import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import {
            BorrowerId,
            AuthorizedContactId,
            CompanyId,
            DocumentId,
            EscrowCompanyId,
            LoanChatMessage as TLoanChatMessage,
            LoanChatMessageId,
            LoanChatSender as TLoanChatSender,
            LoanId,
            LosId,
            PaymentDueId,
            PaymentId,
            PortalUserId,
            PropertyId,
            UsioAccountId,
            RepayAccountId,
            GqlIsoDate as TGqlIsoDate,
            GqlIsoDateTime as TGqlIsoDateTime,
            LoanOwnerId,
            Weekday as TWeekday,
            Timezone as TTimezone,
            Temporal,
            OriginationData as TOriginationData,
          } from '@willow/types-iso';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EnumResolverSignature<T, AllowedValues = any> = { [key in keyof T]?: AllowedValues };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AchBatchId: { input: any; output: any; }
  AchBatchScheduleId: { input: any; output: any; }
  AchBatchTransactionId: { input: any; output: any; }
  ApiKeyId: { input: any; output: any; }
  AppraisalId: { input: any; output: any; }
  AuditLogId: { input: any; output: any; }
  AuthorizedContactId: { input: AuthorizedContactId; output: AuthorizedContactId; }
  BankruptcyId: { input: any; output: any; }
  BankruptcyProofOfClaimId: { input: any; output: any; }
  BannerMessageId: { input: any; output: any; }
  BorrowerAchAccountId: { input: any; output: any; }
  BorrowerId: { input: BorrowerId; output: BorrowerId; }
  ColumnEnumMappingId: { input: any; output: any; }
  ColumnMappingId: { input: any; output: any; }
  CompanyAchAccountId: { input: any; output: any; }
  CompanyId: { input: CompanyId; output: CompanyId; }
  CompanyInterestOnEscrowSettingId: { input: any; output: any; }
  CompanyWireSettingsId: { input: any; output: any; }
  CustodialAccountBalanceId: { input: any; output: any; }
  CustodialAccountId: { input: any; output: any; }
  CustomCompanyFieldId: { input: any; output: any; }
  CustomFAQItemId: { input: any; output: any; }
  CustomFAQSectionId: { input: any; output: any; }
  CustomTemplateId: { input: any; output: any; }
  DelinquentInterestSettingId: { input: any; output: any; }
  DisbursementId: { input: any; output: any; }
  DocumentId: { input: DocumentId; output: DocumentId; }
  DrawId: { input: any; output: any; }
  EntityId: { input: any; output: any; }
  EscrowCompanyId: { input: EscrowCompanyId; output: EscrowCompanyId; }
  EscrowDueId: { input: any; output: any; }
  EscrowPaymentHistoryItemId: { input: any; output: any; }
  EscrowSettingId: { input: any; output: any; }
  ExternalEntityId: { input: any; output: any; }
  FeeId: { input: any; output: any; }
  FeeLineItemId: { input: any; output: any; }
  FileImportId: { input: any; output: any; }
  ForeclosureId: { input: any; output: any; }
  GqlDate: { input: any; output: any; }
  GqlIsoDate: { input: TGqlIsoDate; output: TGqlIsoDate; }
  GqlIsoDateTime: { input: TGqlIsoDateTime; output: TGqlIsoDateTime; }
  GqlTemporalInstant: { input: Temporal.Instant; output: Temporal.Instant; }
  GqlTemporalPlainTime: { input: Temporal.PlainTime; output: Temporal.PlainTime; }
  GqlTimestamp: { input: any; output: any; }
  HistoricalTransactionId: { input: any; output: any; }
  InspectionId: { input: any; output: any; }
  InvestorId: { input: any; output: any; }
  InvestorReportingId: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LiquidationId: { input: any; output: any; }
  LoanChatMessageId: { input: LoanChatMessageId; output: LoanChatMessageId; }
  LoanId: { input: LoanId; output: LoanId; }
  LoanNoteId: { input: any; output: any; }
  LoanOwnerId: { input: LoanOwnerId; output: LoanOwnerId; }
  LosId: { input: LosId; output: LosId; }
  MERSMIN: { input: any; output: any; }
  MERSOrgId: { input: any; output: any; }
  NonPerformanceCodeForReportingCycleId: { input: any; output: any; }
  PageSizeInt: { input: number; output: number; }
  PayeeId: { input: any; output: any; }
  PaymentBreakdownId: { input: any; output: any; }
  PaymentConfigId: { input: any; output: any; }
  PaymentDueId: { input: PaymentDueId; output: PaymentDueId; }
  PaymentId: { input: PaymentId; output: PaymentId; }
  PayoffId: { input: any; output: any; }
  PoolId: { input: any; output: any; }
  PortalUserId: { input: PortalUserId; output: PortalUserId; }
  PrincipalModificationId: { input: any; output: any; }
  PropertyId: { input: PropertyId; output: PropertyId; }
  QcDocumentId: { input: any; output: any; }
  QrpcId: { input: any; output: any; }
  RepayAccountId: { input: RepayAccountId; output: RepayAccountId; }
  ReportableEventId: { input: any; output: any; }
  SftpKeyId: { input: any; output: any; }
  SftpSiteId: { input: any; output: any; }
  TaskAuditLogId: { input: any; output: any; }
  UserId: { input: any; output: any; }
  UsioAccountId: { input: UsioAccountId; output: UsioAccountId; }
  WorkoutPlanId: { input: any; output: any; }
  WriteoffId: { input: any; output: any; }
};

export type AccessTokenResponse = {
  __typename?: 'AccessTokenResponse';
  accessToken: Scalars['String']['output'];
};

export type Actor = {
  __typename?: 'Actor';
  id: Scalars['String']['output'];
  type: ActorType;
};

export enum ActorType {
  Api = 'api',
  Borrower = 'borrower',
  Internal = 'internal',
  User = 'user'
}

export type Address = {
  __typename?: 'Address';
  country: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  line4?: Maybe<Scalars['String']['output']>;
  locality: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type AddressInput = {
  country: Scalars['String']['input'];
  county?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  line4?: InputMaybe<Scalars['String']['input']>;
  locality: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type Advance = {
  __typename?: 'Advance';
  advanceConfig?: Maybe<AdvanceConfig>;
  advanceInterest: Scalars['Float']['output'];
  advanceInterestUpdatedAt?: Maybe<Scalars['GqlDate']['output']>;
  advancePrincipal: Scalars['Float']['output'];
  amountRemaining: Scalars['Float']['output'];
  chargeDate: Scalars['GqlDate']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['GqlIsoDateTime']['output']>;
  dWorkoutPlan?: Maybe<ChargeWorkoutPlan>;
  id: Scalars['FeeId']['output'];
  investorRemittanceSplit?: Maybe<InvestorRemittanceSplit>;
  isDeferred: Scalars['Boolean']['output'];
  isPrePetition?: Maybe<Scalars['Boolean']['output']>;
  originalPrincipal?: Maybe<Scalars['Float']['output']>;
  payeeId?: Maybe<Scalars['PayeeId']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  status: FeeStatus;
  totalAmount: Scalars['Float']['output'];
  type?: Maybe<ChargeType>;
  updatedAt?: Maybe<Scalars['GqlDate']['output']>;
};

export type AdvanceBreakdown = PaymentToPaymentDue & {
  __typename?: 'AdvanceBreakdown';
  advance: Scalars['Float']['output'];
  advanceInterest: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  feeId: Scalars['FeeId']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  paymentId: Scalars['PaymentId']['output'];
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export enum AdvanceCategory {
  AgentFee = 'AGENT_FEE',
  AppraisalCost = 'APPRAISAL_COST',
  AttorneyFee = 'ATTORNEY_FEE',
  Bankruptcy = 'BANKRUPTCY',
  BrokerPriceOpinionCost = 'BROKER_PRICE_OPINION_COST',
  ForcePlacedInsurance = 'FORCE_PLACED_INSURANCE',
  Foreclosure = 'FORECLOSURE',
  Other = 'OTHER',
  PropertyInspectionCost = 'PROPERTY_INSPECTION_COST',
  PropertyPreservation = 'PROPERTY_PRESERVATION',
  ProtectiveAdvance = 'PROTECTIVE_ADVANCE',
  Taxes = 'TAXES',
  TitleSearch = 'TITLE_SEARCH'
}

export type AdvanceConfig = EscrowAdvanceConfig | StandardAdvanceConfig;

export enum AdvanceType {
  Corporate = 'CORPORATE',
  Escrow = 'ESCROW'
}

export enum AmortizationType {
  Arm = 'arm',
  Fixed = 'fixed'
}

export type Appraisal = {
  __typename?: 'Appraisal';
  amount: Scalars['Float']['output'];
  appraisalMethod: AppraisalMethod;
  appraisalType: AppraisalType;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  date: Scalars['GqlIsoDate']['output'];
  id: Scalars['AppraisalId']['output'];
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['PropertyId']['output'];
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export enum AppraisalMethod {
  AutomatedValuationModel = 'AUTOMATED_VALUATION_MODEL',
  DesktopAppraisal = 'DESKTOP_APPRAISAL',
  DeskReview = 'DESK_REVIEW',
  DriveBy = 'DRIVE_BY',
  FieldReview = 'FIELD_REVIEW',
  FullAppraisal = 'FULL_APPRAISAL',
  HybridAppraisal = 'HYBRID_APPRAISAL',
  None = 'NONE',
  Other = 'OTHER',
  PriorAppraisalUsed = 'PRIOR_APPRAISAL_USED'
}

export enum AppraisalType {
  Appraisal = 'APPRAISAL',
  Bpo = 'BPO'
}

export type ArmConfiguration = {
  __typename?: 'ArmConfiguration';
  adjustmentLeadCountDays?: Maybe<Scalars['Int']['output']>;
  armFirstRateChangeDate?: Maybe<Scalars['GqlDate']['output']>;
  armIndex?: Maybe<IndexRateType>;
  margin?: Maybe<Scalars['Float']['output']>;
  maxIncreaseForFirstPeriod?: Maybe<Scalars['Float']['output']>;
  maxIncreasePerPeriod?: Maybe<Scalars['Float']['output']>;
  minIncreaseForFirstPeriod?: Maybe<Scalars['Float']['output']>;
  minIncreasePerPeriod?: Maybe<Scalars['Float']['output']>;
  rateAdjustmentFrequency?: Maybe<Scalars['Int']['output']>;
  rateCeiling?: Maybe<Scalars['Float']['output']>;
  rateFloor?: Maybe<Scalars['Float']['output']>;
  roundingPercent?: Maybe<Scalars['Float']['output']>;
  roundingType?: Maybe<ArmRoundingType>;
};

export enum ArmRoundingType {
  Down = 'DOWN',
  Nearest = 'NEAREST',
  Up = 'UP'
}

export type Attribution = {
  dailyInterestRate: Scalars['Float']['output'];
  days: Scalars['Int']['output'];
  endOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  interest: Scalars['Float']['output'];
  isDeferred?: Maybe<Scalars['Boolean']['output']>;
  isWaived?: Maybe<Scalars['Boolean']['output']>;
  periodInterestRate?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  startOfPeriodPrincipal: Scalars['Float']['output'];
  type: AttributionType;
};

export enum AttributionType {
  DelinquentInterest = 'DELINQUENT_INTEREST',
  DrawInterest = 'DRAW_INTEREST',
  PartialPayoffInterest = 'PARTIAL_PAYOFF_INTEREST',
  StantardInterest = 'STANTARD_INTEREST'
}

export type AuthorizedContact = {
  id: Scalars['AuthorizedContactId']['output'];
  type: AuthorizedContactType;
};

export type AuthorizedContactPayer = {
  __typename?: 'AuthorizedContactPayer';
  authorizedContactId: Scalars['AuthorizedContactId']['output'];
  type: Scalars['String']['output'];
};

export enum AuthorizedContactType {
  Attorney = 'ATTORNEY',
  Builder = 'BUILDER',
  Guarantor = 'GUARANTOR',
  NonBorrowingSpouse = 'NON_BORROWING_SPOUSE',
  Other = 'OTHER',
  Title = 'TITLE'
}

export type AutopaySettings = DwollaAutopaySettings | NachaAutopaySettings | RepayAutopaySettings | UsioAutopaySettings;

export type AutopaySettingsInput = {
  bankUrl: Scalars['String']['input'];
  portalUserId: Scalars['PortalUserId']['input'];
};

export enum AutopaySettingsType {
  Dwolla = 'dwolla',
  Nacha = 'nacha',
  Repay = 'repay',
  Usio = 'usio'
}

export type BalanceReallocationBreakdown = PaymentToPaymentDue & {
  __typename?: 'BalanceReallocationBreakdown';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  escrow: Scalars['Float']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  futureStatementSuspense: Scalars['Float']['output'];
  holdback: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  lossDraft: Scalars['Float']['output'];
  paymentId: Scalars['PaymentId']['output'];
  principal: Scalars['Float']['output'];
  suspense?: Maybe<Scalars['Float']['output']>;
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type Balances = {
  __typename?: 'Balances';
  escrowBalance: Scalars['Float']['output'];
  holdbackBalance?: Maybe<Scalars['Float']['output']>;
  lossDraftBalance?: Maybe<Scalars['Float']['output']>;
  principalPrepaymentBalance: Scalars['Float']['output'];
  reserveBalance?: Maybe<Scalars['Float']['output']>;
  suspenseBalance: Scalars['Float']['output'];
};

export type BalloonConfiguration = {
  __typename?: 'BalloonConfiguration';
  amortizationTerm: Scalars['Int']['output'];
};

export enum BankruptcyCh13PaymentConfigChangeReason {
  AmountDecrease = 'AMOUNT_DECREASE',
  AmountIncrease = 'AMOUNT_INCREASE',
  LengthDecrease = 'LENGTH_DECREASE',
  LengthIncrease = 'LENGTH_INCREASE'
}

export type BankruptcyCh13PrePetition = {
  __typename?: 'BankruptcyCh13PrePetition';
  arrearages: BankruptcyCh13PrePetitionArrearages;
  paymentConfigHistory: Array<BankruptcyCh13PrePetitionPaymentConfig>;
  planPaymentsDue: Array<WorkoutPlanPaymentDue>;
};

export type BankruptcyCh13PrePetitionArrearages = {
  __typename?: 'BankruptcyCh13PrePetitionArrearages';
  chargeIds: Array<Scalars['FeeId']['output']>;
  paymentDueIds: Array<Scalars['PaymentDueId']['output']>;
};

export type BankruptcyCh13PrePetitionPaymentConfig = {
  __typename?: 'BankruptcyCh13PrePetitionPaymentConfig';
  changeReason?: Maybe<BankruptcyCh13PaymentConfigChangeReason>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  effectiveDate: Scalars['GqlIsoDate']['output'];
  monthlyPaymentAmount: Scalars['Float']['output'];
  numberOfMonthsRemaining: Scalars['Int']['output'];
  payer: BankruptcyPaymentPayer;
};

export type BankruptcyCh13WorkoutPlan = WorkoutPlan & {
  __typename?: 'BankruptcyCh13WorkoutPlan';
  bankruptcyId: Scalars['BankruptcyId']['output'];
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  confirmationDate: Scalars['GqlIsoDate']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['WorkoutPlanId']['output'];
  initialContractualLPIDate: Scalars['GqlIsoDate']['output'];
  postPetitionSplitEffectiveDate: Scalars['GqlIsoDate']['output'];
  prePetition?: Maybe<BankruptcyCh13PrePetition>;
  startDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export enum BankruptcyPaymentPayer {
  Borrower = 'BORROWER',
  Trustee = 'TRUSTEE'
}

export type BannerMessage = {
  __typename?: 'BannerMessage';
  createdAt: Scalars['GqlIsoDateTime']['output'];
  id: Scalars['BannerMessageId']['output'];
  isActive: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export enum BillingStatus {
  Future = 'future',
  Past = 'past',
  Upcoming = 'upcoming'
}

export type Borrower = {
  __typename?: 'Borrower';
  achAccounts: Array<BorrowerAchAccount>;
  companyId: Scalars['CompanyId']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailConsent: Scalars['Boolean']['output'];
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['BorrowerId']['output'];
  lastName: Scalars['String']['output'];
  mailingAddress?: Maybe<Address>;
  middleName?: Maybe<Scalars['String']['output']>;
  paperNotificationsEnabled: Scalars['Boolean']['output'];
  phoneConsent: Scalars['Boolean']['output'];
  phoneNumbers: Phone;
  preferredContactTimes: Array<DayAndTimeRange>;
  repayAccounts: Array<RepayAccount>;
  suffix?: Maybe<Scalars['String']['output']>;
  usioAccounts: Array<UsioAccount>;
};

export type BorrowerAchAccount = {
  __typename?: 'BorrowerAchAccount';
  accountName: Scalars['String']['output'];
  addedByCompany: Scalars['Boolean']['output'];
  createdAt: Scalars['GqlTimestamp']['output'];
  disabledAt?: Maybe<Scalars['GqlTimestamp']['output']>;
  id: Scalars['BorrowerAchAccountId']['output'];
  lastFour: Scalars['String']['output'];
  prenoteSubmittedAt?: Maybe<Scalars['GqlTimestamp']['output']>;
};

export type BorrowerEditInput = {
  mailingAddress?: InputMaybe<AddressInput>;
  phoneCell?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  preferredContactTimes?: InputMaybe<Array<DayAndTimeRangeInput>>;
};

export enum BorrowerMessageKey {
  MailingAddressConfirmedAt = 'mailingAddressConfirmedAt'
}

export type BorrowerMessageViews = {
  __typename?: 'BorrowerMessageViews';
  mailingAddressConfirmedAt?: Maybe<Scalars['GqlIsoDateTime']['output']>;
};

export type BorrowerNotificationSettingsForAllCompaniesInput = {
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  paperNotificationsEnabled: Scalars['Boolean']['input'];
};

export type BorrowerNotificationSettingsInput = {
  companyId: Scalars['CompanyId']['input'];
  emailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paperNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BorrowerPayer = {
  __typename?: 'BorrowerPayer';
  borrowerId: Scalars['BorrowerId']['output'];
  type: Scalars['String']['output'];
};

export type BorrowerPaymentSettings = {
  __typename?: 'BorrowerPaymentSettings';
  allowPaymentsPastMaturity: Scalars['Boolean']['output'];
};

export type BorrowerRequestSettings = {
  __typename?: 'BorrowerRequestSettings';
  drawRequestEnabled: Scalars['Boolean']['output'];
  escrowWaiverRequestEnabled: Scalars['Boolean']['output'];
  generalInquiryEnabled: Scalars['Boolean']['output'];
  paymentAssistanceInquiryEnabled: Scalars['Boolean']['output'];
  payoffRequestEnabled: Scalars['Boolean']['output'];
  pmiCancellationRequestEnabled: Scalars['Boolean']['output'];
  verificationOfMortgageEnabled: Scalars['Boolean']['output'];
};

export type BuilderAuthorizedContact = AuthorizedContact & {
  __typename?: 'BuilderAuthorizedContact';
  companyName: Scalars['String']['output'];
  id: Scalars['AuthorizedContactId']['output'];
  type: AuthorizedContactType;
};

export type CancelPaymentDeferralWorkoutPlanInput = {
  isDraftPlan: Scalars['Boolean']['input'];
  reason: PaymentDeferralCancellationReason;
  terminationDate: Scalars['GqlIsoDate']['input'];
  workoutPlanId: Scalars['WorkoutPlanId']['input'];
};

export type CancelRepaymentWorkoutPlanInput = {
  reason: RepaymentPlanCancellationReason;
  terminationDate: Scalars['GqlIsoDate']['input'];
  workoutPlanId: Scalars['WorkoutPlanId']['input'];
};

export type Charge = Advance | Fee;

export enum ChargeType {
  Advance = 'ADVANCE',
  Fee = 'FEE'
}

export type ChargeWorkoutPlan = {
  __typename?: 'ChargeWorkoutPlan';
  id: Scalars['WorkoutPlanId']['output'];
  type: WorkoutPlanType;
};

export type ChatBotResponse = {
  __typename?: 'ChatBotResponse';
  message: Scalars['String']['output'];
};

export enum CitizenshipStatus {
  Asylee = 'ASYLEE',
  ConditionalPermanentResident = 'CONDITIONAL_PERMANENT_RESIDENT',
  LawfulPermanentResident = 'LAWFUL_PERMANENT_RESIDENT',
  Refugee = 'REFUGEE',
  Unknown = 'UNKNOWN',
  UsCitizen = 'US_CITIZEN',
  UsNational = 'US_NATIONAL'
}

export enum CompanyApplyDefaultInterestOnPastDueType {
  EndOfGrace = 'END_OF_GRACE',
  FirstOfMissedCycle = 'FIRST_OF_MISSED_CYCLE',
  FirstOfMissedCycleOnFirstOfNextCycle = 'FIRST_OF_MISSED_CYCLE_ON_FIRST_OF_NEXT_CYCLE'
}

export type CompanyLogos = {
  __typename?: 'CompanyLogos';
  emailLogoUrl?: Maybe<Scalars['String']['output']>;
  portalLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyWireSettings = {
  __typename?: 'CompanyWireSettings';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bankAddress: Address;
  bankName: Scalars['String']['output'];
  bankRoutingNumber: Scalars['String']['output'];
  id: Scalars['CompanyWireSettingsId']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  ownerIds: Array<Scalars['LoanOwnerId']['output']>;
};

export type Configuration = {
  __typename?: 'Configuration';
  acquisitionDate?: Maybe<Scalars['GqlDate']['output']>;
  amortizationType: AmortizationType;
  annualInterestRate: Scalars['Float']['output'];
  armConfiguration?: Maybe<ArmConfiguration>;
  balloonConfiguration?: Maybe<BalloonConfiguration>;
  brokerName?: Maybe<Scalars['String']['output']>;
  buydownType?: Maybe<Scalars['String']['output']>;
  completionCertFlag?: Maybe<Scalars['Boolean']['output']>;
  completionCertNotes?: Maybe<Scalars['String']['output']>;
  constructionLoanType?: Maybe<ConstructionLoanType>;
  delinquentInterestRate?: Maybe<Scalars['Float']['output']>;
  delinquentInterestRemittanceSplit?: Maybe<InvestorRemittanceSplit>;
  drawsEnabled: Scalars['Boolean']['output'];
  escrowed: Scalars['Boolean']['output'];
  fees?: Maybe<LoanFees>;
  firstCollectedPaymentDate: Scalars['GqlDate']['output'];
  firstDueDate: Scalars['GqlDate']['output'];
  fundingChannel?: Maybe<Scalars['String']['output']>;
  fundingDate: Scalars['GqlDate']['output'];
  gracePeriod?: Maybe<Scalars['Int']['output']>;
  hasInterestReserve: Scalars['Boolean']['output'];
  incomingTransferEffectiveDate?: Maybe<Scalars['GqlDate']['output']>;
  initialDiscountPointsAmount?: Maybe<Scalars['Float']['output']>;
  initialMaturityDate?: Maybe<Scalars['GqlDate']['output']>;
  interestOnlyConfiguration?: Maybe<InterestOnlyConfiguration>;
  interestRate: Scalars['Float']['output'];
  investor?: Maybe<LoanInvestor>;
  investorOrgId?: Maybe<Scalars['String']['output']>;
  isAssumable?: Maybe<Scalars['Boolean']['output']>;
  isBalloon: Scalars['Boolean']['output'];
  isDrawableLoanType: Scalars['Boolean']['output'];
  isDutch: Scalars['Boolean']['output'];
  isInterestOnly: Scalars['Boolean']['output'];
  legalDescription?: Maybe<Scalars['String']['output']>;
  lienPosition?: Maybe<Scalars['Int']['output']>;
  loanClosingDate?: Maybe<Scalars['GqlDate']['output']>;
  loanTerm: Scalars['Int']['output'];
  maxLineOfCredit: Scalars['Float']['output'];
  noteDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  numberOfProperties?: Maybe<Scalars['Int']['output']>;
  occupancyType?: Maybe<OccupancyType>;
  originalAmortizationType: AmortizationType;
  originalNoteHolder?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<Scalars['Int']['output']>;
  ppc1OrgId?: Maybe<Scalars['String']['output']>;
  previousLoanOwner?: Maybe<Scalars['String']['output']>;
  previousServicer?: Maybe<PreviousServicer>;
  productType?: Maybe<ProductType>;
  purpose?: Maybe<LoanPurpose>;
  qualifiedMortgage?: Maybe<Scalars['Boolean']['output']>;
  servicerOrgId?: Maybe<Scalars['String']['output']>;
  subServicerOrgId?: Maybe<Scalars['String']['output']>;
  taxDetails?: Maybe<TaxDetails>;
};

export type ConstructionConfig = {
  __typename?: 'ConstructionConfig';
  constructionModificationEffectiveDate?: Maybe<Scalars['GqlDate']['output']>;
  constructionToPermanentStatus: ConstructionToPermanentStatus;
};

export enum ConstructionLoanType {
  ConstructionOnly = 'constructionOnly',
  ConstructionToPermanent = 'constructionToPermanent'
}

export enum ConstructionToPermanentStatus {
  Active = 'active',
  Permanent = 'permanent'
}

export type CreateBankruptcyCh13WorkoutPlanInput = {
  bankruptcyId: Scalars['BankruptcyId']['input'];
  confirmationDate: Scalars['GqlIsoDate']['input'];
  postPetitionSplitEffectiveDate: Scalars['GqlIsoDate']['input'];
  prePetitionEffectiveDate: Scalars['GqlIsoDate']['input'];
  prePetitionMonthlyPaymentAmount: Scalars['Float']['input'];
  prePetitionNumberOfMonths: Scalars['Int']['input'];
  prePetitionPayer: BankruptcyPaymentPayer;
};

export type CreateBorrowerAchAccountInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  borrowerId: Scalars['BorrowerId']['input'];
  isCorporateAccount?: InputMaybe<Scalars['Boolean']['input']>;
  routingNumber: Scalars['String']['input'];
};

export type CreateFlexModificationWorkoutPlanInput = {
  adjustedOutstandingBalance: Scalars['Float']['input'];
  completedBorrowerResponsePackageReceived: Scalars['Boolean']['input'];
  deferredPrincipalAmount: Scalars['Float']['input'];
  disasterHardshipReason: Scalars['Boolean']['input'];
  evaluationNoticeSentDate: Scalars['GqlIsoDate']['input'];
  ineligibleModifications: Array<WorkoutPlanIneligibleModificationInput>;
  interestRate: Scalars['Float']['input'];
  loanTermMonths: Scalars['Int']['input'];
  monthlyEscrowAmount: Scalars['Float']['input'];
  quotedTrialPITI: Scalars['Float']['input'];
  trialStartDate: Scalars['GqlIsoDate']['input'];
  trialTermMonths: Scalars['Int']['input'];
};

export type CreateForbearanceWorkoutPlanInput = {
  completedBorrowerResponsePackageReceived: Scalars['Boolean']['input'];
  imminentDefault: Scalars['Boolean']['input'];
  ineligibleModifications: Array<WorkoutPlanIneligibleModificationInput>;
  programMoratoriumStartDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  reducedPaymentAmount: Scalars['Float']['input'];
  startDate: Scalars['GqlIsoDate']['input'];
  subType: ForbearanceSubType;
  termMonths: Scalars['Int']['input'];
  type: ForbearanceType;
};

export type CreatePaymentDeferralWorkoutPlanInput = {
  acceptanceMethod: PaymentDeferralAcceptanceMethod;
  acceptanceMethodOther?: InputMaybe<Scalars['String']['input']>;
  chargeIds: Array<Scalars['FeeId']['input']>;
  endStatementDate: Scalars['GqlIsoDate']['input'];
  escrowAnalysisId?: InputMaybe<Scalars['QcDocumentId']['input']>;
  expirationDate: Scalars['GqlIsoDate']['input'];
  paymentDueIds: Array<Scalars['PaymentDueId']['input']>;
  quotedDeferredBalances: PaymentDeferralQuotedDeferredBalancesInput;
  reason: PaymentDeferralReason;
  sendAgreementTo: Array<Scalars['BorrowerId']['input']>;
  startStatementDate: Scalars['GqlIsoDate']['input'];
};

export type CreatePortalBorrowerAchAccountInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type CreatePrincipalModificationInput = {
  amount: Scalars['Float']['input'];
  collectionType: PrincipalModificationCollectionType;
  effectiveDate: Scalars['GqlIsoDate']['input'];
  isFederalGovernmentPlan: Scalars['Boolean']['input'];
  isRecast: Scalars['Boolean']['input'];
};

export type CreateRepayAccountInput = {
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  isCorporateAccount?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type CreateRepaymentWorkoutPlanInput = {
  completedBorrowerResponsePackageReceived: Scalars['Boolean']['input'];
  endStatementDate: Scalars['GqlIsoDate']['input'];
  hasFees: Scalars['Boolean']['input'];
  ineligibleModifications: Array<WorkoutPlanIneligibleModificationInput>;
  quotedArrearageBilledPerStatement: Scalars['Float']['input'];
  quotedArrearageTotal: Scalars['Float']['input'];
  quotedContractualMonthlyPaymentAmount: Scalars['Float']['input'];
  quotedPlanIncrease: Scalars['Float']['input'];
  quotedPlanMonthlyPaymentAmount: Scalars['Float']['input'];
  sendAgreementTo: Array<Scalars['BorrowerId']['input']>;
  startDate: Scalars['GqlIsoDate']['input'];
  startStatementDate: Scalars['GqlIsoDate']['input'];
  termMonths: Scalars['Int']['input'];
};

export type CurrentPaymentConfig = {
  __typename?: 'CurrentPaymentConfig';
  effectiveDate: Scalars['GqlIsoDate']['output'];
  monthlyEscrowPayment: Scalars['Float']['output'];
  monthlyInterestRate: Scalars['Float']['output'];
  monthlyPrincipalAndInterestTotal: Scalars['Float']['output'];
};

export type CustomFaqItem = {
  __typename?: 'CustomFAQItem';
  answer: Scalars['String']['output'];
  id: Scalars['CustomFAQItemId']['output'];
  question: Scalars['String']['output'];
};

export type CustomFaqSection = {
  __typename?: 'CustomFAQSection';
  id: Scalars['CustomFAQSectionId']['output'];
  items: Array<CustomFaqItem>;
  title: Scalars['String']['output'];
};

export type DayAndTimeRange = {
  __typename?: 'DayAndTimeRange';
  endDay: Weekday;
  endTime: Scalars['Float']['output'];
  startDay: Weekday;
  startTime: Scalars['Float']['output'];
  timezone: Timezone;
};

export type DayAndTimeRangeInput = {
  endDay: Weekday;
  endTime: Scalars['Float']['input'];
  startDay: Weekday;
  startTime: Scalars['Float']['input'];
  timezone: Timezone;
};

export type DefermentWorkoutPlan = WorkoutPlan & {
  __typename?: 'DefermentWorkoutPlan';
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  chargeIds: Array<Scalars['FeeId']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  escrowAmount: Scalars['Float']['output'];
  feeAmount: Scalars['Float']['output'];
  hasEscrow: Scalars['Boolean']['output'];
  hasFees: Scalars['Boolean']['output'];
  hasPrincipalAndInterest: Scalars['Boolean']['output'];
  id: Scalars['WorkoutPlanId']['output'];
  interestAmount: Scalars['Float']['output'];
  paymentDueIds: Array<Scalars['PaymentDueId']['output']>;
  principalAmount: Scalars['Float']['output'];
  reason?: Maybe<WorkoutPlanReason>;
  startDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  totalAmount: Scalars['Float']['output'];
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export type DefermentWorkoutPlanDocument = Document & {
  __typename?: 'DefermentWorkoutPlanDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  workoutPlanId: Scalars['WorkoutPlanId']['output'];
};

export type DelinquentInterestAppliedDocument = Document & {
  __typename?: 'DelinquentInterestAppliedDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  delinquentInterestSettingId?: Maybe<Scalars['DelinquentInterestSettingId']['output']>;
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  paymentConfigId?: Maybe<Scalars['PaymentConfigId']['output']>;
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DelinquentInterestAttribution = Attribution & {
  __typename?: 'DelinquentInterestAttribution';
  dailyInterestRate: Scalars['Float']['output'];
  days: Scalars['Int']['output'];
  delinquentInterestSettingId?: Maybe<Scalars['DelinquentInterestSettingId']['output']>;
  endOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  interest: Scalars['Float']['output'];
  isDeferred?: Maybe<Scalars['Boolean']['output']>;
  isWaived?: Maybe<Scalars['Boolean']['output']>;
  periodInterestRate?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  startOfPeriodPrincipal: Scalars['Float']['output'];
  type: AttributionType;
};

export type DelinquentInterestSetting = {
  __typename?: 'DelinquentInterestSetting';
  createdAt: Scalars['GqlDate']['output'];
  endDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  id: Scalars['DelinquentInterestSettingId']['output'];
  interestRate: Scalars['Float']['output'];
  investorRemittanceSplit?: Maybe<InvestorRemittanceSplit>;
  isDeferred: Scalars['Boolean']['output'];
  isWaived: Scalars['Boolean']['output'];
  startDate: Scalars['GqlIsoDate']['output'];
  updatedAt: Scalars['GqlDate']['output'];
};

export type DirectoryPayee = {
  __typename?: 'DirectoryPayee';
  address?: Maybe<Address>;
  companyId: Scalars['CompanyId']['output'];
  createdAt: Scalars['GqlTimestamp']['output'];
  deletedAt?: Maybe<Scalars['GqlTimestamp']['output']>;
  dueDates: Array<Scalars['String']['output']>;
  externalPayeeId: Scalars['String']['output'];
  id: Scalars['PayeeId']['output'];
  isActive: Scalars['Boolean']['output'];
  loanUsageCount?: Maybe<Scalars['Int']['output']>;
  miCompanyCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payeeType: PayeeType;
  paymentMethod: PayeePaymentMethod;
  phone?: Maybe<Scalars['String']['output']>;
  taxOption?: Maybe<Scalars['Int']['output']>;
  taxType?: Maybe<PayeeTaxType>;
  updatedAt: Scalars['GqlTimestamp']['output'];
};

export type Disbursement = {
  __typename?: 'Disbursement';
  amounts: DisbursementAmounts;
  borrowerId?: Maybe<Scalars['BorrowerId']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['GqlDate']['output'];
  escrowDueId?: Maybe<Scalars['EscrowDueId']['output']>;
  id: Scalars['DisbursementId']['output'];
  isReversal: Scalars['Boolean']['output'];
  loanId: Scalars['LoanId']['output'];
  payeeId?: Maybe<Scalars['PayeeId']['output']>;
  paymentMethod?: Maybe<PayeePaymentMethod>;
  recipient: Scalars['String']['output'];
  status: DisbursementStatus;
  total: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  type: DisbursementType;
};

export type DisbursementAmounts = {
  __typename?: 'DisbursementAmounts';
  escrow: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  futureStatementSuspense: Scalars['Float']['output'];
  holdback: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  lossDraft: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
  principalPrepayment: Scalars['Float']['output'];
  reserve: Scalars['Float']['output'];
  suspense: Scalars['Float']['output'];
  unappliedSuspense: Scalars['Float']['output'];
};

export enum DisbursementStatus {
  Processed = 'PROCESSED'
}

export enum DisbursementType {
  Advance = 'advance',
  Escrow = 'escrow',
  ForwardPayment = 'forwardPayment',
  PaymentAfterPayoff = 'paymentAfterPayoff',
  Payoff = 'payoff',
  ServicingTransfer = 'servicingTransfer'
}

export type Document = {
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum DocumentType {
  BorrowerUpload = 'BORROWER_UPLOAD',
  DefermentWorkoutPlan = 'DEFERMENT_WORKOUT_PLAN',
  DelinquentInterestApplied = 'DELINQUENT_INTEREST_APPLIED',
  EscrowAnalysis = 'ESCROW_ANALYSIS',
  FlexModCancellationNotice = 'FLEX_MOD_CANCELLATION_NOTICE',
  ForbearanceWorkoutPlanCompleted = 'FORBEARANCE_WORKOUT_PLAN_COMPLETED',
  ForbearanceWorkoutPlanEarlyTerminationNotice = 'FORBEARANCE_WORKOUT_PLAN_EARLY_TERMINATION_NOTICE',
  Form1098 = 'FORM1098',
  Goodbye = 'GOODBYE',
  InterestRateAdjustmentNotification = 'INTEREST_RATE_ADJUSTMENT_NOTIFICATION',
  LenderUpload = 'LENDER_UPLOAD',
  LoanExtensionAgreement = 'LOAN_EXTENSION_AGREEMENT',
  LoanExtensionFees = 'LOAN_EXTENSION_FEES',
  MortgageInsuranceCancellationNotice = 'MORTGAGE_INSURANCE_CANCELLATION_NOTICE',
  MortgageProofOfClaim = 'MORTGAGE_PROOF_OF_CLAIM',
  PaidInFull = 'PAID_IN_FULL',
  PartialPayoffConfirmation = 'PARTIAL_PAYOFF_CONFIRMATION',
  PaymentDeferralCancellationNotice = 'PAYMENT_DEFERRAL_CANCELLATION_NOTICE',
  PaymentDeferralOfferLetter = 'PAYMENT_DEFERRAL_OFFER_LETTER',
  Payoff = 'PAYOFF',
  PreActiveWelcome = 'PRE_ACTIVE_WELCOME',
  PrincipalModificationApplied = 'PRINCIPAL_MODIFICATION_APPLIED',
  PrincipalModificationCancelled = 'PRINCIPAL_MODIFICATION_CANCELLED',
  RepaymentPlanCancellationNotice = 'REPAYMENT_PLAN_CANCELLATION_NOTICE',
  RepaymentPlanOfferNotice = 'REPAYMENT_PLAN_OFFER_NOTICE',
  VerificationOfMortgage = 'VERIFICATION_OF_MORTGAGE'
}

export type DownloadUrlResponse = {
  __typename?: 'DownloadUrlResponse';
  url: Scalars['String']['output'];
};

export type DrawInterestAttribution = Attribution & {
  __typename?: 'DrawInterestAttribution';
  dailyInterestRate: Scalars['Float']['output'];
  days: Scalars['Int']['output'];
  drawId: Scalars['DrawId']['output'];
  endOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  interest: Scalars['Float']['output'];
  isDeferred?: Maybe<Scalars['Boolean']['output']>;
  isWaived?: Maybe<Scalars['Boolean']['output']>;
  periodInterestRate?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  startOfPeriodPrincipal: Scalars['Float']['output'];
  type: AttributionType;
};

export type DwollaAutopaySettings = {
  __typename?: 'DwollaAutopaySettings';
  actor?: Maybe<Actor>;
  bankUrl: Scalars['String']['output'];
  portalUserId: Scalars['PortalUserId']['output'];
  type: AutopaySettingsType;
};

export type DwollaBank = {
  __typename?: 'DwollaBank';
  isAutopayAuthorized: Scalars['Boolean']['output'];
  links: DwollaUrls;
  name: Scalars['String']['output'];
};

export type DwollaPaymentResponse = {
  __typename?: 'DwollaPaymentResponse';
  transferUrl?: Maybe<Scalars['String']['output']>;
};

export type DwollaUrls = {
  __typename?: 'DwollaUrls';
  self: Scalars['String']['output'];
};

export type Entity = {
  __typename?: 'Entity';
  address?: Maybe<Address>;
  ein: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalEntityId: Scalars['ExternalEntityId']['output'];
  id: Scalars['EntityId']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type EntityPayer = {
  __typename?: 'EntityPayer';
  entityId: Scalars['EntityId']['output'];
  type: Scalars['String']['output'];
};

export type EscrowAdvanceConfig = {
  __typename?: 'EscrowAdvanceConfig';
  advanceType: AdvanceType;
};

export type EscrowAnalysisDocument = Document & {
  __typename?: 'EscrowAnalysisDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  effectiveDate: Scalars['GqlDate']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCorrected: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EscrowDue = {
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['GqlDate']['output']>;
  escrowSettingId: Scalars['EscrowSettingId']['output'];
  escrowed: Scalars['Boolean']['output'];
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['EscrowDueId']['output'];
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  type: EscrowType;
};

export type EscrowDueInput = {
  amountPaid: Scalars['Float']['input'];
  fulfilled: Scalars['Boolean']['input'];
  id: Scalars['EscrowDueId']['input'];
};

export enum EscrowInsuranceType {
  Condo = 'condo',
  Earthquake = 'earthquake',
  Equipment = 'equipment',
  Fire = 'fire',
  Flood = 'flood',
  Hazard = 'hazard',
  Homeowners = 'homeowners',
  Hurricane = 'hurricane',
  Liability = 'liability',
  Other = 'other',
  Rental = 'rental',
  Sewer = 'sewer',
  Sinkhole = 'sinkhole',
  Title = 'title',
  Umbrella = 'umbrella',
  Wildfire = 'wildfire',
  Windstorm = 'windstorm'
}

export type EscrowPaymentHistoryItem = {
  __typename?: 'EscrowPaymentHistoryItem';
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['GqlTimestamp']['output'];
  effectiveDate?: Maybe<Scalars['GqlDate']['output']>;
  id: Scalars['EscrowPaymentHistoryItemId']['output'];
  isCancelled: Scalars['Boolean']['output'];
  newMonthlyAmount: Scalars['Float']['output'];
  newMonthlyAmountIfShortagePaidUpfront?: Maybe<Scalars['Float']['output']>;
  shortageAmount?: Maybe<Scalars['Float']['output']>;
  type: EscrowPaymentHistoryItemType;
};

export enum EscrowPaymentHistoryItemType {
  Analysis = 'ANALYSIS',
  Api = 'API',
  ConstructionToPermanent = 'CONSTRUCTION_TO_PERMANENT',
  Csv = 'CSV',
  Initial = 'INITIAL',
  ManualUpdate = 'MANUAL_UPDATE',
  ShortagePayment = 'SHORTAGE_PAYMENT'
}

export type EscrowSetting = {
  amount: Scalars['Float']['output'];
  escrowed: Scalars['Boolean']['output'];
  id: Scalars['EscrowSettingId']['output'];
  payee: Payee;
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  type: EscrowSettingType;
};

export type EscrowSettingInput = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  agentPhone?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  apn?: InputMaybe<Scalars['String']['input']>;
  cancellationDetails?: InputMaybe<MortgageInsuranceCancellationInput>;
  certificateId?: InputMaybe<Scalars['String']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  coverageAmount?: InputMaybe<Scalars['Float']['input']>;
  coveragePercent?: InputMaybe<Scalars['Float']['input']>;
  dueDates?: InputMaybe<Array<Scalars['String']['input']>>;
  escrowed: Scalars['Boolean']['input'];
  fhaProgramType?: InputMaybe<FhaProgramType>;
  forcedPlacedFlag?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['EscrowSettingId']['input'];
  insuranceName?: InputMaybe<Scalars['String']['input']>;
  insuranceType?: InputMaybe<EscrowInsuranceType>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  midpointDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  mortgageInsuranceType?: InputMaybe<MortgageInsuranceType>;
  payee: LegacyEscrowPayeeInput;
  payeeId?: InputMaybe<Scalars['PayeeId']['input']>;
  paymentCadence?: InputMaybe<PaymentCadence>;
  policyEndDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  policyStartDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  poolCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['PropertyId']['input'];
  renewalType?: InputMaybe<MortgageInsuranceRenewalType>;
  startDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  status: EscrowSettingStatus;
  taxType?: InputMaybe<TaxEscrowType>;
  type: EscrowSettingType;
};

export enum EscrowSettingStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum EscrowSettingType {
  InsuranceEscrowSetting = 'INSURANCE_ESCROW_SETTING',
  MortgageInsuranceEscrowSetting = 'MORTGAGE_INSURANCE_ESCROW_SETTING',
  TaxEscrowSetting = 'TAX_ESCROW_SETTING'
}

export enum EscrowType {
  Insurance = 'INSURANCE',
  MortgageInsurance = 'MORTGAGE_INSURANCE',
  Tax = 'TAX'
}

export enum EscrowWaiverRequestType {
  Insurance = 'INSURANCE',
  Other = 'OTHER',
  Tax = 'TAX'
}

export enum Ethnicity {
  Asian = 'ASIAN',
  Black = 'BLACK',
  Hispanic = 'HISPANIC',
  MiddleEastern = 'MIDDLE_EASTERN',
  MultiRacial = 'MULTI_RACIAL',
  NativeAmerican = 'NATIVE_AMERICAN',
  Other = 'OTHER',
  PacificIslander = 'PACIFIC_ISLANDER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  White = 'WHITE'
}

export type ExpectedPayment = {
  __typename?: 'ExpectedPayment';
  nextPaymentDueDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  paymentDate: Scalars['GqlIsoDate']['output'];
  totalAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalAmountRemainingFromCredit: Scalars['Float']['output'];
  totalFutureAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalUpcomingAmountRemainingFromBorrower: Scalars['Float']['output'];
};

export type ExtendForbearanceWorkoutPlanInput = {
  extensionTermMonths: Scalars['Int']['input'];
  workoutPlanId: Scalars['WorkoutPlanId']['input'];
};

export enum FhaProgramType {
  Fha_203B = 'FHA_203B',
  Fha_203K = 'FHA_203K',
  Fha_234C = 'FHA_234C'
}

export type Fee = {
  __typename?: 'Fee';
  amountRemaining: Scalars['Float']['output'];
  chargeDate: Scalars['GqlDate']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['FeeId']['output'];
  investorRemittanceSplit?: Maybe<InvestorRemittanceSplit>;
  isDeferred: Scalars['Boolean']['output'];
  isPrePetition?: Maybe<Scalars['Boolean']['output']>;
  lineItems: Array<FeeLineItem>;
  paymentDueId?: Maybe<Scalars['PaymentDueId']['output']>;
  status: FeeStatus;
  totalAmount: Scalars['Float']['output'];
  type?: Maybe<ChargeType>;
  updatedAt?: Maybe<Scalars['GqlDate']['output']>;
};

export type FeeBreakdown = PaymentToPaymentDue & {
  __typename?: 'FeeBreakdown';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  feeId: Scalars['FeeId']['output'];
  fees: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  paymentId: Scalars['PaymentId']['output'];
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type FeeLineItem = {
  __typename?: 'FeeLineItem';
  amount: Scalars['Float']['output'];
  id: Scalars['FeeLineItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['PaymentId']['output']>;
  type: FeeType;
};

export enum FeeStatus {
  Cancelled = 'CANCELLED',
  Capitalized = 'CAPITALIZED',
  Charged = 'CHARGED',
  Paid = 'PAID',
  Waived = 'WAIVED'
}

export enum FeeType {
  Admin = 'ADMIN',
  CreditCardProcessing = 'CREDIT_CARD_PROCESSING',
  Deboarding = 'DEBOARDING',
  Document = 'DOCUMENT',
  Draw = 'DRAW',
  Extension = 'EXTENSION',
  Late = 'LATE',
  Legal = 'LEGAL',
  LienRelease = 'LIEN_RELEASE',
  LoanModification = 'LOAN_MODIFICATION',
  NonSufficientFunds = 'NON_SUFFICIENT_FUNDS',
  Onboarding = 'ONBOARDING',
  Other = 'OTHER',
  Payoff = 'PAYOFF',
  PayoffRevision = 'PAYOFF_REVISION',
  PendingPaymentAtPayoff = 'PENDING_PAYMENT_AT_PAYOFF',
  PrepaymentPenalty = 'PREPAYMENT_PENALTY',
  PrincipalLate = 'PRINCIPAL_LATE',
  Recording = 'RECORDING',
  Rush = 'RUSH',
  Tax = 'TAX',
  Termination = 'TERMINATION',
  VerificationOfMortgage = 'VERIFICATION_OF_MORTGAGE',
  Wire = 'WIRE'
}

export type FlagStopSettingsInput = {
  advancesPaused: Scalars['Boolean']['input'];
  advancesPausedUntilDate?: InputMaybe<Scalars['GqlIsoDate']['input']>;
  documentAccessPaused: Scalars['Boolean']['input'];
  drawsPaused: Scalars['Boolean']['input'];
  emailsPaused: Scalars['Boolean']['input'];
  miCancellationReviewReason?: InputMaybe<Scalars['String']['input']>;
  miCancellationReviewRequired?: InputMaybe<Scalars['Boolean']['input']>;
  miDisbursementsPaused?: InputMaybe<Scalars['Boolean']['input']>;
  omitFromDelinquentInterestAutomation: Scalars['Boolean']['input'];
  omitFromInterestOnEscrow: Scalars['Boolean']['input'];
  omitFromLateFeeAutomation: Scalars['Boolean']['input'];
  omitFromPayoffAutomation: Scalars['Boolean']['input'];
  portalPayments: PortalPaymentStopSettingType;
};

export type FlexModification = Modification & {
  __typename?: 'FlexModification';
  deferredPrincipalAmount: Scalars['Float']['output'];
  effectiveDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['PrincipalModificationId']['output'];
  interestRate: Scalars['Float']['output'];
  loanTerm: Scalars['Int']['output'];
  status: ModificationStatus;
  type: ModificationType;
  unpaidPrincipalBalance: Scalars['Float']['output'];
  workoutPlanId?: Maybe<Scalars['WorkoutPlanId']['output']>;
};

export type FlexModificationModification = {
  __typename?: 'FlexModificationModification';
  deferredPrincipalAmount: Scalars['Float']['output'];
  interestRate: Scalars['Float']['output'];
  loanTerm: Scalars['Int']['output'];
  unpaidPrincipalBalance: Scalars['Float']['output'];
};

export type FlexModificationWorkoutPlan = WorkoutPlan & {
  __typename?: 'FlexModificationWorkoutPlan';
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  evaluationNoticeSentDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['WorkoutPlanId']['output'];
  modification: FlexModificationModification;
  planPaymentsDue: Array<WorkoutPlanPaymentDue>;
  reason?: Maybe<WorkoutPlanReason>;
  startDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  trialTermMonths: Scalars['Int']['output'];
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
  workflowInformation?: Maybe<WorkoutPlanWorkflowInformation>;
};

export enum ForbearanceCancellationReason {
  DefermentSelected = 'DEFERMENT_SELECTED',
  EvaluatingDifferentPlan = 'EVALUATING_DIFFERENT_PLAN',
  FlexModificationSelected = 'FLEX_MODIFICATION_SELECTED',
  InsufficientPayments = 'INSUFFICIENT_PAYMENTS',
  LoanReinstated = 'LOAN_REINSTATED',
  NoLongerEligible = 'NO_LONGER_ELIGIBLE',
  RepaymentPlanSelected = 'REPAYMENT_PLAN_SELECTED'
}

export enum ForbearanceSubType {
  Disaster = 'DISASTER',
  Formal = 'FORMAL',
  NotApplicable = 'NOT_APPLICABLE',
  Special = 'SPECIAL'
}

export enum ForbearanceType {
  Reduced = 'REDUCED',
  Suspended = 'SUSPENDED'
}

export type ForbearanceWorkoutPlan = WorkoutPlan & {
  __typename?: 'ForbearanceWorkoutPlan';
  cancellationReason?: Maybe<ForbearanceCancellationReason>;
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  extensions: Array<ForbearanceWorkoutPlanExtension>;
  forbearanceType: ForbearanceType;
  id: Scalars['WorkoutPlanId']['output'];
  originalTermMonths: Scalars['Int']['output'];
  partialPaymentAmount: Scalars['Float']['output'];
  planPaymentsDue: Array<WorkoutPlanPaymentDue>;
  startDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  subType: ForbearanceSubType;
  terminationDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
  workflowInformation?: Maybe<WorkoutPlanWorkflowInformation>;
};

export type ForbearanceWorkoutPlanExtension = {
  __typename?: 'ForbearanceWorkoutPlanExtension';
  extensionDate: Scalars['GqlIsoDateTime']['output'];
  extensionTermMonths: Scalars['Int']['output'];
};

export type Form1098Document = Document & {
  __typename?: 'Form1098Document';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCorrected: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  year: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type GeneralDocument = Document & {
  __typename?: 'GeneralDocument';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type GetS3PresignedUploadUrlResponse = {
  __typename?: 'GetS3PresignedUploadUrlResponse';
  destination: Scalars['String']['output'];
  presignedUploadUrl: Scalars['String']['output'];
};

export enum IndexRateType {
  Sofr_30D = 'SOFR_30D',
  Sofr_90D = 'SOFR_90D',
  Sofr_180D = 'SOFR_180D',
  Us_1M = 'US_1M',
  Us_1Y = 'US_1Y',
  Us_3M = 'US_3M',
  Us_3Y = 'US_3Y',
  Us_5Y = 'US_5Y',
  Us_6M = 'US_6M',
  Us_10Y = 'US_10Y',
  WsjPrime = 'WSJ_PRIME'
}

export enum InspectionGeneralCondition {
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  C6 = 'C6',
  Inaccessible = 'INACCESSIBLE'
}

export enum InspectionInsurableDamages {
  Fire = 'FIRE',
  NotApplicable = 'NOT_APPLICABLE',
  Theft = 'THEFT',
  Vandalism = 'VANDALISM',
  Water = 'WATER',
  Wind = 'WIND'
}

export enum InspectionOccupancyStatus {
  Abandoned = 'ABANDONED',
  DisasterUnknown = 'DISASTER_UNKNOWN',
  Occupied = 'OCCUPIED',
  SecondaryResidence = 'SECONDARY_RESIDENCE',
  Vacant = 'VACANT',
  VacantLot = 'VACANT_LOT'
}

export enum InspectionOccupancyType {
  Owner = 'OWNER',
  Tenant = 'TENANT',
  Unknown = 'UNKNOWN'
}

export enum InspectionOrderedReason {
  Bankruptcy = 'BANKRUPTCY',
  Collections = 'COLLECTIONS',
  Foreclosure = 'FORECLOSURE',
  LossMitigation = 'LOSS_MITIGATION',
  Other = 'OTHER'
}

export enum InspectionType {
  Curbside = 'CURBSIDE',
  ExteriorOnly = 'EXTERIOR_ONLY',
  InteriorAndExterior = 'INTERIOR_AND_EXTERIOR',
  Other = 'OTHER'
}

export type InsuranceEscrowDue = EscrowDue & {
  __typename?: 'InsuranceEscrowDue';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['GqlDate']['output']>;
  escrowSettingId: Scalars['EscrowSettingId']['output'];
  escrowed: Scalars['Boolean']['output'];
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['EscrowDueId']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<EscrowInsuranceType>;
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  type: EscrowType;
};

export type InsuranceEscrowSetting = EscrowSetting & {
  __typename?: 'InsuranceEscrowSetting';
  agentEmail?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentPhone?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  coverageAmount?: Maybe<Scalars['Float']['output']>;
  escrowed: Scalars['Boolean']['output'];
  forcedPlacedFlag?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['EscrowSettingId']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<EscrowInsuranceType>;
  payee: Payee;
  policyEndDate: Scalars['GqlIsoDate']['output'];
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyStartDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  type: EscrowSettingType;
};

export type InterestOnlyConfiguration = {
  __typename?: 'InterestOnlyConfiguration';
  loanTerm: Scalars['Int']['output'];
  type: InterestOnlyType;
};

export enum InterestOnlyType {
  Actual_360 = 'ACTUAL_360',
  Actual_365 = 'ACTUAL_365',
  Thirty_360 = 'THIRTY_360'
}

export type InterestRateChange = {
  __typename?: 'InterestRateChange';
  effectiveDate: Scalars['GqlDate']['output'];
  monthlyInterestRate: Scalars['Float']['output'];
};

export type InvestorRemittanceSplit = {
  __typename?: 'InvestorRemittanceSplit';
  investor: Scalars['Float']['output'];
  servicer: Scalars['Float']['output'];
  splitEnabled: Scalars['Boolean']['output'];
};

export enum InvestorSplitOption {
  FiftyFifty = 'FIFTY_FIFTY',
  Investor = 'INVESTOR',
  Servicer = 'SERVICER'
}

export enum Language {
  Chinese = 'CHINESE',
  DoNotWishToRespond = 'DO_NOT_WISH_TO_RESPOND',
  English = 'ENGLISH',
  Hmong = 'HMONG',
  Korean = 'KOREAN',
  Other = 'OTHER',
  Rohingya = 'ROHINGYA',
  Spanish = 'SPANISH',
  Tagalog = 'TAGALOG',
  Vietnamese = 'VIETNAMESE'
}

export type LegacyEscrowPayeeInput = {
  address?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
};

export type LegacyEscrowPayeeSnapshot = {
  __typename?: 'LegacyEscrowPayeeSnapshot';
  address?: Maybe<Address>;
  name: Scalars['String']['output'];
};

export type LoanBillSettings = {
  __typename?: 'LoanBillSettings';
  startDate: Scalars['GqlDate']['output'];
  type: LoanBillSettingsType;
};

export enum LoanBillSettingsType {
  Borrower = 'BORROWER',
  Builder = 'BUILDER'
}

export type LoanChatMessage = {
  __typename?: 'LoanChatMessage';
  id: Scalars['LoanChatMessageId']['output'];
  message: Scalars['String']['output'];
  sender: LoanChatSender;
  sentAt?: Maybe<Scalars['GqlTimestamp']['output']>;
};

export type LoanChatMessages = {
  __typename?: 'LoanChatMessages';
  records: Array<LoanChatMessage>;
};

export enum LoanChatSender {
  Borrower = 'BORROWER',
  Bot = 'BOT',
  Lender = 'LENDER'
}

export type LoanDetailsSettings = {
  __typename?: 'LoanDetailsSettings';
  loanOfficer: Scalars['Boolean']['output'];
  manageMailingAddress: Scalars['Boolean']['output'];
};

export type LoanFees = {
  __typename?: 'LoanFees';
  lateFee?: Maybe<LoanLateFee>;
  prepaymentPenalty?: Maybe<LoanPrepaymentPenaltyFee>;
  principalLateFee?: Maybe<LoanPrincipalLateFee>;
  terminationFee?: Maybe<LoanTerminationFee>;
};

export type LoanInvestor = {
  __typename?: 'LoanInvestor';
  documentCustodian?: Maybe<Scalars['String']['output']>;
  fhaAdpCode?: Maybe<Scalars['String']['output']>;
  fhaCaseNumber?: Maybe<Scalars['String']['output']>;
  investorLoanId?: Maybe<Scalars['String']['output']>;
  investorName?: Maybe<Scalars['String']['output']>;
  mers?: Maybe<Mers>;
  noteholder?: Maybe<Noteholder>;
};

export type LoanInvestorRemittanceSplit = {
  __typename?: 'LoanInvestorRemittanceSplit';
  guaranteeFee?: Maybe<Scalars['Float']['output']>;
  investor: Scalars['Float']['output'];
  investor2?: Maybe<Scalars['Float']['output']>;
  investor2Ownership?: Maybe<Scalars['Float']['output']>;
  investorOwnership?: Maybe<Scalars['Float']['output']>;
  servicer: Scalars['Float']['output'];
  soldDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  splitEnabled: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['GqlIsoDate']['output']>;
};

export type LoanInvestorRemittanceSplitInput = {
  guaranteeFee?: InputMaybe<Scalars['Float']['input']>;
  investor: Scalars['Float']['input'];
  investor2?: InputMaybe<Scalars['Float']['input']>;
  investor2Ownership?: InputMaybe<Scalars['Float']['input']>;
  investorOwnership?: InputMaybe<Scalars['Float']['input']>;
  servicer: Scalars['Float']['input'];
  splitEnabled: Scalars['Boolean']['input'];
};

export type LoanLateFee = {
  type: LoanLateFeeType;
};

export type LoanLateFeeFixed = LoanLateFee & {
  __typename?: 'LoanLateFeeFixed';
  amount: Scalars['Float']['output'];
  type: LoanLateFeeType;
};

export type LoanLateFeePercent = LoanLateFee & {
  __typename?: 'LoanLateFeePercent';
  decimalCharge: Scalars['Float']['output'];
  maxAmount?: Maybe<Scalars['Float']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
  type: LoanLateFeeType;
};

export enum LoanLateFeeType {
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export enum LoanNoteContactRole {
  AttorneyRepresentingBorrower = 'ATTORNEY_REPRESENTING_BORROWER',
  AuthorizedThirdParty = 'AUTHORIZED_THIRD_PARTY',
  Cfpb = 'CFPB',
  CoBorrower = 'CO_BORROWER',
  NonCfpbRegulatory = 'NON_CFPB_REGULATORY',
  NoContact = 'NO_CONTACT',
  Other = 'OTHER',
  PrimaryBorrower = 'PRIMARY_BORROWER',
  StateAgency = 'STATE_AGENCY'
}

export enum LoanNoteContactType {
  InboundCall = 'INBOUND_CALL',
  InboundEmail = 'INBOUND_EMAIL',
  InboundText = 'INBOUND_TEXT',
  InPerson = 'IN_PERSON',
  NoContact = 'NO_CONTACT',
  Other = 'OTHER',
  OutboundCall = 'OUTBOUND_CALL',
  OutboundEmail = 'OUTBOUND_EMAIL',
  PaperMail = 'PAPER_MAIL',
  Voicemail = 'VOICEMAIL',
  WelcomeCall = 'WELCOME_CALL'
}

export enum LoanNoteReason {
  AbandonmentOfProperty = 'ABANDONMENT_OF_PROPERTY',
  BusinessFailure = 'BUSINESS_FAILURE',
  CasualtyLoss = 'CASUALTY_LOSS',
  ChangeIncome = 'CHANGE_INCOME',
  Construction = 'CONSTRUCTION',
  ConstructionProgress = 'CONSTRUCTION_PROGRESS',
  CustomerServiceIssue = 'CUSTOMER_SERVICE_ISSUE',
  Death = 'DEATH',
  DeathBorrowerFamily = 'DEATH_BORROWER_FAMILY',
  Default = 'DEFAULT',
  Dispute = 'DISPUTE',
  DistanceEmploymentTransfer = 'DISTANCE_EMPLOYMENT_TRANSFER',
  EligibleDisaster = 'ELIGIBLE_DISASTER',
  EnergyEnvironmentCost = 'ENERGY_ENVIRONMENT_COST',
  FinancialObligation = 'FINANCIAL_OBLIGATION',
  Fraud = 'FRAUD',
  Illness = 'ILLNESS',
  IllnessBorrowerFamily = 'ILLNESS_BORROWER_FAMILY',
  Incarceration = 'INCARCERATION',
  LackRental = 'LACK_RENTAL',
  LoanDetails = 'LOAN_DETAILS',
  LoanNotBoarded = 'LOAN_NOT_BOARDED',
  Marital = 'MARITAL',
  Military = 'MILITARY',
  NationalEmergency = 'NATIONAL_EMERGENCY',
  NationalEmergencyRelated = 'NATIONAL_EMERGENCY_RELATED',
  NeighborhoodProblem = 'NEIGHBORHOOD_PROBLEM',
  NewServicer = 'NEW_SERVICER',
  NotificationNotReceived = 'NOTIFICATION_NOT_RECEIVED',
  NoContact = 'NO_CONTACT',
  Origination = 'ORIGINATION',
  Other = 'OTHER',
  PaymentAdjustment = 'PAYMENT_ADJUSTMENT',
  PaymentDispute = 'PAYMENT_DISPUTE',
  PaymentHandling = 'PAYMENT_HANDLING',
  PaymentIssue = 'PAYMENT_ISSUE',
  PaymentMisapplication = 'PAYMENT_MISAPPLICATION',
  Property = 'PROPERTY',
  ServicingProblems = 'SERVICING_PROBLEMS',
  Subservicer = 'SUBSERVICER',
  TaxEscrow = 'TAX_ESCROW',
  TransferOwnership = 'TRANSFER_OWNERSHIP',
  UnableSell = 'UNABLE_SELL',
  Unemployment = 'UNEMPLOYMENT'
}

export enum LoanNoteTopicType {
  AddContact = 'ADD_CONTACT',
  Autopay = 'AUTOPAY',
  Billing = 'BILLING',
  ConnectBank = 'CONNECT_BANK',
  Damage = 'DAMAGE',
  DefaultLegalNote = 'DEFAULT_LEGAL_NOTE',
  DefaultNote = 'DEFAULT_NOTE',
  DefaultPropertyNote = 'DEFAULT_PROPERTY_NOTE',
  Doc_1098 = 'DOC_1098',
  DrawCompleted = 'DRAW_COMPLETED',
  DrawInspectionReceived = 'DRAW_INSPECTION_RECEIVED',
  DrawRequested = 'DRAW_REQUESTED',
  DrawWelcomePackage = 'DRAW_WELCOME_PACKAGE',
  EconsentPreference = 'ECONSENT_PREFERENCE',
  EditContact = 'EDIT_CONTACT',
  EmailUndelivered = 'EMAIL_UNDELIVERED',
  EscrowAnalysisDocuments = 'ESCROW_ANALYSIS_DOCUMENTS',
  EscrowAnalysisTaxEscrow = 'ESCROW_ANALYSIS_TAX_ESCROW',
  EscrowPayment = 'ESCROW_PAYMENT',
  GeneralComplaint = 'GENERAL_COMPLAINT',
  GeneralContact = 'GENERAL_CONTACT',
  GeneralDocuments = 'GENERAL_DOCUMENTS',
  GeneralLoanTransfer = 'GENERAL_LOAN_TRANSFER',
  GeneralPaymentPortal = 'GENERAL_PAYMENT_PORTAL',
  GeneralPaymentResolution = 'GENERAL_PAYMENT_RESOLUTION',
  GeneralTaxEscrow = 'GENERAL_TAX_ESCROW',
  GoodbyeLetter = 'GOODBYE_LETTER',
  InspectionOrdered = 'INSPECTION_ORDERED',
  Insurance = 'INSURANCE',
  Login = 'LOGIN',
  LossMitigation = 'LOSS_MITIGATION',
  Modification = 'MODIFICATION',
  MonthlyStatement = 'MONTHLY_STATEMENT',
  NewServicerIssue = 'NEW_SERVICER_ISSUE',
  NoPromise = 'NO_PROMISE',
  Other = 'OTHER',
  PaymentMailed = 'PAYMENT_MAILED',
  PaymentProcessed = 'PAYMENT_PROCESSED',
  PaymentWrongServicer = 'PAYMENT_WRONG_SERVICER',
  Payoff = 'PAYOFF',
  Promise = 'PROMISE',
  QualifiedWrittenRequest = 'QUALIFIED_WRITTEN_REQUEST',
  RemoveContact = 'REMOVE_CONTACT',
  Repayment = 'REPAYMENT',
  StoppedPayment = 'STOPPED_PAYMENT',
  Tax = 'TAX',
  WelcomeInformation = 'WELCOME_INFORMATION'
}

export type LoanPrepaymentPenaltyFee = {
  __typename?: 'LoanPrepaymentPenaltyFee';
  expirationMonths?: Maybe<Scalars['Int']['output']>;
  flag: Scalars['Boolean']['output'];
  planDescription?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<LoanPrepaymentPenaltyFeePlanType>;
};

export enum LoanPrepaymentPenaltyFeePlanType {
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export type LoanPrincipalLateFee = {
  flag: Scalars['Boolean']['output'];
  type: LoanPrincipalLateFeeType;
};

export type LoanPrincipalLateFeeDisabled = LoanPrincipalLateFee & {
  __typename?: 'LoanPrincipalLateFeeDisabled';
  flag: Scalars['Boolean']['output'];
  type: LoanPrincipalLateFeeType;
};

export type LoanPrincipalLateFeeFixed = LoanPrincipalLateFee & {
  __typename?: 'LoanPrincipalLateFeeFixed';
  fixedAmount: Scalars['Float']['output'];
  fixedDays: Scalars['Int']['output'];
  flag: Scalars['Boolean']['output'];
  perProperty: Scalars['Boolean']['output'];
  type: LoanPrincipalLateFeeType;
};

export type LoanPrincipalLateFeePercent = LoanPrincipalLateFee & {
  __typename?: 'LoanPrincipalLateFeePercent';
  flag: Scalars['Boolean']['output'];
  percentDays: Scalars['Int']['output'];
  percentPrincipal: Scalars['Float']['output'];
  type: LoanPrincipalLateFeeType;
};

export enum LoanPrincipalLateFeeType {
  Disabled = 'DISABLED',
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export enum LoanPurpose {
  Purchase = 'purchase',
  Refinance = 'refinance'
}

export enum LoanStatus {
  Active = 'active',
  Archived = 'archived',
  Liquidated = 'liquidated',
  PaidOff = 'paidOff',
  PendingActivation = 'pendingActivation',
  PendingTransfer = 'pendingTransfer',
  PreActive = 'preActive',
  Reo = 'reo',
  Transferred = 'transferred'
}

export type LoanStatusStopSettingsInput = {
  documentAccessPaused: Scalars['Boolean']['input'];
  emailsPaused: Scalars['Boolean']['input'];
  portalPayments: PortalPaymentStopSettingType;
};

export type LoanTerminationFee = {
  flag: Scalars['Boolean']['output'];
  type: LoanTerminationFeeType;
};

export type LoanTerminationFeeDisabled = LoanTerminationFee & {
  __typename?: 'LoanTerminationFeeDisabled';
  flag: Scalars['Boolean']['output'];
  type: LoanTerminationFeeType;
};

export type LoanTerminationFeeFixed = LoanTerminationFee & {
  __typename?: 'LoanTerminationFeeFixed';
  fixedAmount: Scalars['Float']['output'];
  fixedMonths: Scalars['Int']['output'];
  flag: Scalars['Boolean']['output'];
  perProperty: Scalars['Boolean']['output'];
  type: LoanTerminationFeeType;
};

export type LoanTerminationFeePercent = LoanTerminationFee & {
  __typename?: 'LoanTerminationFeePercent';
  flag: Scalars['Boolean']['output'];
  percentMonths: Scalars['Int']['output'];
  percentPrincipal: Scalars['Float']['output'];
  type: LoanTerminationFeeType;
};

export enum LoanTerminationFeeType {
  Disabled = 'DISABLED',
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export type Mers = {
  __typename?: 'MERS';
  MIN?: Maybe<Scalars['MERSMIN']['output']>;
  MINStatus?: Maybe<MersminStatus>;
  momFlag?: Maybe<Scalars['Boolean']['output']>;
  orgId?: Maybe<Scalars['MERSOrgId']['output']>;
  registrationDate?: Maybe<Scalars['GqlIsoDate']['output']>;
};

export enum MersminStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MaturityConfig = {
  __typename?: 'MaturityConfig';
  history: Array<MaturityHistoryItem>;
  isMaturing: Scalars['Boolean']['output'];
  maturityDate: Scalars['GqlDate']['output'];
};

export type MaturityHistoryItem = {
  __typename?: 'MaturityHistoryItem';
  createdAt: Scalars['GqlDate']['output'];
  maturityDate: Scalars['GqlDate']['output'];
};

export type Modification = {
  effectiveDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['PrincipalModificationId']['output'];
  status: ModificationStatus;
  type: ModificationType;
};

export enum ModificationStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export enum ModificationType {
  FlexModification = 'FLEX_MODIFICATION',
  PrincipalOnly = 'PRINCIPAL_ONLY'
}

export enum MortgageInsuranceCancellationEligibilityReason {
  CurrentLtv = 'CURRENT_LTV',
  MidpointDate = 'MIDPOINT_DATE',
  MipLtvThresholdDate = 'MIP_LTV_THRESHOLD_DATE',
  OriginalLtv = 'ORIGINAL_LTV'
}

export type MortgageInsuranceCancellationInput = {
  cancellationDiscontinuanceCode: Scalars['String']['input'];
  cancellationEffectiveDate: Scalars['GqlIsoDate']['input'];
  cancellationNotification?: InputMaybe<Scalars['String']['input']>;
  notificationRecipientIds?: InputMaybe<Array<Scalars['BorrowerId']['input']>>;
};

export enum MortgageInsuranceDiscontinuanceCode {
  AutomaticDueToLtvOrMidpointValue = 'AUTOMATIC_DUE_TO_LTV_OR_MIDPOINT_VALUE',
  BorrowerInitiatedDueToCurrentValue = 'BORROWER_INITIATED_DUE_TO_CURRENT_VALUE',
  BorrowerInitiatedDueToOriginalValue = 'BORROWER_INITIATED_DUE_TO_ORIGINAL_VALUE',
  ShouldNotHaveBeenApplied = 'SHOULD_NOT_HAVE_BEEN_APPLIED',
  TerminatedDueToHighRisk = 'TERMINATED_DUE_TO_HIGH_RISK'
}

export type MortgageInsuranceEscrowDue = EscrowDue & {
  __typename?: 'MortgageInsuranceEscrowDue';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['GqlDate']['output']>;
  escrowSettingId: Scalars['EscrowSettingId']['output'];
  escrowed: Scalars['Boolean']['output'];
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['EscrowDueId']['output'];
  isCancellable: Scalars['Boolean']['output'];
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  type: EscrowType;
};

export type MortgageInsuranceEscrowSetting = EscrowSetting & {
  __typename?: 'MortgageInsuranceEscrowSetting';
  amount: Scalars['Float']['output'];
  associatedDisbursementCount: Scalars['Int']['output'];
  cancellationDiscontinuanceCode?: Maybe<MortgageInsuranceDiscontinuanceCode>;
  cancellationEffectiveDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  cancellationEligibilityReasons: Array<MortgageInsuranceCancellationEligibilityReason>;
  certificateId: Scalars['String']['output'];
  coveragePercent: Scalars['Float']['output'];
  escrowed: Scalars['Boolean']['output'];
  fhaProgramType?: Maybe<FhaProgramType>;
  id: Scalars['EscrowSettingId']['output'];
  /** @deprecated Use cancellationEligibilityReasons instead */
  isEligibleForCancellation: Scalars['Boolean']['output'];
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  isRefundable: Scalars['Boolean']['output'];
  midpointDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  mortgageInsuranceType: MortgageInsuranceType;
  payee: Payee;
  paymentCadence: PaymentCadence;
  poolCertificateNumber?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['PropertyId']['output'];
  renewalType: MortgageInsuranceRenewalType;
  startDate: Scalars['GqlIsoDate']['output'];
  status: EscrowSettingStatus;
  type: EscrowSettingType;
};

export enum MortgageInsuranceRenewalType {
  Constant = 'CONSTANT',
  Declining = 'DECLINING'
}

export enum MortgageInsuranceType {
  Fha = 'FHA',
  Pmi = 'PMI',
  Ufmip = 'UFMIP'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms: PortalUser;
  cancelPayment: PortalLoan;
  confirmMessageView: PortalLoan;
  createPortalBorrowerAchAccount: PortalLoan;
  createRepayAccount: PortalLoan;
  deletePortalBorrowerAchAccount: PortalLoan;
  deleteRepayAccount: PortalLoan;
  drawRequest: PortalLoan;
  editBorrowerDetails: Borrower;
  escrowWaiverRequest: SuccessResponse;
  generalInquiry: SuccessResponse;
  getDocumentUrl: DownloadUrlResponse;
  getPdfStatementUrl: DownloadUrlResponse;
  getS3PresignedUrlDocumentUpload: GetS3PresignedUploadUrlResponse;
  initiateNachaPayment: PortalLoan;
  initiatePayment: DwollaPaymentResponse;
  initiateRepayPayment: PortalLoan;
  logout: SuccessResponse;
  paymentAssistanceInquiry: SuccessResponse;
  pmiCancellationRequest: SuccessResponse;
  postPlaidBankToDwolla: PortalUser;
  queryChatBot?: Maybe<ChatBotResponse>;
  removeBank: PortalUserActionResponse;
  removePlaidToken: SuccessResponse;
  requestPayoffStatement: PortalLoan;
  saveBorrowerDocumentUpload: PortalLoan;
  saveMicroDepositToken: AccessTokenResponse;
  sendChatMessage: LoanChatMessage;
  updateAutopaySettingsForLoan: PortalLoan;
  updateNachaAutopaySettingsForLoan: PortalLoan;
  updateNotificationSettings: SuccessResponse;
  updateNotificationSettingsForAllCompanies: SuccessResponse;
  updateRepayAutopaySettingsForLoan: PortalLoan;
  verificationOfMortgageRequest: PortalLoan;
};


export type MutationAcceptTermsArgs = {
  emailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  tosVersion: Scalars['Int']['input'];
};


export type MutationCancelPaymentArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  paymentId: Scalars['PaymentId']['input'];
};


export type MutationConfirmMessageViewArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  messageKey: BorrowerMessageKey;
};


export type MutationCreatePortalBorrowerAchAccountArgs = {
  companyId: Scalars['CompanyId']['input'];
  input: CreatePortalBorrowerAchAccountInput;
  loanId: Scalars['LoanId']['input'];
};


export type MutationCreateRepayAccountArgs = {
  companyId: Scalars['CompanyId']['input'];
  input: CreateRepayAccountInput;
  loanId: Scalars['LoanId']['input'];
};


export type MutationDeletePortalBorrowerAchAccountArgs = {
  accountId: Scalars['BorrowerAchAccountId']['input'];
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
};


export type MutationDeleteRepayAccountArgs = {
  accountId: Scalars['RepayAccountId']['input'];
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
};


export type MutationDrawRequestArgs = {
  amount: Scalars['Float']['input'];
  companyId: Scalars['CompanyId']['input'];
  date: Scalars['GqlDate']['input'];
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
};


export type MutationEditBorrowerDetailsArgs = {
  companyId: Scalars['CompanyId']['input'];
  input: BorrowerEditInput;
  loanId: Scalars['LoanId']['input'];
};


export type MutationEscrowWaiverRequestArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  waivedItems: Array<EscrowWaiverRequestType>;
};


export type MutationGeneralInquiryArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
};


export type MutationGetDocumentUrlArgs = {
  documentId: Scalars['DocumentId']['input'];
  loanId: Scalars['LoanId']['input'];
};


export type MutationGetPdfStatementUrlArgs = {
  loanId: Scalars['LoanId']['input'];
  paymentDueId: Scalars['PaymentDueId']['input'];
  version: Scalars['Int']['input'];
};


export type MutationGetS3PresignedUrlDocumentUploadArgs = {
  companyId: Scalars['CompanyId']['input'];
  fileExtension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  fileType: Scalars['String']['input'];
  loanId: Scalars['LoanId']['input'];
};


export type MutationInitiateNachaPaymentArgs = {
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  borrowerAchAccountId: Scalars['BorrowerAchAccountId']['input'];
  companyId: Scalars['CompanyId']['input'];
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
  loanId: Scalars['LoanId']['input'];
};


export type MutationInitiatePaymentArgs = {
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  companyId: Scalars['CompanyId']['input'];
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
  fromBankUrl: Scalars['String']['input'];
  loanId: Scalars['LoanId']['input'];
};


export type MutationInitiateRepayPaymentArgs = {
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  companyId: Scalars['CompanyId']['input'];
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
  loanId: Scalars['LoanId']['input'];
  repayAccountId: Scalars['RepayAccountId']['input'];
};


export type MutationPaymentAssistanceInquiryArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
  quotedPastDueTotal: Scalars['Float']['input'];
};


export type MutationPmiCancellationRequestArgs = {
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  propertyValueType: PmiCancellationRequestPropertyValueType;
};


export type MutationPostPlaidBankToDwollaArgs = {
  accountId: Scalars['String']['input'];
  accountNickname: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};


export type MutationQueryChatBotArgs = {
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
};


export type MutationRemoveBankArgs = {
  bankUrl: Scalars['String']['input'];
};


export type MutationRequestPayoffStatementArgs = {
  additionalBorrowers: Array<Scalars['BorrowerId']['input']>;
  loanId: Scalars['LoanId']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  payoffDate: Scalars['GqlDate']['input'];
  propertyIds: Array<Scalars['PropertyId']['input']>;
};


export type MutationSaveBorrowerDocumentUploadArgs = {
  loanId: Scalars['LoanId']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationSaveMicroDepositTokenArgs = {
  accountId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};


export type MutationSendChatMessageArgs = {
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
};


export type MutationUpdateAutopaySettingsForLoanArgs = {
  autopaySettings?: InputMaybe<AutopaySettingsInput>;
  loanId: Scalars['LoanId']['input'];
};


export type MutationUpdateNachaAutopaySettingsForLoanArgs = {
  autopaySettings?: InputMaybe<NachaAutopaySettingsInput>;
  loanId: Scalars['LoanId']['input'];
};


export type MutationUpdateNotificationSettingsArgs = {
  input: BorrowerNotificationSettingsInput;
  loanId: Scalars['LoanId']['input'];
};


export type MutationUpdateNotificationSettingsForAllCompaniesArgs = {
  input: BorrowerNotificationSettingsForAllCompaniesInput;
};


export type MutationUpdateRepayAutopaySettingsForLoanArgs = {
  autopaySettings?: InputMaybe<RepayAutopaySettingsInput>;
  loanId: Scalars['LoanId']['input'];
};


export type MutationVerificationOfMortgageRequestArgs = {
  companyId: Scalars['CompanyId']['input'];
  input: VerificationOfMortgageRequestInput;
  loanId: Scalars['LoanId']['input'];
};

export type NachaAutopaySettings = {
  __typename?: 'NachaAutopaySettings';
  accountId: Scalars['BorrowerAchAccountId']['output'];
  actor?: Maybe<Actor>;
  borrowerId: Scalars['BorrowerId']['output'];
  dayOfTheMonth?: Maybe<Scalars['Int']['output']>;
  type: AutopaySettingsType;
};

export type NachaAutopaySettingsInput = {
  accountId: Scalars['BorrowerAchAccountId']['input'];
  dayOfTheMonth: Scalars['Int']['input'];
};

export enum Noteholder {
  Investor = 'investor',
  Servicer = 'servicer',
  ThirdParty = 'thirdParty'
}

export enum OccupancyType {
  Investment = 'investment',
  Primary = 'primary',
  Second = 'second'
}

export enum OpenPayoffStatus {
  Active = 'active',
  ActiveOutdated = 'activeOutdated',
  Requested = 'requested'
}

export type OriginationData = {
  __typename?: 'OriginationData';
  fundedAtClosing?: Maybe<Scalars['Float']['output']>;
  loanOfficerEmail?: Maybe<Scalars['String']['output']>;
  loanOfficerName?: Maybe<Scalars['String']['output']>;
  loanProcessorEmail?: Maybe<Scalars['String']['output']>;
  loanProcessorName?: Maybe<Scalars['String']['output']>;
};

export enum PmiCancellationRequestPropertyValueType {
  Current = 'CURRENT',
  Original = 'ORIGINAL'
}

export type PaidOffRecord = {
  id: Scalars['PayoffId']['output'];
  payoffDate: Scalars['GqlDate']['output'];
  payoffType: PaidOffType;
};

export enum PaidOffType {
  Payoff = 'payoff',
  UntrackedPayoff = 'untrackedPayoff'
}

export type PartialPayoffInterestAttribution = Attribution & {
  __typename?: 'PartialPayoffInterestAttribution';
  dailyInterestRate: Scalars['Float']['output'];
  days: Scalars['Int']['output'];
  endOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  interest: Scalars['Float']['output'];
  isDeferred?: Maybe<Scalars['Boolean']['output']>;
  isWaived?: Maybe<Scalars['Boolean']['output']>;
  payoffId: Scalars['PayoffId']['output'];
  periodInterestRate?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  startOfPeriodPrincipal: Scalars['Float']['output'];
  type: AttributionType;
};

export type Payee = DirectoryPayee | LegacyEscrowPayeeSnapshot;

export enum PayeePaymentMethod {
  Ach = 'ACH',
  AuthorizedAch = 'AUTHORIZED_ACH',
  Check = 'CHECK',
  Wire = 'WIRE'
}

export enum PayeeTaxType {
  City = 'CITY',
  County = 'COUNTY',
  Other = 'OTHER',
  School = 'SCHOOL',
  Town = 'TOWN',
  Village = 'VILLAGE'
}

export enum PayeeType {
  Insurance = 'INSURANCE',
  MortgageInsurance = 'MORTGAGE_INSURANCE',
  Other = 'OTHER',
  Tax = 'TAX'
}

export type Payer = AuthorizedContactPayer | BorrowerPayer | EntityPayer | ThirdPartyPayer;

export type PayerInput = {
  authorizedContactId?: InputMaybe<Scalars['AuthorizedContactId']['input']>;
  borrowerId?: InputMaybe<Scalars['BorrowerId']['input']>;
  entityId?: InputMaybe<Scalars['EntityId']['input']>;
  thirdPartyName?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  additionalEscrow: Scalars['Float']['output'];
  additionalPrincipal: Scalars['Float']['output'];
  additionalSuspense: Scalars['Float']['output'];
  canCancel: Scalars['Boolean']['output'];
  canInitiateClawBack: Scalars['Boolean']['output'];
  clawBackStatus?: Maybe<PaymentStatus>;
  comment?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['GqlDate']['output'];
  failureDate?: Maybe<Scalars['GqlDate']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  hasSweep: Scalars['Boolean']['output'];
  holdback: Scalars['Float']['output'];
  id: Scalars['PaymentId']['output'];
  isAutopayment?: Maybe<Scalars['Boolean']['output']>;
  isDeposit?: Maybe<Scalars['Boolean']['output']>;
  isInterestOnEscrowDeposit: Scalars['Boolean']['output'];
  lossDraft: Scalars['Float']['output'];
  method: PaymentMethod;
  originatingAccountId?: Maybe<Scalars['String']['output']>;
  payer: Payer;
  paymentDate: Scalars['GqlDate']['output'];
  payoffId?: Maybe<Scalars['PayoffId']['output']>;
  status: PaymentStatus;
  total: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
};

export enum PaymentBreakdownEvent {
  Initiated = 'initiated',
  Reallocated = 'reallocated',
  Voided = 'voided'
}

export enum PaymentCadence {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnual = 'SEMI_ANNUAL',
  Upfront = 'UPFRONT'
}

export enum PaymentDeferralAcceptanceMethod {
  Call = 'CALL',
  Other = 'OTHER',
  Sign = 'SIGN'
}

export enum PaymentDeferralCancellationReason {
  NoAgreement = 'NO_AGREEMENT',
  Other = 'OTHER',
  ReviewingDifferentPlan = 'REVIEWING_DIFFERENT_PLAN'
}

export type PaymentDeferralQuotedDeferredBalances = {
  __typename?: 'PaymentDeferralQuotedDeferredBalances';
  charges: Scalars['Float']['output'];
  escrowAdvances: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
};

export type PaymentDeferralQuotedDeferredBalancesInput = {
  charges: Scalars['Float']['input'];
  escrowAdvances: Scalars['Float']['input'];
  interest: Scalars['Float']['input'];
  principal: Scalars['Float']['input'];
};

export enum PaymentDeferralReason {
  Covid = 'COVID',
  FailedRepaymentPlan = 'FAILED_REPAYMENT_PLAN',
  Hardship = 'HARDSHIP',
  NaturalDisaster = 'NATURAL_DISASTER',
  Other = 'OTHER',
  PostForbearancePlan = 'POST_FORBEARANCE_PLAN'
}

export type PaymentDeferralWorkoutPlan = WorkoutPlan & {
  __typename?: 'PaymentDeferralWorkoutPlan';
  acceptanceMethod: PaymentDeferralAcceptanceMethod;
  acceptanceMethodOther?: Maybe<Scalars['String']['output']>;
  acceptedDate?: Maybe<Scalars['GqlIsoDateTime']['output']>;
  archivedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  cancellationReason?: Maybe<PaymentDeferralCancellationReason>;
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  chargeIds: Array<Scalars['FeeId']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  endStatementDate: Scalars['GqlIsoDate']['output'];
  escrowAnalysisId?: Maybe<Scalars['QcDocumentId']['output']>;
  id: Scalars['WorkoutPlanId']['output'];
  offeredDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  paymentDeferralReason: PaymentDeferralReason;
  quotedDeferredBalances: PaymentDeferralQuotedDeferredBalances;
  startDate: Scalars['GqlIsoDate']['output'];
  startStatementDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  totalDeferredBalance: Scalars['Float']['output'];
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export type PaymentDue = {
  __typename?: 'PaymentDue';
  attribution: Array<Attribution>;
  createdAt?: Maybe<Scalars['GqlTimestamp']['output']>;
  escrow: Scalars['Float']['output'];
  escrowShortage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['PaymentDueId']['output'];
  interest: Scalars['Float']['output'];
  paymentDate: Scalars['GqlDate']['output'];
  principal: Scalars['Float']['output'];
  reserveCredit?: Maybe<Scalars['Float']['output']>;
  statementDate: Scalars['GqlDate']['output'];
  statements: Array<Statement>;
  status: PaymentDueSnapshot;
  total: Scalars['Float']['output'];
};

export type PaymentDueSnapshot = {
  __typename?: 'PaymentDueSnapshot';
  amountRemainingFromBorrower: Scalars['Float']['output'];
  amountRemainingFromCredit: Scalars['Float']['output'];
  billingStatus: BillingStatus;
  fulfilled: Scalars['Boolean']['output'];
  isLate: Scalars['Boolean']['output'];
  isPrePetition?: Maybe<Scalars['Boolean']['output']>;
  totalAmountRemaining: Scalars['Float']['output'];
  wasCapitalized?: Maybe<Scalars['Boolean']['output']>;
  workoutPlanType?: Maybe<WorkoutPlanType>;
};

export enum PaymentDueStatus {
  Due = 'due',
  NotDue = 'notDue',
  Submitted = 'submitted'
}

export type PaymentDueSubStatus = {
  __typename?: 'PaymentDueSubStatus';
  isPastDue: Scalars['Boolean']['output'];
  paymentFail: Scalars['Boolean']['output'];
};

export enum PaymentMethod {
  AuthorizedAch = 'AUTHORIZED_ACH',
  BalanceForward = 'BALANCE_FORWARD',
  BalanceReallocation = 'BALANCE_REALLOCATION',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD',
  Dwolla = 'DWOLLA',
  Lockbox = 'LOCKBOX',
  Phone = 'PHONE',
  PrincipalPrepayment = 'PRINCIPAL_PREPAYMENT',
  Reserve = 'RESERVE',
  ReserveReversal = 'RESERVE_REVERSAL',
  Reversal = 'REVERSAL',
  Wire = 'WIRE'
}

export type PaymentSnapshot = {
  __typename?: 'PaymentSnapshot';
  balances: Balances;
  outstandingBalance: Scalars['Float']['output'];
  totalPaid: TotalPaid;
};

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export type PaymentToPaymentDue = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  paymentId: Scalars['PaymentId']['output'];
  type: PaymentToPaymentDueType;
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export enum PaymentToPaymentDueType {
  Advance = 'advance',
  BalanceReallocation = 'balanceReallocation',
  Fee = 'fee',
  Payoff = 'payoff',
  PrincipalPrepayment = 'principalPrepayment',
  Statement = 'statement',
  Suspense = 'suspense',
  ThirdParty = 'thirdParty'
}

export type Payoff = {
  __typename?: 'Payoff';
  createdAt: Scalars['GqlTimestamp']['output'];
  expirationDate: Scalars['GqlDate']['output'];
  fee?: Maybe<Fee>;
  id: Scalars['PayoffId']['output'];
  isPartial: Scalars['Boolean']['output'];
  processedRecord?: Maybe<PayoffRecord>;
  propertyIds: Array<Scalars['PropertyId']['output']>;
  status: PayoffStatus;
  totalDue: Scalars['Float']['output'];
};

export type PayoffBreakdown = PaymentToPaymentDue & {
  __typename?: 'PayoffBreakdown';
  additionalEscrow: Scalars['Float']['output'];
  additionalPrincipal: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  escrow: Scalars['Float']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  fees: Scalars['Float']['output'];
  futureStatementSuspense: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  interest: Scalars['Float']['output'];
  paymentId: Scalars['PaymentId']['output'];
  payoffId: Scalars['PayoffId']['output'];
  principal: Scalars['Float']['output'];
  reserve: Scalars['Float']['output'];
  suspense: Scalars['Float']['output'];
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type PayoffDocument = Document & {
  __typename?: 'PayoffDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  expirationDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  payoffAmount: Scalars['Float']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PayoffRecord = {
  __typename?: 'PayoffRecord';
  amountPaid: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['GqlIsoDateTime']['output']>;
  escrowBalance: Scalars['Float']['output'];
  fee?: Maybe<Fee>;
  processedDate: Scalars['GqlDate']['output'];
  totalDue: Scalars['Float']['output'];
  waivedAmounts: PayoffWaiver;
};

export enum PayoffStatus {
  Expired = 'expired',
  Pending = 'pending',
  Processed = 'processed'
}

export type PayoffWaiver = {
  __typename?: 'PayoffWaiver';
  escrow: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
  suspense: Scalars['Float']['output'];
};

export enum PermittedAction {
  CreateDefaultInterest = 'createDefaultInterest',
  CreateDepositsOrTransfers = 'createDepositsOrTransfers',
  CreateDisbursementsFromAdvance = 'createDisbursementsFromAdvance',
  CreateDisbursementsFromDraw = 'createDisbursementsFromDraw',
  CreateDisbursementsFromEscrow = 'createDisbursementsFromEscrow',
  CreateDisbursementsFromPayoff = 'createDisbursementsFromPayoff',
  CreateDisbursementsFromServicingTransfer = 'createDisbursementsFromServicingTransfer',
  CreateEscrowAnalysis = 'createEscrowAnalysis',
  CreateFees = 'createFees',
  CreateForm1098s = 'createForm1098s',
  CreateLoanDocuments = 'createLoanDocuments',
  CreateLoans = 'createLoans',
  CreateManualStatements = 'createManualStatements',
  CreatePayments = 'createPayments',
  CreatePayoffStatements = 'createPayoffStatements',
  CreatePrincipalModifications = 'createPrincipalModifications',
  CreateReportableEvents = 'createReportableEvents',
  CreateReports = 'createReports',
  CreateWorkoutPlans = 'createWorkoutPlans',
  CreateWriteOffs = 'createWriteOffs',
  DeleteLoans = 'deleteLoans',
  ManageLoanPointOfContacts = 'manageLoanPointOfContacts',
  ManagePayees = 'managePayees',
  ManageSftpCredentials = 'manageSftpCredentials',
  UpdateAuthorizedContacts = 'updateAuthorizedContacts',
  UpdateBankingDetails = 'updateBankingDetails',
  UpdateCalls = 'updateCalls',
  UpdateConstructionToPerm = 'updateConstructionToPerm',
  UpdateEscrowDetails = 'updateEscrowDetails',
  UpdateInterestRate = 'updateInterestRate',
  UpdateLoanData = 'updateLoanData',
  UpdateLoanIdsAndRemittance = 'updateLoanIdsAndRemittance',
  UpdateLoanStatus = 'updateLoanStatus',
  UpdateMaturityDate = 'updateMaturityDate',
  UpdateStopSettings = 'updateStopSettings'
}

export type Phone = {
  __typename?: 'Phone';
  cell?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PortalCompany = {
  __typename?: 'PortalCompany';
  address?: Maybe<Address>;
  adminSettings: PortalCompanyAdminSettings;
  customFAQ: Array<CustomFaqSection>;
  id: Scalars['CompanyId']['output'];
  logos: CompanyLogos;
  name: Scalars['String']['output'];
  paymentsPaused: Scalars['Boolean']['output'];
  portalSettings: PortalSettings;
  supportEmail: Scalars['String']['output'];
  supportHours?: Maybe<SupportHours>;
  supportPhone: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type PortalCompanyAdminSettings = {
  __typename?: 'PortalCompanyAdminSettings';
  applicationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  applicationsEnabledSettings?: Maybe<PortalCompanyAdminSettingsApplications>;
  autopayEnabled?: Maybe<Scalars['Boolean']['output']>;
  econsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  exactPaymentsOnly?: Maybe<Scalars['Boolean']['output']>;
  manualNachaFileGeneration?: Maybe<Scalars['Boolean']['output']>;
  portalBalanceForward?: Maybe<Scalars['Boolean']['output']>;
  repayEnabled?: Maybe<Scalars['Boolean']['output']>;
  whedaEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PortalCompanyAdminSettingsApplications = {
  __typename?: 'PortalCompanyAdminSettingsApplications';
  ladderLife: Scalars['Boolean']['output'];
};

export type PortalLoan = {
  __typename?: 'PortalLoan';
  achAccounts: Array<BorrowerAchAccount>;
  additionalBorrowers: Array<Borrower>;
  address: Address;
  authorizedContacts: Array<AuthorizedContact>;
  company: PortalCompany;
  configuration: Configuration;
  currentSnapshot: PortalLoanSnapshot;
  entity?: Maybe<Entity>;
  id: Scalars['LoanId']['output'];
  losId: Scalars['LosId']['output'];
  messageViews?: Maybe<BorrowerMessageViews>;
  originalAmount: Scalars['Float']['output'];
  primaryBorrower: Borrower;
  repayAccounts: Array<RepayAccount>;
  wireSettings?: Maybe<CompanyWireSettings>;
};

export type PortalLoanSnapshot = {
  __typename?: 'PortalLoanSnapshot';
  activeWorkoutPlan?: Maybe<WorkoutPlan>;
  amortizationMonth: Scalars['Int']['output'];
  autopaySettings?: Maybe<AutopaySettings>;
  chargeAmountDue: Scalars['Float']['output'];
  charges: Array<Charge>;
  creditRemaining: Scalars['Float']['output'];
  currentBillSettingsType: LoanBillSettingsType;
  currentPaymentConfig: CurrentPaymentConfig;
  delinquentInterestSettings: Array<DelinquentInterestSetting>;
  disbursements: Array<Disbursement>;
  documents: Array<Document>;
  drawsEnabled: Scalars['Boolean']['output'];
  escrowShortageAnalysisId?: Maybe<Scalars['EscrowPaymentHistoryItemId']['output']>;
  expectedPayoffTotal: Scalars['Float']['output'];
  hasMortgageInsurance: Scalars['Boolean']['output'];
  hasOpenDrawRequest: Scalars['Boolean']['output'];
  interestRateChangeHistory: Array<InterestRateChange>;
  isDrawable: Scalars['Boolean']['output'];
  isEligibleForAutomatedPayoff: Scalars['Boolean']['output'];
  isFullInterestOnlyLoan: Scalars['Boolean']['output'];
  loanId: Scalars['LoanId']['output'];
  loanStatus: LoanStatus;
  maturityConfig: MaturityConfig;
  maxLineOfCredit: Scalars['Float']['output'];
  nextPaymentDueDate?: Maybe<Scalars['GqlDate']['output']>;
  nextStatementDate: Scalars['GqlDate']['output'];
  offeredWorkoutPlans: Array<WorkoutPlan>;
  openPayoffStatus?: Maybe<OpenPayoffStatus>;
  originationData?: Maybe<OriginationData>;
  paymentDueStatus: PaymentDueStatus;
  paymentDueSubStatus: PaymentDueSubStatus;
  paymentToPaymentDue: Array<PaymentToPaymentDue>;
  payments: Array<Payment>;
  paymentsDue: Array<PaymentDue>;
  payoffs: Array<Payoff>;
  properties: Array<Property>;
  shortageAmount: Scalars['Float']['output'];
  snapshot: PaymentSnapshot;
  spreadMonths: Scalars['Int']['output'];
  stopSettings: StopSettings;
  totalAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalAmountRemainingFromCredit: Scalars['Float']['output'];
  totalFutureAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalPastDueAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalStatementAmountDue: Scalars['Float']['output'];
  totalUpcomingAmountRemainingFromBorrower: Scalars['Float']['output'];
  totalWorkoutPlanAmountRemainingFromBorrower?: Maybe<Scalars['Float']['output']>;
  transactionActivities: Array<TransactionActivity>;
  transferData?: Maybe<TransferData>;
};

export enum PortalPaymentStopSettingType {
  Any = 'any',
  Exact = 'exact',
  None = 'none'
}

export type PortalSettings = {
  __typename?: 'PortalSettings';
  borrowerPayments: BorrowerPaymentSettings;
  borrowerRequests: BorrowerRequestSettings;
  emailGreeting?: Maybe<Scalars['String']['output']>;
  loanDetails: LoanDetailsSettings;
  primaryColor?: Maybe<Scalars['String']['output']>;
};

export type PortalSettingsStatementPdf = {
  __typename?: 'PortalSettingsStatementPdf';
  footer?: Maybe<Scalars['String']['output']>;
};

export type PortalUser = {
  __typename?: 'PortalUser';
  acceptedTerms: Scalars['Boolean']['output'];
  banks: Array<DwollaBank>;
  bannerMessages: Array<BannerMessage>;
  borrowerId: Scalars['BorrowerId']['output'];
  dwollaBorrowerUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['PortalUserId']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  linkToken?: Maybe<Scalars['String']['output']>;
  loan: PortalLoan;
  loans: Array<PortalLoan>;
  microDepositVerification: Scalars['Boolean']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Phone;
  requiredTosVersion: Scalars['Int']['output'];
  suffix?: Maybe<Scalars['String']['output']>;
};


export type PortalUserLoanArgs = {
  loanId: Scalars['LoanId']['input'];
};

export type PortalUserActionResponse = {
  __typename?: 'PortalUserActionResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  portalUser: PortalUser;
};

export type PreviousServicer = {
  __typename?: 'PreviousServicer';
  lenderEmail?: Maybe<Scalars['String']['output']>;
  lenderName?: Maybe<Scalars['String']['output']>;
  lenderPhone?: Maybe<Scalars['String']['output']>;
  purchaseDate?: Maybe<Scalars['GqlDate']['output']>;
  purchasedEscrowBalance?: Maybe<Scalars['Float']['output']>;
  purchasedReserveBalance?: Maybe<Scalars['Float']['output']>;
};

export type PrincipalModification = Modification & {
  __typename?: 'PrincipalModification';
  amount: Scalars['Float']['output'];
  collectionType: PrincipalModificationCollectionType;
  effectiveDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['PrincipalModificationId']['output'];
  isFederalGovernmentPlan: Scalars['Boolean']['output'];
  isRecast: Scalars['Boolean']['output'];
  status: ModificationStatus;
  type: ModificationType;
};

export type PrincipalModificationAppliedDocument = Document & {
  __typename?: 'PrincipalModificationAppliedDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  principalModificationId: Scalars['PrincipalModificationId']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PrincipalModificationCancelledDocument = Document & {
  __typename?: 'PrincipalModificationCancelledDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  principalModificationId: Scalars['PrincipalModificationId']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum PrincipalModificationCollectionType {
  Deferred = 'DEFERRED',
  Waived = 'WAIVED'
}

export type PrincipalPrepaymentBreakdown = PaymentToPaymentDue & {
  __typename?: 'PrincipalPrepaymentBreakdown';
  additionalPrincipal: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  paymentId: Scalars['PaymentId']['output'];
  reserve: Scalars['Float']['output'];
  type: PaymentToPaymentDueType;
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export enum ProductType {
  Bridge = 'bridge',
  BusinessPurpose = 'businessPurpose',
  Conv = 'conv',
  Fha = 'fha',
  Heloc = 'heloc',
  Jumbo = 'jumbo',
  Pih = 'pih',
  Usda = 'usda',
  Va = 'va'
}

export type Property = {
  __typename?: 'Property';
  address: Address;
  id: Scalars['PropertyId']['output'];
  isReleased: Scalars['Boolean']['output'];
};

export enum QrpcOccupancyStatus {
  Abandoned = 'ABANDONED',
  BorrowerOccupied = 'BORROWER_OCCUPIED',
  OccupiedByUnknown = 'OCCUPIED_BY_UNKNOWN',
  TenantOccupied = 'TENANT_OCCUPIED',
  Unknown = 'UNKNOWN',
  Vacant = 'VACANT'
}

export enum QrpcReason {
  AbandonmentOfProperty = 'ABANDONMENT_OF_PROPERTY',
  BusinessFailure = 'BUSINESS_FAILURE',
  CasualtyLoss = 'CASUALTY_LOSS',
  CurtailmentOfIncome = 'CURTAILMENT_OF_INCOME',
  DeathOfBorrower = 'DEATH_OF_BORROWER',
  DeathOfBorrowersFamilyMember = 'DEATH_OF_BORROWERS_FAMILY_MEMBER',
  DisasterDamagedProperty = 'DISASTER_DAMAGED_PROPERTY',
  DistantEmploymentTransfer = 'DISTANT_EMPLOYMENT_TRANSFER',
  EligibleDisasterArea = 'ELIGIBLE_DISASTER_AREA',
  EnergyEnvironmentCost = 'ENERGY_ENVIRONMENT_COST',
  ExcessiveObligations = 'EXCESSIVE_OBLIGATIONS',
  Fraud = 'FRAUD',
  IllnessOfBorrower = 'ILLNESS_OF_BORROWER',
  IllnessOfBorrowersFamilyMember = 'ILLNESS_OF_BORROWERS_FAMILY_MEMBER',
  InabilityToRentProperty = 'INABILITY_TO_RENT_PROPERTY',
  InabilityToSellProperty = 'INABILITY_TO_SELL_PROPERTY',
  Incarceration = 'INCARCERATION',
  IncomeLossDueToDisaster = 'INCOME_LOSS_DUE_TO_DISASTER',
  MaritalDifficulties = 'MARITAL_DIFFICULTIES',
  MilitaryService = 'MILITARY_SERVICE',
  NationalEmergencyDeclaration = 'NATIONAL_EMERGENCY_DECLARATION',
  Other = 'OTHER',
  PaymentAdjustment = 'PAYMENT_ADJUSTMENT',
  PaymentDispute = 'PAYMENT_DISPUTE',
  PropertyProblem = 'PROPERTY_PROBLEM',
  ServicingProblems = 'SERVICING_PROBLEMS',
  TransferOfOwnershipPending = 'TRANSFER_OF_OWNERSHIP_PENDING',
  UnableToContactBorrower = 'UNABLE_TO_CONTACT_BORROWER',
  UnableToContactBorrowerDisaster = 'UNABLE_TO_CONTACT_BORROWER_DISASTER',
  Unemployment = 'UNEMPLOYMENT'
}

export type Query = {
  __typename?: 'Query';
  getChatMessage: LoanChatMessage;
  getChatMessages: LoanChatMessages;
  portalSelf: PortalUser;
};


export type QueryGetChatMessageArgs = {
  loanId: Scalars['LoanId']['input'];
  messageId: Scalars['LoanChatMessageId']['input'];
};


export type QueryGetChatMessagesArgs = {
  loanId: Scalars['LoanId']['input'];
};


export type QueryPortalSelfArgs = {
  userId?: InputMaybe<Scalars['BorrowerId']['input']>;
};

export type RecordWriteoffInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  corporateAdvances: Scalars['Float']['input'];
  effectiveDate: Scalars['GqlIsoDate']['input'];
  escrow: Scalars['Float']['input'];
  fees: Scalars['Float']['input'];
  interest: Scalars['Float']['input'];
  principal: Scalars['Float']['input'];
  suspense: Scalars['Float']['input'];
};

export type RepayAccount = {
  __typename?: 'RepayAccount';
  accountName: Scalars['String']['output'];
  addedByCompany: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['RepayAccountId']['output'];
  lastFour: Scalars['String']['output'];
  payAccountId: Scalars['String']['output'];
};

export type RepayAutopaySettings = {
  __typename?: 'RepayAutopaySettings';
  accountId: Scalars['RepayAccountId']['output'];
  actor?: Maybe<Actor>;
  borrowerId: Scalars['BorrowerId']['output'];
  dayOfTheMonth?: Maybe<Scalars['Int']['output']>;
  type: AutopaySettingsType;
};

export type RepayAutopaySettingsInput = {
  accountId: Scalars['RepayAccountId']['input'];
  dayOfTheMonth: Scalars['Int']['input'];
  portalUserId: Scalars['PortalUserId']['input'];
};

export type RepaymentArrearagesBreakdown = {
  __typename?: 'RepaymentArrearagesBreakdown';
  escrow: Scalars['Float']['output'];
  feesAndAdvances: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  monthlyPaymentAmount: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
  statementSuspenseCredit: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export enum RepaymentPlanCancellationReason {
  EvaluatingForDeferment = 'EVALUATING_FOR_DEFERMENT',
  EvaluatingForDisasterDeferment = 'EVALUATING_FOR_DISASTER_DEFERMENT',
  EvaluatingForDisasterFlexMod = 'EVALUATING_FOR_DISASTER_FLEX_MOD',
  EvaluatingForFlexMod = 'EVALUATING_FOR_FLEX_MOD',
  InsufficientPayments = 'INSUFFICIENT_PAYMENTS',
  LoanReinstated = 'LOAN_REINSTATED',
  NoLongerEligible = 'NO_LONGER_ELIGIBLE',
  Other = 'OTHER',
  ReferringToForeclosure = 'REFERRING_TO_FORECLOSURE'
}

export type RepaymentWorkoutPlan = WorkoutPlan & {
  __typename?: 'RepaymentWorkoutPlan';
  arrearageBreakdown: RepaymentArrearagesBreakdown;
  cancellationReason?: Maybe<RepaymentPlanCancellationReason>;
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  chargeIds: Array<Scalars['FeeId']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  contractualMonthlyPaymentAmount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  dAmountPaid: Scalars['Float']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  endStatementDate: Scalars['GqlIsoDate']['output'];
  hasFees: Scalars['Boolean']['output'];
  id: Scalars['WorkoutPlanId']['output'];
  planIncreaseDecimal: Scalars['Float']['output'];
  planPaymentsDue: Array<WorkoutPlanPaymentDue>;
  repaymentMonthlyAmount: Scalars['Float']['output'];
  startDate: Scalars['GqlIsoDate']['output'];
  startStatementDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  termMonths: Scalars['Int']['output'];
  terminationDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
  workflowInformation?: Maybe<WorkoutPlanWorkflowInformation>;
};

export type SortBy = {
  key: Scalars['String']['input'];
  order: Scalars['String']['input'];
};

export type StandardAdvanceConfig = {
  __typename?: 'StandardAdvanceConfig';
  advanceCategory?: Maybe<AdvanceCategory>;
  advanceCategoryDetail?: Maybe<Scalars['String']['output']>;
  advanceType: AdvanceType;
  interestRate: Scalars['Float']['output'];
};

export type StandardInterestAttribution = Attribution & {
  __typename?: 'StandardInterestAttribution';
  dailyInterestRate: Scalars['Float']['output'];
  days: Scalars['Int']['output'];
  endOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  interest: Scalars['Float']['output'];
  isDeferred?: Maybe<Scalars['Boolean']['output']>;
  isWaived?: Maybe<Scalars['Boolean']['output']>;
  periodInterestRate?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<Scalars['GqlTimestamp']['output']>;
  startOfPeriodPrincipal: Scalars['Float']['output'];
  type: AttributionType;
};

export type Statement = {
  __typename?: 'Statement';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type StatementBreakdown = PaymentToPaymentDue & {
  __typename?: 'StatementBreakdown';
  additionalEscrow: Scalars['Float']['output'];
  additionalPrincipal: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  escrow: Scalars['Float']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  futureStatementSuspense: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  interest: Scalars['Float']['output'];
  paymentDueId: Scalars['PaymentDueId']['output'];
  paymentId: Scalars['PaymentId']['output'];
  principal: Scalars['Float']['output'];
  reserve: Scalars['Float']['output'];
  suspense: Scalars['Float']['output'];
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type StopSettings = {
  __typename?: 'StopSettings';
  advancesPaused: Scalars['Boolean']['output'];
  advancesPausedUntilDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  documentAccessPaused: Scalars['Boolean']['output'];
  drawsPaused: Scalars['Boolean']['output'];
  emailsPaused: Scalars['Boolean']['output'];
  miCancellationReviewReason?: Maybe<Scalars['String']['output']>;
  miCancellationReviewRequired?: Maybe<Scalars['Boolean']['output']>;
  miDisbursementsPaused?: Maybe<Scalars['Boolean']['output']>;
  omitFromDelinquentInterestAutomation: Scalars['Boolean']['output'];
  omitFromInterestOnEscrow: Scalars['Boolean']['output'];
  omitFromLateFeeAutomation: Scalars['Boolean']['output'];
  omitFromPayoffAutomation: Scalars['Boolean']['output'];
  portalPayments: PortalPaymentStopSettingType;
};

/**
 * A response that indicates the operation was successful.
 *
 * Consider using `SuccessResponseWithFailureReason` for operations that may fail
 * due to user input (i.e. what would be consider a 4xx-class HTTP response) and
 * reserving thrown exceptions for truly unexpected errors (i.e. 5xx-class HTTP
 * response). This will help us differentiate between the two cases for logging,
 * alerting, etc.
 */
export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * A response that indicates the operation was successful or failed.
 *
 * Use this for operations that may fail due to user input (i.e. what would be
 * considered a 4xx-class HTTP response) to preserve the distinction between
 * user-recoverable errors (which should probably not be logged & alerted as true
 * application errors) and truly unexpected errors (which should be).
 */
export type SuccessResponseWithFailureReason = {
  __typename?: 'SuccessResponseWithFailureReason';
  failureReason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SupportHours = {
  __typename?: 'SupportHours';
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
};

export type SuspenseBreakdown = PaymentToPaymentDue & {
  __typename?: 'SuspenseBreakdown';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  futureStatementSuspense: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  paymentId: Scalars['PaymentId']['output'];
  suspense: Scalars['Float']['output'];
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type TaxDetails = {
  __typename?: 'TaxDetails';
  backupWithholdingAmount?: Maybe<Scalars['Float']['output']>;
  backupWithholdingRequired?: Maybe<Scalars['Boolean']['output']>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
};

export type TaxEscrowDue = EscrowDue & {
  __typename?: 'TaxEscrowDue';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Scalars['GqlDate']['output']>;
  escrowSettingId: Scalars['EscrowSettingId']['output'];
  escrowed: Scalars['Boolean']['output'];
  estimatedAmount?: Maybe<Scalars['Float']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['EscrowDueId']['output'];
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  taxType: TaxEscrowType;
  type: EscrowType;
};

export type TaxEscrowSetting = EscrowSetting & {
  __typename?: 'TaxEscrowSetting';
  amount: Scalars['Float']['output'];
  apn?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  dueDates: Array<Scalars['String']['output']>;
  escrowed: Scalars['Boolean']['output'];
  id: Scalars['EscrowSettingId']['output'];
  payee: Payee;
  propertyId: Scalars['PropertyId']['output'];
  status: EscrowSettingStatus;
  taxType: TaxEscrowType;
  type: EscrowSettingType;
};

export enum TaxEscrowType {
  CityTax = 'CITY_TAX',
  CountyTax = 'COUNTY_TAX',
  OtherTax = 'OTHER_TAX',
  SchoolTax = 'SCHOOL_TAX',
  TownTax = 'TOWN_TAX',
  VillageTax = 'VILLAGE_TAX'
}

export type ThirdPartyAuthorizedContact = AuthorizedContact & {
  __typename?: 'ThirdPartyAuthorizedContact';
  companyName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['AuthorizedContactId']['output'];
  lastName: Scalars['String']['output'];
  type: AuthorizedContactType;
};

export type ThirdPartyBreakdown = PaymentToPaymentDue & {
  __typename?: 'ThirdPartyBreakdown';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['GqlIsoDateTime']['output'];
  escrow: Scalars['Float']['output'];
  event: PaymentBreakdownEvent;
  expectedPayment: Scalars['Float']['output'];
  holdback: Scalars['Float']['output'];
  id?: Maybe<Scalars['PaymentBreakdownId']['output']>;
  lossDraft: Scalars['Float']['output'];
  paymentId: Scalars['PaymentId']['output'];
  principal: Scalars['Float']['output'];
  suspense?: Maybe<Scalars['Float']['output']>;
  type: PaymentToPaymentDueType;
  unappliedSuspense: Scalars['Float']['output'];
  voidedBreakdownId?: Maybe<Scalars['PaymentBreakdownId']['output']>;
};

export type ThirdPartyPayer = {
  __typename?: 'ThirdPartyPayer';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum Timezone {
  AmericaChicago = 'America__Chicago',
  AmericaDenver = 'America__Denver',
  AmericaLosAngeles = 'America__Los_Angeles',
  AmericaNewYork = 'America__New_York'
}

export type TotalPaid = {
  __typename?: 'TotalPaid';
  escrow: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type TrackedPaidOffRecord = PaidOffRecord & {
  __typename?: 'TrackedPaidOffRecord';
  id: Scalars['PayoffId']['output'];
  payoffDate: Scalars['GqlDate']['output'];
  payoffRecord: PayoffRecord;
  payoffType: PaidOffType;
};

export type TransactionActivity = {
  __typename?: 'TransactionActivity';
  amount: Scalars['String']['output'];
  date: Scalars['String']['output'];
  isFailed?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  subAmount?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TransferData = {
  __typename?: 'TransferData';
  correspondenceAddress?: Maybe<Address>;
  legalTransferEffectiveDate: Scalars['GqlIsoDate']['output'];
  loanOfficerEmail?: Maybe<Scalars['String']['output']>;
  loanOfficerName?: Maybe<Scalars['String']['output']>;
  nextServicerCollectsLatePayments: Scalars['Boolean']['output'];
  paymentAddress: Address;
  phone: Scalars['String']['output'];
  phoneExtension?: Maybe<Scalars['String']['output']>;
  servicerHours1?: Maybe<Scalars['String']['output']>;
  servicerHours2?: Maybe<Scalars['String']['output']>;
  servicerHours3?: Maybe<Scalars['String']['output']>;
  servicerLoanNumber: Scalars['String']['output'];
  servicerName: Scalars['String']['output'];
  servicerWebsite?: Maybe<Scalars['String']['output']>;
  transferEffectiveDate: Scalars['GqlIsoDate']['output'];
};

export type UntrackedPaidOffRecord = PaidOffRecord & {
  __typename?: 'UntrackedPaidOffRecord';
  id: Scalars['PayoffId']['output'];
  payoffDate: Scalars['GqlDate']['output'];
  payoffType: PaidOffType;
};

export type UploadDocument = Document & {
  __typename?: 'UploadDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type UsioAccount = {
  __typename?: 'UsioAccount';
  confirmationId: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['UsioAccountId']['output'];
  name: Scalars['String']['output'];
};

export type UsioAutopaySettings = {
  __typename?: 'UsioAutopaySettings';
  actor?: Maybe<Actor>;
  borrowerId: Scalars['BorrowerId']['output'];
  confirmationId: Scalars['String']['output'];
  dayOfTheMonth?: Maybe<Scalars['Int']['output']>;
  type: AutopaySettingsType;
};

export type VerificationOfMortgageDocument = Document & {
  __typename?: 'VerificationOfMortgageDocument';
  createdAt: Scalars['GqlTimestamp']['output'];
  id: Scalars['DocumentId']['output'];
  isArchived: Scalars['Boolean']['output'];
  type: DocumentType;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum VerificationOfMortgagePurpose {
  NewLoanApplication = 'NEW_LOAN_APPLICATION',
  Other = 'OTHER',
  Refinance = 'REFINANCE'
}

export type VerificationOfMortgageRequestInput = {
  companyName: Scalars['String']['input'];
  isAssumable?: InputMaybe<Scalars['Boolean']['input']>;
  otherPurpose?: InputMaybe<Scalars['String']['input']>;
  purpose: VerificationOfMortgagePurpose;
  recipientAddress: AddressInput;
  recipientName: Scalars['String']['input'];
};

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WorkoutPlan = {
  cancelledDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  completedDate?: Maybe<Scalars['GqlIsoDate']['output']>;
  createdAt: Scalars['GqlIsoDateTime']['output'];
  endDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['WorkoutPlanId']['output'];
  startDate: Scalars['GqlIsoDate']['output'];
  status: WorkoutPlanStatus;
  type: WorkoutPlanType;
  updatedAt: Scalars['GqlIsoDateTime']['output'];
};

export type WorkoutPlanIneligibleModificationInput = {
  reason: Scalars['String']['input'];
  type: WorkoutPlanType;
};

export type WorkoutPlanIneligibleModifications = {
  __typename?: 'WorkoutPlanIneligibleModifications';
  reason: Scalars['String']['output'];
  type: WorkoutPlanType;
};

export type WorkoutPlanPaymentDue = {
  __typename?: 'WorkoutPlanPaymentDue';
  dStatus: WorkoutPlanPaymentDueStatus;
  paymentDate: Scalars['GqlIsoDate']['output'];
  total: Scalars['Float']['output'];
};

export type WorkoutPlanPaymentDueStatus = {
  __typename?: 'WorkoutPlanPaymentDueStatus';
  amountRemaining: Scalars['Float']['output'];
  fulfilledAt?: Maybe<Scalars['GqlIsoDate']['output']>;
  isLate: Scalars['Boolean']['output'];
  paymentMadeIds: Array<Scalars['PaymentId']['output']>;
};

export enum WorkoutPlanReason {
  NaturalDisaster = 'NATURAL_DISASTER'
}

export enum WorkoutPlanStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Offered = 'OFFERED'
}

export enum WorkoutPlanType {
  BankruptcyCh13 = 'BANKRUPTCY_CH13',
  FlexModification = 'FLEX_MODIFICATION',
  Forbearance = 'FORBEARANCE',
  PaymentDeferment = 'PAYMENT_DEFERMENT',
  PaymentDeferral = 'PAYMENT_DEFERRAL',
  RepaymentPlan = 'REPAYMENT_PLAN'
}

export type WorkoutPlanWorkflowInformation = {
  __typename?: 'WorkoutPlanWorkflowInformation';
  completedBorrowerResponsePackageReceived: Scalars['Boolean']['output'];
  ineligibleModifications: Array<WorkoutPlanIneligibleModifications>;
};

export type Writeoff = {
  __typename?: 'Writeoff';
  amounts: WriteoffAmounts;
  comment?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['GqlIsoDate']['output'];
  id: Scalars['WriteoffId']['output'];
};

export type WriteoffAmounts = {
  __typename?: 'WriteoffAmounts';
  corporateAdvances: Scalars['Float']['output'];
  escrow: Scalars['Float']['output'];
  fees: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  principal: Scalars['Float']['output'];
  suspense: Scalars['Float']['output'];
};

export type PortalActorFragment = { __typename?: 'Actor', id: string, type: ActorType };

type PortalAutopaySettings_DwollaAutopaySettings_Fragment = { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null };

type PortalAutopaySettings_NachaAutopaySettings_Fragment = { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null };

type PortalAutopaySettings_RepayAutopaySettings_Fragment = { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null };

type PortalAutopaySettings_UsioAutopaySettings_Fragment = { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null };

export type PortalAutopaySettingsFragment = PortalAutopaySettings_DwollaAutopaySettings_Fragment | PortalAutopaySettings_NachaAutopaySettings_Fragment | PortalAutopaySettings_RepayAutopaySettings_Fragment | PortalAutopaySettings_UsioAutopaySettings_Fragment;

export type PortalBannerMessageFragment = { __typename?: 'BannerMessage', id: any, message: string, createdAt: TGqlIsoDateTime, updatedAt: TGqlIsoDateTime };

export type BorrowerNameFragment = { __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, firstName: string, lastName: string, suffix?: string | null };

export type BorrowerNotificationSettingsFragment = { __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, emailConsent: boolean, emailNotificationsEnabled: boolean, paperNotificationsEnabled: boolean, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null };

export type BorrowersOnLoanFragment = { __typename?: 'PortalLoan', primaryBorrower: { __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, firstName: string, lastName: string, suffix?: string | null, emailConsent: boolean, emailNotificationsEnabled: boolean, paperNotificationsEnabled: boolean, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null }, additionalBorrowers: Array<{ __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, firstName: string, lastName: string, suffix?: string | null, emailConsent: boolean, emailNotificationsEnabled: boolean, paperNotificationsEnabled: boolean, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null }> };

export type PortalBorrowerAchAccountFragment = { __typename?: 'BorrowerAchAccount', id: any, accountName: string, lastFour: string, prenoteSubmittedAt?: any | null, disabledAt?: any | null, addedByCompany: boolean, createdAt: any };

type PortalCharge_Advance_Fragment = { __typename?: 'Advance', id: any, isDeferred: boolean, totalAmount: number, amountRemaining: number, status: FeeStatus, chargeDate: any, updatedAt?: any | null };

type PortalCharge_Fee_Fragment = { __typename?: 'Fee', id: any, isDeferred: boolean, totalAmount: number, amountRemaining: number, status: FeeStatus, chargeDate: any, updatedAt?: any | null, lineItems: Array<{ __typename?: 'FeeLineItem', id: any, amount: number, type: FeeType, name?: string | null }> };

export type PortalChargeFragment = PortalCharge_Advance_Fragment | PortalCharge_Fee_Fragment;

export type CompanyFragment = { __typename?: 'PortalCompany', id: CompanyId, name: string, paymentsPaused: boolean, supportEmail: string, supportPhone: string, website?: string | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null, supportHours?: { __typename?: 'SupportHours', line1?: string | null, line2?: string | null, line3?: string | null } | null, logos: { __typename?: 'CompanyLogos', portalLogoUrl?: string | null, emailLogoUrl?: string | null }, portalSettings: { __typename?: 'PortalSettings', primaryColor?: string | null, borrowerRequests: { __typename?: 'BorrowerRequestSettings', payoffRequestEnabled: boolean, drawRequestEnabled: boolean, generalInquiryEnabled: boolean, paymentAssistanceInquiryEnabled: boolean, escrowWaiverRequestEnabled: boolean, pmiCancellationRequestEnabled: boolean, verificationOfMortgageEnabled: boolean }, borrowerPayments: { __typename?: 'BorrowerPaymentSettings', allowPaymentsPastMaturity: boolean }, loanDetails: { __typename?: 'LoanDetailsSettings', loanOfficer: boolean, manageMailingAddress: boolean } }, adminSettings: { __typename?: 'PortalCompanyAdminSettings', autopayEnabled?: boolean | null, exactPaymentsOnly?: boolean | null, applicationsEnabled?: boolean | null, econsentEnabled?: boolean | null, whedaEnabled?: boolean | null, repayEnabled?: boolean | null, manualNachaFileGeneration?: boolean | null, applicationsEnabledSettings?: { __typename?: 'PortalCompanyAdminSettingsApplications', ladderLife: boolean } | null }, customFAQ: Array<{ __typename?: 'CustomFAQSection', title: string, items: Array<{ __typename?: 'CustomFAQItem', question: string, answer: string }> }> };

export type PortalCustomFaqSectionFragment = { __typename?: 'CustomFAQSection', title: string, items: Array<{ __typename?: 'CustomFAQItem', question: string, answer: string }> };

export type PortalCustomFaqItemFragment = { __typename?: 'CustomFAQItem', question: string, answer: string };

export type PortalDelinquentInterestSettingFragment = { __typename?: 'DelinquentInterestSetting', id: any, interestRate: number, startDate: TGqlIsoDate, endDate?: TGqlIsoDate | null, isDeferred: boolean, isWaived: boolean, createdAt: any, updatedAt: any };

type PortalDocument_DefermentWorkoutPlanDocument_Fragment = { __typename?: 'DefermentWorkoutPlanDocument', workoutPlanId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_DelinquentInterestAppliedDocument_Fragment = { __typename?: 'DelinquentInterestAppliedDocument', paymentConfigId?: any | null, delinquentInterestSettingId?: any | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_EscrowAnalysisDocument_Fragment = { __typename?: 'EscrowAnalysisDocument', effectiveDate: any, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_Form1098Document_Fragment = { __typename?: 'Form1098Document', year: string, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_GeneralDocument_Fragment = { __typename?: 'GeneralDocument', amount?: number | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_PayoffDocument_Fragment = { __typename?: 'PayoffDocument', payoffAmount: number, isExpired: boolean, expirationDate?: TGqlIsoDate | null, isPartial?: boolean | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_PrincipalModificationAppliedDocument_Fragment = { __typename?: 'PrincipalModificationAppliedDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_PrincipalModificationCancelledDocument_Fragment = { __typename?: 'PrincipalModificationCancelledDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_UploadDocument_Fragment = { __typename?: 'UploadDocument', title: string, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

type PortalDocument_VerificationOfMortgageDocument_Fragment = { __typename?: 'VerificationOfMortgageDocument', id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean };

export type PortalDocumentFragment = PortalDocument_DefermentWorkoutPlanDocument_Fragment | PortalDocument_DelinquentInterestAppliedDocument_Fragment | PortalDocument_EscrowAnalysisDocument_Fragment | PortalDocument_Form1098Document_Fragment | PortalDocument_GeneralDocument_Fragment | PortalDocument_PayoffDocument_Fragment | PortalDocument_PrincipalModificationAppliedDocument_Fragment | PortalDocument_PrincipalModificationCancelledDocument_Fragment | PortalDocument_UploadDocument_Fragment | PortalDocument_VerificationOfMortgageDocument_Fragment;

export type BorrowerMessageViewsFragment = { __typename?: 'BorrowerMessageViews', mailingAddressConfirmedAt?: TGqlIsoDateTime | null };

type PortalPayer_AuthorizedContactPayer_Fragment = { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string };

type PortalPayer_BorrowerPayer_Fragment = { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string };

type PortalPayer_EntityPayer_Fragment = { __typename?: 'EntityPayer', entityId: any, type: string };

type PortalPayer_ThirdPartyPayer_Fragment = { __typename?: 'ThirdPartyPayer', name: string, type: string };

export type PortalPayerFragment = PortalPayer_AuthorizedContactPayer_Fragment | PortalPayer_BorrowerPayer_Fragment | PortalPayer_EntityPayer_Fragment | PortalPayer_ThirdPartyPayer_Fragment;

export type PortalPaymentFragment = { __typename?: 'Payment', id: PaymentId, total: number, method: PaymentMethod, transactionId: string, paymentDate: any, status: PaymentStatus, canCancel: boolean, payer: { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string } | { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string } | { __typename?: 'EntityPayer', entityId: any, type: string } | { __typename?: 'ThirdPartyPayer', name: string, type: string } };

type PortalPaymentBreakdown_AdvanceBreakdown_Fragment = { __typename?: 'AdvanceBreakdown', feeId: any, advance: number, advanceInterest: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_BalanceReallocationBreakdown_Fragment = { __typename?: 'BalanceReallocationBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_FeeBreakdown_Fragment = { __typename?: 'FeeBreakdown', feeId: any, fees: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_PayoffBreakdown_Fragment = { __typename?: 'PayoffBreakdown', payoffId: any, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_PrincipalPrepaymentBreakdown_Fragment = { __typename?: 'PrincipalPrepaymentBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_StatementBreakdown_Fragment = { __typename?: 'StatementBreakdown', paymentDueId: PaymentDueId, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_SuspenseBreakdown_Fragment = { __typename?: 'SuspenseBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

type PortalPaymentBreakdown_ThirdPartyBreakdown_Fragment = { __typename?: 'ThirdPartyBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number };

export type PortalPaymentBreakdownFragment = PortalPaymentBreakdown_AdvanceBreakdown_Fragment | PortalPaymentBreakdown_BalanceReallocationBreakdown_Fragment | PortalPaymentBreakdown_FeeBreakdown_Fragment | PortalPaymentBreakdown_PayoffBreakdown_Fragment | PortalPaymentBreakdown_PrincipalPrepaymentBreakdown_Fragment | PortalPaymentBreakdown_StatementBreakdown_Fragment | PortalPaymentBreakdown_SuspenseBreakdown_Fragment | PortalPaymentBreakdown_ThirdPartyBreakdown_Fragment;

export type PortalPaymentDueFragment = { __typename?: 'PaymentDue', id: PaymentDueId, total: number, principal: number, interest: number, escrow: number, reserveCredit?: number | null, paymentDate: any, statementDate: any, escrowShortage?: number | null, status: { __typename?: 'PaymentDueSnapshot', amountRemainingFromBorrower: number, amountRemainingFromCredit: number, totalAmountRemaining: number, fulfilled: boolean, isLate: boolean, workoutPlanType?: WorkoutPlanType | null, billingStatus: BillingStatus }, statements: Array<{ __typename?: 'Statement', version: number, createdAt: any }> };

export type PortalPayoffFragment = { __typename?: 'Payoff', id: any, totalDue: number, status: PayoffStatus, expirationDate: any };

export type PortalAddressFragment = { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string };

type PortalAuthorizedContact_BuilderAuthorizedContact_Fragment = { __typename: 'BuilderAuthorizedContact', id: AuthorizedContactId, type: AuthorizedContactType, builderCompanyName: string };

type PortalAuthorizedContact_ThirdPartyAuthorizedContact_Fragment = { __typename: 'ThirdPartyAuthorizedContact', firstName: string, lastName: string, id: AuthorizedContactId, type: AuthorizedContactType, thirdPartyCompanyName?: string | null };

export type PortalAuthorizedContactFragment = PortalAuthorizedContact_BuilderAuthorizedContact_Fragment | PortalAuthorizedContact_ThirdPartyAuthorizedContact_Fragment;

export type PortalBankFragment = { __typename?: 'DwollaBank', name: string, isAutopayAuthorized: boolean, links: { __typename?: 'DwollaUrls', self: string } };

export type PortalWireSettingsFragment = { __typename?: 'CompanyWireSettings', bankName: string, bankRoutingNumber: string, accountName: string, accountNumber: string, instructions?: string | null, bankAddress: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } };

export type PortalPropertyFragment = { __typename?: 'Property', id: PropertyId, isReleased: boolean, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } };

export type PortalRepayAccountFragment = { __typename?: 'RepayAccount', id: RepayAccountId, payAccountId: string, accountName: string, lastFour: string, disabled: boolean, addedByCompany: boolean };

export type PortalStopSettingsFragment = { __typename?: 'StopSettings', portalPayments: PortalPaymentStopSettingType, emailsPaused: boolean, documentAccessPaused: boolean, drawsPaused: boolean };

export type PortalDayAndTimeRangeFragment = { __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone };

export type PortalTransferDataFragment = { __typename?: 'TransferData', servicerName: string, servicerLoanNumber: string, transferEffectiveDate: TGqlIsoDate, legalTransferEffectiveDate: TGqlIsoDate, phone: string, servicerWebsite?: string | null, servicerHours1?: string | null, servicerHours2?: string | null, servicerHours3?: string | null, loanOfficerName?: string | null, loanOfficerEmail?: string | null, nextServicerCollectsLatePayments: boolean, paymentAddress: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string }, correspondenceAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null };

type PortalWorkoutPlan_BankruptcyCh13WorkoutPlan_Fragment = { __typename: 'BankruptcyCh13WorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate };

type PortalWorkoutPlan_DefermentWorkoutPlan_Fragment = { __typename: 'DefermentWorkoutPlan', principalAmount: number, interestAmount: number, feeAmount: number, escrowAmount: number, totalAmount: number, hasPrincipalAndInterest: boolean, hasFees: boolean, hasEscrow: boolean, paymentDueIds: Array<PaymentDueId>, chargeIds: Array<any>, reason?: WorkoutPlanReason | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate };

type PortalWorkoutPlan_FlexModificationWorkoutPlan_Fragment = { __typename: 'FlexModificationWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> };

type PortalWorkoutPlan_ForbearanceWorkoutPlan_Fragment = { __typename: 'ForbearanceWorkoutPlan', forbearanceType: ForbearanceType, terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, forbearanceCancellationReason?: ForbearanceCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> };

type PortalWorkoutPlan_PaymentDeferralWorkoutPlan_Fragment = { __typename: 'PaymentDeferralWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate };

type PortalWorkoutPlan_RepaymentWorkoutPlan_Fragment = { __typename: 'RepaymentWorkoutPlan', terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, repaymentCancellationReason?: RepaymentPlanCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> };

export type PortalWorkoutPlanFragment = PortalWorkoutPlan_BankruptcyCh13WorkoutPlan_Fragment | PortalWorkoutPlan_DefermentWorkoutPlan_Fragment | PortalWorkoutPlan_FlexModificationWorkoutPlan_Fragment | PortalWorkoutPlan_ForbearanceWorkoutPlan_Fragment | PortalWorkoutPlan_PaymentDeferralWorkoutPlan_Fragment | PortalWorkoutPlan_RepaymentWorkoutPlan_Fragment;

export type PortalWorkoutPlanPaymentDueFragment = { __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } };

export type AcceptTermsMutationVariables = Exact<{
  emailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  tosVersion: Scalars['Int']['input'];
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms: { __typename?: 'PortalUser', id: PortalUserId, acceptedTerms: boolean, linkToken?: string | null } };

export type CancelPaymentMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  paymentId: Scalars['PaymentId']['input'];
}>;


export type CancelPaymentMutation = { __typename?: 'Mutation', cancelPayment: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, payments: Array<{ __typename?: 'Payment', id: PaymentId, total: number, method: PaymentMethod, transactionId: string, paymentDate: any, status: PaymentStatus, canCancel: boolean, payer: { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string } | { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string } | { __typename?: 'EntityPayer', entityId: any, type: string } | { __typename?: 'ThirdPartyPayer', name: string, type: string } }> } } };

export type ConfirmMessageViewMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  messageKey: BorrowerMessageKey;
}>;


export type ConfirmMessageViewMutation = { __typename?: 'Mutation', confirmMessageView: { __typename?: 'PortalLoan', id: LoanId } };

export type CreatePortalBorrowerAchAccountMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  input: CreatePortalBorrowerAchAccountInput;
}>;


export type CreatePortalBorrowerAchAccountMutation = { __typename?: 'Mutation', createPortalBorrowerAchAccount: { __typename?: 'PortalLoan', id: LoanId, achAccounts: Array<{ __typename?: 'BorrowerAchAccount', id: any, accountName: string, lastFour: string, prenoteSubmittedAt?: any | null, disabledAt?: any | null, addedByCompany: boolean, createdAt: any }> } };

export type CreateRepayAccountMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  input: CreateRepayAccountInput;
}>;


export type CreateRepayAccountMutation = { __typename?: 'Mutation', createRepayAccount: { __typename?: 'PortalLoan', id: LoanId, repayAccounts: Array<{ __typename?: 'RepayAccount', id: RepayAccountId, payAccountId: string, accountName: string, lastFour: string, disabled: boolean, addedByCompany: boolean }> } };

export type DeletePortalBorrowerAchAccountMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  accountId: Scalars['BorrowerAchAccountId']['input'];
}>;


export type DeletePortalBorrowerAchAccountMutation = { __typename?: 'Mutation', deletePortalBorrowerAchAccount: { __typename?: 'PortalLoan', id: LoanId, achAccounts: Array<{ __typename?: 'BorrowerAchAccount', id: any, accountName: string, lastFour: string, prenoteSubmittedAt?: any | null, disabledAt?: any | null, addedByCompany: boolean, createdAt: any }> } };

export type DeleteRepayAccountMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  accountId: Scalars['RepayAccountId']['input'];
}>;


export type DeleteRepayAccountMutation = { __typename?: 'Mutation', deleteRepayAccount: { __typename?: 'PortalLoan', id: LoanId, repayAccounts: Array<{ __typename?: 'RepayAccount', id: RepayAccountId, payAccountId: string, accountName: string, lastFour: string, disabled: boolean, addedByCompany: boolean }> } };

export type DrawRequestMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  amount: Scalars['Float']['input'];
  date: Scalars['GqlDate']['input'];
  message: Scalars['String']['input'];
}>;


export type DrawRequestMutation = { __typename?: 'Mutation', drawRequest: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, hasOpenDrawRequest: boolean } } };

export type EditBorrowerDetailsMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  input: BorrowerEditInput;
}>;


export type EditBorrowerDetailsMutation = { __typename?: 'Mutation', editBorrowerDetails: { __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null } };

export type EscrowWaiverRequestMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  waivedItems: Array<EscrowWaiverRequestType> | EscrowWaiverRequestType;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type EscrowWaiverRequestMutation = { __typename?: 'Mutation', escrowWaiverRequest: { __typename?: 'SuccessResponse', success: boolean } };

export type GeneralInquiryMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
}>;


export type GeneralInquiryMutation = { __typename?: 'Mutation', generalInquiry: { __typename?: 'SuccessResponse', success: boolean } };

export type GetChatMessageQueryVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  messageId: Scalars['LoanChatMessageId']['input'];
}>;


export type GetChatMessageQuery = { __typename?: 'Query', getChatMessage: { __typename?: 'LoanChatMessage', message: string, sentAt?: any | null, sender: LoanChatSender } };

export type GetChatMessagesQueryVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', getChatMessages: { __typename?: 'LoanChatMessages', records: Array<{ __typename?: 'LoanChatMessage', message: string, id: LoanChatMessageId, sentAt?: any | null, sender: LoanChatSender }> } };

export type GetDocumentUrlMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  documentId: Scalars['DocumentId']['input'];
}>;


export type GetDocumentUrlMutation = { __typename?: 'Mutation', getDocumentUrl: { __typename?: 'DownloadUrlResponse', url: string } };

export type GetPdfStatementUrlMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  paymentDueId: Scalars['PaymentDueId']['input'];
  version: Scalars['Int']['input'];
}>;


export type GetPdfStatementUrlMutation = { __typename?: 'Mutation', getPdfStatementUrl: { __typename?: 'DownloadUrlResponse', url: string } };

export type InitiateNachaPaymentMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  borrowerAchAccountId: Scalars['BorrowerAchAccountId']['input'];
  amount: Scalars['Float']['input'];
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
}>;


export type InitiateNachaPaymentMutation = { __typename?: 'Mutation', initiateNachaPayment: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, paymentsDue: Array<{ __typename?: 'PaymentDue', id: PaymentDueId, total: number, principal: number, interest: number, escrow: number, reserveCredit?: number | null, paymentDate: any, statementDate: any, escrowShortage?: number | null, status: { __typename?: 'PaymentDueSnapshot', amountRemainingFromBorrower: number, amountRemainingFromCredit: number, totalAmountRemaining: number, fulfilled: boolean, isLate: boolean, workoutPlanType?: WorkoutPlanType | null, billingStatus: BillingStatus }, statements: Array<{ __typename?: 'Statement', version: number, createdAt: any }> }>, payments: Array<{ __typename?: 'Payment', id: PaymentId, total: number, method: PaymentMethod, transactionId: string, paymentDate: any, status: PaymentStatus, canCancel: boolean, payer: { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string } | { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string } | { __typename?: 'EntityPayer', entityId: any, type: string } | { __typename?: 'ThirdPartyPayer', name: string, type: string } }>, paymentToPaymentDue: Array<{ __typename?: 'AdvanceBreakdown', feeId: any, advance: number, advanceInterest: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'BalanceReallocationBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'FeeBreakdown', feeId: any, fees: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PayoffBreakdown', payoffId: any, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PrincipalPrepaymentBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'StatementBreakdown', paymentDueId: PaymentDueId, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'SuspenseBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'ThirdPartyBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number }> } } };

export type InitiatePaymentMutationVariables = Exact<{
  borrowerBankUrl: Scalars['String']['input'];
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  amount: Scalars['Float']['input'];
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
}>;


export type InitiatePaymentMutation = { __typename?: 'Mutation', initiatePayment: { __typename?: 'DwollaPaymentResponse', transferUrl?: string | null } };

export type InitiateRepayPaymentMutationVariables = Exact<{
  repayAccountId: Scalars['RepayAccountId']['input'];
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  amount: Scalars['Float']['input'];
  additionalPrincipal?: InputMaybe<Scalars['Float']['input']>;
  additionalEscrow?: InputMaybe<Scalars['Float']['input']>;
  additionalSuspense?: InputMaybe<Scalars['Float']['input']>;
  escrowShortageAnalysisId?: InputMaybe<Scalars['EscrowPaymentHistoryItemId']['input']>;
}>;


export type InitiateRepayPaymentMutation = { __typename?: 'Mutation', initiateRepayPayment: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, paymentsDue: Array<{ __typename?: 'PaymentDue', id: PaymentDueId, total: number, principal: number, interest: number, escrow: number, reserveCredit?: number | null, paymentDate: any, statementDate: any, escrowShortage?: number | null, status: { __typename?: 'PaymentDueSnapshot', amountRemainingFromBorrower: number, amountRemainingFromCredit: number, totalAmountRemaining: number, fulfilled: boolean, isLate: boolean, workoutPlanType?: WorkoutPlanType | null, billingStatus: BillingStatus }, statements: Array<{ __typename?: 'Statement', version: number, createdAt: any }> }>, payments: Array<{ __typename?: 'Payment', id: PaymentId, total: number, method: PaymentMethod, transactionId: string, paymentDate: any, status: PaymentStatus, canCancel: boolean, payer: { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string } | { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string } | { __typename?: 'EntityPayer', entityId: any, type: string } | { __typename?: 'ThirdPartyPayer', name: string, type: string } }>, paymentToPaymentDue: Array<{ __typename?: 'AdvanceBreakdown', feeId: any, advance: number, advanceInterest: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'BalanceReallocationBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'FeeBreakdown', feeId: any, fees: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PayoffBreakdown', payoffId: any, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PrincipalPrepaymentBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'StatementBreakdown', paymentDueId: PaymentDueId, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'SuspenseBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'ThirdPartyBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number }> } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'SuccessResponse', success: boolean } };

export type PmiCancellationRequestMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  propertyValueType: PmiCancellationRequestPropertyValueType;
}>;


export type PmiCancellationRequestMutation = { __typename?: 'Mutation', pmiCancellationRequest: { __typename?: 'SuccessResponse', success: boolean } };

export type PaymentAssistanceInquiryMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
  quotedPastDueTotal: Scalars['Float']['input'];
}>;


export type PaymentAssistanceInquiryMutation = { __typename?: 'Mutation', paymentAssistanceInquiry: { __typename?: 'SuccessResponse', success: boolean } };

export type PostPlaidBankToDwollaMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  accountNickname: Scalars['String']['input'];
}>;


export type PostPlaidBankToDwollaMutation = { __typename?: 'Mutation', postPlaidBankToDwolla: { __typename?: 'PortalUser', id: PortalUserId, banks: Array<{ __typename?: 'DwollaBank', name: string, isAutopayAuthorized: boolean, links: { __typename?: 'DwollaUrls', self: string } }> } };

export type QueryChatBotMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
}>;


export type QueryChatBotMutation = { __typename?: 'Mutation', queryChatBot?: { __typename?: 'ChatBotResponse', message: string } | null };

export type RemoveBankMutationVariables = Exact<{
  bankUrl: Scalars['String']['input'];
}>;


export type RemoveBankMutation = { __typename?: 'Mutation', removeBank: { __typename?: 'PortalUserActionResponse', errorMessage?: string | null, portalUser: { __typename?: 'PortalUser', id: PortalUserId, banks: Array<{ __typename?: 'DwollaBank', name: string, isAutopayAuthorized: boolean, links: { __typename?: 'DwollaUrls', self: string } }>, loans: Array<{ __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, autopaySettings?: { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | null } }> } } };

export type RemovePlaidTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RemovePlaidTokenMutation = { __typename?: 'Mutation', removePlaidToken: { __typename?: 'SuccessResponse', success: boolean } };

export type RequestPayoffStatementMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  payoffDate: Scalars['GqlDate']['input'];
  additionalBorrowers: Array<Scalars['BorrowerId']['input']> | Scalars['BorrowerId']['input'];
  propertyIds: Array<Scalars['PropertyId']['input']> | Scalars['PropertyId']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestPayoffStatementMutation = { __typename?: 'Mutation', requestPayoffStatement: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, openPayoffStatus?: OpenPayoffStatus | null } } };

export type SaveMicroDepositTokenMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;


export type SaveMicroDepositTokenMutation = { __typename?: 'Mutation', saveMicroDepositToken: { __typename?: 'AccessTokenResponse', accessToken: string } };

export type SendChatMessageMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  message: Scalars['String']['input'];
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: { __typename?: 'LoanChatMessage', message: string, sender: LoanChatSender, id: LoanChatMessageId, sentAt?: any | null } };

export type UpdateAutopaySettingsForLoanMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  autopaySettings?: InputMaybe<AutopaySettingsInput>;
}>;


export type UpdateAutopaySettingsForLoanMutation = { __typename?: 'Mutation', updateAutopaySettingsForLoan: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, autopaySettings?: { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | null } } };

export type UpdateNachaAutopaySettingsForLoanMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  autopaySettings?: InputMaybe<NachaAutopaySettingsInput>;
}>;


export type UpdateNachaAutopaySettingsForLoanMutation = { __typename?: 'Mutation', updateNachaAutopaySettingsForLoan: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, autopaySettings?: { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | null } } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  input: BorrowerNotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename?: 'SuccessResponse', success: boolean } };

export type UpdateNotificationSettingsForAllCompaniesMutationVariables = Exact<{
  input: BorrowerNotificationSettingsForAllCompaniesInput;
}>;


export type UpdateNotificationSettingsForAllCompaniesMutation = { __typename?: 'Mutation', updateNotificationSettingsForAllCompanies: { __typename?: 'SuccessResponse', success: boolean } };

export type UpdateRepayAutopaySettingsForLoanMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  autopaySettings?: InputMaybe<RepayAutopaySettingsInput>;
}>;


export type UpdateRepayAutopaySettingsForLoanMutation = { __typename?: 'Mutation', updateRepayAutopaySettingsForLoan: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, autopaySettings?: { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | null } } };

export type VerificationOfMortgageRequestMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  input: VerificationOfMortgageRequestInput;
}>;


export type VerificationOfMortgageRequestMutation = { __typename?: 'Mutation', verificationOfMortgageRequest: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, documents: Array<{ __typename?: 'DefermentWorkoutPlanDocument', workoutPlanId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'DelinquentInterestAppliedDocument', paymentConfigId?: any | null, delinquentInterestSettingId?: any | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'EscrowAnalysisDocument', effectiveDate: any, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'Form1098Document', year: string, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'GeneralDocument', amount?: number | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PayoffDocument', payoffAmount: number, isExpired: boolean, expirationDate?: TGqlIsoDate | null, isPartial?: boolean | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationAppliedDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationCancelledDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'UploadDocument', title: string, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'VerificationOfMortgageDocument', id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean }> } } };

export type GetS3PresignedUrlDocumentUploadMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  loanId: Scalars['LoanId']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  fileExtension: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
}>;


export type GetS3PresignedUrlDocumentUploadMutation = { __typename?: 'Mutation', getS3PresignedUrlDocumentUpload: { __typename?: 'GetS3PresignedUploadUrlResponse', presignedUploadUrl: string, destination: string } };

export type SaveBorrowerDocumentUploadMutationVariables = Exact<{
  loanId: Scalars['LoanId']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type SaveBorrowerDocumentUploadMutation = { __typename?: 'Mutation', saveBorrowerDocumentUpload: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, documents: Array<{ __typename?: 'DefermentWorkoutPlanDocument', workoutPlanId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'DelinquentInterestAppliedDocument', paymentConfigId?: any | null, delinquentInterestSettingId?: any | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'EscrowAnalysisDocument', effectiveDate: any, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'Form1098Document', year: string, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'GeneralDocument', amount?: number | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PayoffDocument', payoffAmount: number, isExpired: boolean, expirationDate?: TGqlIsoDate | null, isPartial?: boolean | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationAppliedDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationCancelledDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'UploadDocument', title: string, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'VerificationOfMortgageDocument', id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean }> } } };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { __typename?: 'Query', portalSelf: { __typename?: 'PortalUser', id: PortalUserId, banks: Array<{ __typename?: 'DwollaBank', name: string, isAutopayAuthorized: boolean, links: { __typename?: 'DwollaUrls', self: string } }> } };

export type GetDocumentsForLoanQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['BorrowerId']['input']>;
  loanId: Scalars['LoanId']['input'];
}>;


export type GetDocumentsForLoanQuery = { __typename?: 'Query', portalSelf: { __typename?: 'PortalUser', id: PortalUserId, loan: { __typename?: 'PortalLoan', id: LoanId, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, documents: Array<{ __typename?: 'DefermentWorkoutPlanDocument', workoutPlanId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'DelinquentInterestAppliedDocument', paymentConfigId?: any | null, delinquentInterestSettingId?: any | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'EscrowAnalysisDocument', effectiveDate: any, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'Form1098Document', year: string, isCorrected: boolean, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'GeneralDocument', amount?: number | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PayoffDocument', payoffAmount: number, isExpired: boolean, expirationDate?: TGqlIsoDate | null, isPartial?: boolean | null, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationAppliedDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'PrincipalModificationCancelledDocument', principalModificationId: any, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'UploadDocument', title: string, id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean } | { __typename?: 'VerificationOfMortgageDocument', id: DocumentId, type: DocumentType, createdAt: any, url: string, version: number, isArchived: boolean }> } } } };

export type GetDwollaUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDwollaUserQuery = { __typename?: 'Query', portalSelf: { __typename?: 'PortalUser', id: PortalUserId, linkToken?: string | null, microDepositVerification: boolean, banks: Array<{ __typename?: 'DwollaBank', name: string, isAutopayAuthorized: boolean, links: { __typename?: 'DwollaUrls', self: string } }> } };

export type PortalSelfQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['BorrowerId']['input']>;
}>;


export type PortalSelfQuery = { __typename?: 'Query', portalSelf: { __typename?: 'PortalUser', id: PortalUserId, borrowerId: BorrowerId, email: string, firstName: string, lastName?: string | null, suffix?: string | null, acceptedTerms: boolean, requiredTosVersion: number, isAdmin: boolean, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, bannerMessages: Array<{ __typename?: 'BannerMessage', id: any, message: string, createdAt: TGqlIsoDateTime, updatedAt: TGqlIsoDateTime }>, loans: Array<{ __typename?: 'PortalLoan', id: LoanId, losId: LosId, originalAmount: number, company: { __typename?: 'PortalCompany', id: CompanyId, name: string, paymentsPaused: boolean, supportEmail: string, supportPhone: string, website?: string | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null, supportHours?: { __typename?: 'SupportHours', line1?: string | null, line2?: string | null, line3?: string | null } | null, logos: { __typename?: 'CompanyLogos', portalLogoUrl?: string | null, emailLogoUrl?: string | null }, portalSettings: { __typename?: 'PortalSettings', primaryColor?: string | null, borrowerRequests: { __typename?: 'BorrowerRequestSettings', payoffRequestEnabled: boolean, drawRequestEnabled: boolean, generalInquiryEnabled: boolean, paymentAssistanceInquiryEnabled: boolean, escrowWaiverRequestEnabled: boolean, pmiCancellationRequestEnabled: boolean, verificationOfMortgageEnabled: boolean }, borrowerPayments: { __typename?: 'BorrowerPaymentSettings', allowPaymentsPastMaturity: boolean }, loanDetails: { __typename?: 'LoanDetailsSettings', loanOfficer: boolean, manageMailingAddress: boolean } }, adminSettings: { __typename?: 'PortalCompanyAdminSettings', autopayEnabled?: boolean | null, exactPaymentsOnly?: boolean | null, applicationsEnabled?: boolean | null, econsentEnabled?: boolean | null, whedaEnabled?: boolean | null, repayEnabled?: boolean | null, manualNachaFileGeneration?: boolean | null, applicationsEnabledSettings?: { __typename?: 'PortalCompanyAdminSettingsApplications', ladderLife: boolean } | null }, customFAQ: Array<{ __typename?: 'CustomFAQSection', title: string, items: Array<{ __typename?: 'CustomFAQItem', question: string, answer: string }> }> }, wireSettings?: { __typename?: 'CompanyWireSettings', bankName: string, bankRoutingNumber: string, accountName: string, accountNumber: string, instructions?: string | null, bankAddress: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } } | null, authorizedContacts: Array<{ __typename: 'BuilderAuthorizedContact', id: AuthorizedContactId, type: AuthorizedContactType, builderCompanyName: string } | { __typename: 'ThirdPartyAuthorizedContact', firstName: string, lastName: string, id: AuthorizedContactId, type: AuthorizedContactType, thirdPartyCompanyName?: string | null }>, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string }, configuration: { __typename?: 'Configuration', amortizationType: AmortizationType, loanTerm: number, paymentFrequency?: number | null, interestRate: number, escrowed: boolean, firstDueDate: any, hasInterestReserve: boolean, annualInterestRate: number, buydownType?: string | null }, currentSnapshot: { __typename?: 'PortalLoanSnapshot', loanId: LoanId, totalAmountRemainingFromBorrower: number, totalUpcomingAmountRemainingFromBorrower: number, totalFutureAmountRemainingFromBorrower: number, totalWorkoutPlanAmountRemainingFromBorrower?: number | null, totalPastDueAmountRemainingFromBorrower: number, totalStatementAmountDue: number, totalAmountRemainingFromCredit: number, shortageAmount: number, spreadMonths: number, escrowShortageAnalysisId?: any | null, chargeAmountDue: number, paymentDueStatus: PaymentDueStatus, openPayoffStatus?: OpenPayoffStatus | null, expectedPayoffTotal: number, nextStatementDate: any, nextPaymentDueDate?: any | null, loanStatus: LoanStatus, amortizationMonth: number, currentBillSettingsType: LoanBillSettingsType, creditRemaining: number, drawsEnabled: boolean, isDrawable: boolean, maxLineOfCredit: number, hasOpenDrawRequest: boolean, isEligibleForAutomatedPayoff: boolean, hasMortgageInsurance: boolean, isFullInterestOnlyLoan: boolean, paymentDueSubStatus: { __typename?: 'PaymentDueSubStatus', isPastDue: boolean, paymentFail: boolean }, paymentsDue: Array<{ __typename?: 'PaymentDue', id: PaymentDueId, total: number, principal: number, interest: number, escrow: number, reserveCredit?: number | null, paymentDate: any, statementDate: any, escrowShortage?: number | null, status: { __typename?: 'PaymentDueSnapshot', amountRemainingFromBorrower: number, amountRemainingFromCredit: number, totalAmountRemaining: number, fulfilled: boolean, isLate: boolean, workoutPlanType?: WorkoutPlanType | null, billingStatus: BillingStatus }, statements: Array<{ __typename?: 'Statement', version: number, createdAt: any }> }>, payments: Array<{ __typename?: 'Payment', id: PaymentId, total: number, method: PaymentMethod, transactionId: string, paymentDate: any, status: PaymentStatus, canCancel: boolean, payer: { __typename?: 'AuthorizedContactPayer', authorizedContactId: AuthorizedContactId, type: string } | { __typename?: 'BorrowerPayer', borrowerId: BorrowerId, type: string } | { __typename?: 'EntityPayer', entityId: any, type: string } | { __typename?: 'ThirdPartyPayer', name: string, type: string } }>, paymentToPaymentDue: Array<{ __typename?: 'AdvanceBreakdown', feeId: any, advance: number, advanceInterest: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'BalanceReallocationBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'FeeBreakdown', feeId: any, fees: number, unappliedSuspense: number, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PayoffBreakdown', payoffId: any, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'PrincipalPrepaymentBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'StatementBreakdown', paymentDueId: PaymentDueId, type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'SuspenseBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number } | { __typename?: 'ThirdPartyBreakdown', type: PaymentToPaymentDueType, paymentId: PaymentId, amount: number, expectedPayment: number }>, disbursements: Array<{ __typename?: 'Disbursement', id: any, loanId: LoanId, total: number, type: DisbursementType, isReversal: boolean, date: any, status: DisbursementStatus, comment?: string | null, recipient: string, amounts: { __typename?: 'DisbursementAmounts', escrow: number, suspense: number, principalPrepayment: number } }>, charges: Array<{ __typename?: 'Advance', id: any, isDeferred: boolean, totalAmount: number, amountRemaining: number, status: FeeStatus, chargeDate: any, updatedAt?: any | null } | { __typename?: 'Fee', id: any, isDeferred: boolean, totalAmount: number, amountRemaining: number, status: FeeStatus, chargeDate: any, updatedAt?: any | null, lineItems: Array<{ __typename?: 'FeeLineItem', id: any, amount: number, type: FeeType, name?: string | null }> }>, transferData?: { __typename?: 'TransferData', servicerName: string, servicerLoanNumber: string, transferEffectiveDate: TGqlIsoDate, legalTransferEffectiveDate: TGqlIsoDate, phone: string, servicerWebsite?: string | null, servicerHours1?: string | null, servicerHours2?: string | null, servicerHours3?: string | null, loanOfficerName?: string | null, loanOfficerEmail?: string | null, nextServicerCollectsLatePayments: boolean, paymentAddress: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string }, correspondenceAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null } | null, transactionActivities: Array<{ __typename?: 'TransactionActivity', date: string, amount: string, subAmount?: string | null, type: string, subType?: string | null, status: string, isFailed?: boolean | null }>, snapshot: { __typename?: 'PaymentSnapshot', outstandingBalance: number, totalPaid: { __typename?: 'TotalPaid', sum: number, principal: number, interest: number, escrow: number }, balances: { __typename?: 'Balances', escrowBalance: number, reserveBalance?: number | null, holdbackBalance?: number | null, lossDraftBalance?: number | null } }, autopaySettings?: { __typename?: 'DwollaAutopaySettings', type: AutopaySettingsType, bankUrl: string, portalUserId: PortalUserId, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'NachaAutopaySettings', type: AutopaySettingsType, borrowerId: BorrowerId, dayOfTheMonth?: number | null, nachaAccountId: any, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'RepayAutopaySettings', type: AutopaySettingsType, accountId: RepayAccountId, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | { __typename?: 'UsioAutopaySettings', type: AutopaySettingsType, confirmationId: string, borrowerId: BorrowerId, dayOfTheMonth?: number | null, actor?: { __typename?: 'Actor', id: string, type: ActorType } | null } | null, payoffs: Array<{ __typename?: 'Payoff', id: any, totalDue: number, status: PayoffStatus, expirationDate: any }>, stopSettings: { __typename?: 'StopSettings', portalPayments: PortalPaymentStopSettingType, emailsPaused: boolean, documentAccessPaused: boolean, drawsPaused: boolean }, properties: Array<{ __typename?: 'Property', id: PropertyId, isReleased: boolean, address: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } }>, currentPaymentConfig: { __typename?: 'CurrentPaymentConfig', monthlyInterestRate: number }, delinquentInterestSettings: Array<{ __typename?: 'DelinquentInterestSetting', id: any, interestRate: number, startDate: TGqlIsoDate, endDate?: TGqlIsoDate | null, isDeferred: boolean, isWaived: boolean, createdAt: any, updatedAt: any }>, interestRateChangeHistory: Array<{ __typename?: 'InterestRateChange', effectiveDate: any, monthlyInterestRate: number }>, maturityConfig: { __typename?: 'MaturityConfig', isMaturing: boolean, maturityDate: any }, activeWorkoutPlan?: { __typename: 'BankruptcyCh13WorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'DefermentWorkoutPlan', principalAmount: number, interestAmount: number, feeAmount: number, escrowAmount: number, totalAmount: number, hasPrincipalAndInterest: boolean, hasFees: boolean, hasEscrow: boolean, paymentDueIds: Array<PaymentDueId>, chargeIds: Array<any>, reason?: WorkoutPlanReason | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'FlexModificationWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> } | { __typename: 'ForbearanceWorkoutPlan', forbearanceType: ForbearanceType, terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, forbearanceCancellationReason?: ForbearanceCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> } | { __typename: 'PaymentDeferralWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'RepaymentWorkoutPlan', terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, repaymentCancellationReason?: RepaymentPlanCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> } | null, offeredWorkoutPlans: Array<{ __typename: 'BankruptcyCh13WorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'DefermentWorkoutPlan', principalAmount: number, interestAmount: number, feeAmount: number, escrowAmount: number, totalAmount: number, hasPrincipalAndInterest: boolean, hasFees: boolean, hasEscrow: boolean, paymentDueIds: Array<PaymentDueId>, chargeIds: Array<any>, reason?: WorkoutPlanReason | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'FlexModificationWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> } | { __typename: 'ForbearanceWorkoutPlan', forbearanceType: ForbearanceType, terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, forbearanceCancellationReason?: ForbearanceCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> } | { __typename: 'PaymentDeferralWorkoutPlan', id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate } | { __typename: 'RepaymentWorkoutPlan', terminationDate?: TGqlIsoDate | null, id: any, status: WorkoutPlanStatus, type: WorkoutPlanType, endDate: TGqlIsoDate, repaymentCancellationReason?: RepaymentPlanCancellationReason | null, planPaymentsDue: Array<{ __typename?: 'WorkoutPlanPaymentDue', total: number, paymentDate: TGqlIsoDate, dStatus: { __typename?: 'WorkoutPlanPaymentDueStatus', amountRemaining: number, fulfilledAt?: TGqlIsoDate | null, isLate: boolean, paymentMadeIds: Array<PaymentId> } }> }>, originationData?: { __typename?: 'OriginationData', loanOfficerName?: string | null, loanOfficerEmail?: string | null } | null }, entity?: { __typename?: 'Entity', name: string } | null, repayAccounts: Array<{ __typename?: 'RepayAccount', id: RepayAccountId, payAccountId: string, accountName: string, lastFour: string, disabled: boolean, addedByCompany: boolean }>, achAccounts: Array<{ __typename?: 'BorrowerAchAccount', id: any, accountName: string, lastFour: string, prenoteSubmittedAt?: any | null, disabledAt?: any | null, addedByCompany: boolean, createdAt: any }>, messageViews?: { __typename?: 'BorrowerMessageViews', mailingAddressConfirmedAt?: TGqlIsoDateTime | null } | null, primaryBorrower: { __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, firstName: string, lastName: string, suffix?: string | null, emailConsent: boolean, emailNotificationsEnabled: boolean, paperNotificationsEnabled: boolean, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null }, additionalBorrowers: Array<{ __typename?: 'Borrower', id: BorrowerId, companyId: CompanyId, firstName: string, lastName: string, suffix?: string | null, emailConsent: boolean, emailNotificationsEnabled: boolean, paperNotificationsEnabled: boolean, preferredContactTimes: Array<{ __typename?: 'DayAndTimeRange', startTime: number, startDay: Weekday, endTime: number, endDay: Weekday, timezone: Timezone }>, phoneNumbers: { __typename?: 'Phone', home?: string | null, work?: string | null, cell?: string | null }, mailingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, line4?: string | null, locality: string, region: string, postcode: string, country: string } | null }> }> } };

export const PortalActorFragmentDoc = gql`
    fragment PortalActor on Actor {
  id
  type
}
    ` as unknown as DocumentNode<PortalActorFragment, unknown>;
export const PortalAutopaySettingsFragmentDoc = gql`
    fragment PortalAutopaySettings on AutopaySettings {
  ... on DwollaAutopaySettings {
    type
    bankUrl
    portalUserId
    actor {
      ...PortalActor
    }
  }
  ... on UsioAutopaySettings {
    type
    confirmationId
    borrowerId
    dayOfTheMonth
    actor {
      ...PortalActor
    }
  }
  ... on RepayAutopaySettings {
    type
    accountId
    borrowerId
    dayOfTheMonth
    actor {
      ...PortalActor
    }
  }
  ... on NachaAutopaySettings {
    type
    nachaAccountId: accountId
    borrowerId
    dayOfTheMonth
    actor {
      ...PortalActor
    }
  }
}
    ` as unknown as DocumentNode<PortalAutopaySettingsFragment, unknown>;
export const PortalBannerMessageFragmentDoc = gql`
    fragment PortalBannerMessage on BannerMessage {
  id
  message
  createdAt
  updatedAt
}
    ` as unknown as DocumentNode<PortalBannerMessageFragment, unknown>;
export const BorrowerNameFragmentDoc = gql`
    fragment BorrowerName on Borrower {
  id
  companyId
  firstName
  lastName
  suffix
}
    ` as unknown as DocumentNode<BorrowerNameFragment, unknown>;
export const PortalDayAndTimeRangeFragmentDoc = gql`
    fragment PortalDayAndTimeRange on DayAndTimeRange {
  startTime
  startDay
  endTime
  endDay
  timezone
}
    ` as unknown as DocumentNode<PortalDayAndTimeRangeFragment, unknown>;
export const BorrowerNotificationSettingsFragmentDoc = gql`
    fragment BorrowerNotificationSettings on Borrower {
  id
  companyId
  emailConsent
  emailNotificationsEnabled
  paperNotificationsEnabled
  preferredContactTimes {
    ...PortalDayAndTimeRange
  }
  phoneNumbers {
    home
    work
    cell
  }
  mailingAddress {
    line1
    line2
    line3
    line4
    locality
    region
    postcode
    country
  }
}
    ` as unknown as DocumentNode<BorrowerNotificationSettingsFragment, unknown>;
export const BorrowersOnLoanFragmentDoc = gql`
    fragment BorrowersOnLoan on PortalLoan {
  primaryBorrower {
    ...BorrowerName
    ...BorrowerNotificationSettings
  }
  additionalBorrowers {
    ...BorrowerName
    ...BorrowerNotificationSettings
  }
}
    ` as unknown as DocumentNode<BorrowersOnLoanFragment, unknown>;
export const PortalBorrowerAchAccountFragmentDoc = gql`
    fragment PortalBorrowerAchAccount on BorrowerAchAccount {
  id
  accountName
  lastFour
  prenoteSubmittedAt
  disabledAt
  addedByCompany
  createdAt
}
    ` as unknown as DocumentNode<PortalBorrowerAchAccountFragment, unknown>;
export const PortalChargeFragmentDoc = gql`
    fragment PortalCharge on Charge {
  ... on Fee {
    id
    lineItems {
      id
      amount
      type
      name
    }
    isDeferred
    totalAmount
    amountRemaining
    status
    chargeDate
    updatedAt
  }
  ... on Advance {
    id
    isDeferred
    totalAmount
    amountRemaining
    status
    chargeDate
    updatedAt
  }
}
    ` as unknown as DocumentNode<PortalChargeFragment, unknown>;
export const PortalAddressFragmentDoc = gql`
    fragment PortalAddress on Address {
  line1
  line2
  line3
  line4
  locality
  region
  postcode
  country
}
    ` as unknown as DocumentNode<PortalAddressFragment, unknown>;
export const PortalCustomFaqItemFragmentDoc = gql`
    fragment PortalCustomFAQItem on CustomFAQItem {
  question
  answer
}
    ` as unknown as DocumentNode<PortalCustomFaqItemFragment, unknown>;
export const PortalCustomFaqSectionFragmentDoc = gql`
    fragment PortalCustomFAQSection on CustomFAQSection {
  title
  items {
    ...PortalCustomFAQItem
  }
}
    ` as unknown as DocumentNode<PortalCustomFaqSectionFragment, unknown>;
export const CompanyFragmentDoc = gql`
    fragment Company on PortalCompany {
  id
  name
  paymentsPaused
  address {
    ...PortalAddress
  }
  supportEmail
  supportPhone
  supportHours {
    line1
    line2
    line3
  }
  website
  logos {
    portalLogoUrl
    emailLogoUrl
  }
  portalSettings {
    primaryColor
    borrowerRequests {
      payoffRequestEnabled
      drawRequestEnabled
      generalInquiryEnabled
      paymentAssistanceInquiryEnabled
      escrowWaiverRequestEnabled
      pmiCancellationRequestEnabled
      verificationOfMortgageEnabled
    }
    borrowerPayments {
      allowPaymentsPastMaturity
    }
    loanDetails {
      loanOfficer
      manageMailingAddress
    }
  }
  adminSettings {
    autopayEnabled
    exactPaymentsOnly
    applicationsEnabled
    applicationsEnabledSettings {
      ladderLife
    }
    econsentEnabled
    whedaEnabled
    repayEnabled
    manualNachaFileGeneration
  }
  customFAQ {
    ...PortalCustomFAQSection
  }
}
    ` as unknown as DocumentNode<CompanyFragment, unknown>;
export const PortalDelinquentInterestSettingFragmentDoc = gql`
    fragment PortalDelinquentInterestSetting on DelinquentInterestSetting {
  id
  interestRate
  startDate
  endDate
  isDeferred
  isWaived
  createdAt
  updatedAt
}
    ` as unknown as DocumentNode<PortalDelinquentInterestSettingFragment, unknown>;
export const PortalDocumentFragmentDoc = gql`
    fragment PortalDocument on Document {
  id
  type
  createdAt
  url
  version
  isArchived
  ... on GeneralDocument {
    amount
  }
  ... on PayoffDocument {
    payoffAmount
    isExpired
    expirationDate
    isPartial
  }
  ... on UploadDocument {
    title
  }
  ... on Form1098Document {
    year
    isCorrected
  }
  ... on EscrowAnalysisDocument {
    effectiveDate
    isCorrected
  }
  ... on DefermentWorkoutPlanDocument {
    workoutPlanId
  }
  ... on DelinquentInterestAppliedDocument {
    paymentConfigId
    delinquentInterestSettingId
  }
  ... on PrincipalModificationAppliedDocument {
    principalModificationId
  }
  ... on PrincipalModificationCancelledDocument {
    principalModificationId
  }
}
    ` as unknown as DocumentNode<PortalDocumentFragment, unknown>;
export const BorrowerMessageViewsFragmentDoc = gql`
    fragment BorrowerMessageViews on BorrowerMessageViews {
  mailingAddressConfirmedAt
}
    ` as unknown as DocumentNode<BorrowerMessageViewsFragment, unknown>;
export const PortalPayerFragmentDoc = gql`
    fragment PortalPayer on Payer {
  ... on BorrowerPayer {
    borrowerId
    type
  }
  ... on AuthorizedContactPayer {
    authorizedContactId
    type
  }
  ... on ThirdPartyPayer {
    name
    type
  }
  ... on EntityPayer {
    entityId
    type
  }
}
    ` as unknown as DocumentNode<PortalPayerFragment, unknown>;
export const PortalPaymentFragmentDoc = gql`
    fragment PortalPayment on Payment {
  id
  payer {
    ...PortalPayer
  }
  total
  method
  transactionId
  paymentDate
  status
  canCancel
}
    ` as unknown as DocumentNode<PortalPaymentFragment, unknown>;
export const PortalPaymentBreakdownFragmentDoc = gql`
    fragment PortalPaymentBreakdown on PaymentToPaymentDue {
  type
  paymentId
  amount
  expectedPayment
  ... on StatementBreakdown {
    paymentDueId
  }
  ... on FeeBreakdown {
    feeId
    fees
    unappliedSuspense
  }
  ... on AdvanceBreakdown {
    feeId
    advance
    advanceInterest
    unappliedSuspense
  }
  ... on PayoffBreakdown {
    payoffId
  }
}
    ` as unknown as DocumentNode<PortalPaymentBreakdownFragment, unknown>;
export const PortalPaymentDueFragmentDoc = gql`
    fragment PortalPaymentDue on PaymentDue {
  id
  total
  principal
  interest
  escrow
  reserveCredit
  paymentDate
  statementDate
  status {
    amountRemainingFromBorrower
    amountRemainingFromCredit
    totalAmountRemaining
    fulfilled
    isLate
    workoutPlanType
    billingStatus
  }
  statements {
    version
    createdAt
  }
  escrowShortage
}
    ` as unknown as DocumentNode<PortalPaymentDueFragment, unknown>;
export const PortalPayoffFragmentDoc = gql`
    fragment PortalPayoff on Payoff {
  id
  totalDue
  status
  expirationDate
}
    ` as unknown as DocumentNode<PortalPayoffFragment, unknown>;
export const PortalAuthorizedContactFragmentDoc = gql`
    fragment PortalAuthorizedContact on AuthorizedContact {
  __typename
  id
  type
  ... on ThirdPartyAuthorizedContact {
    firstName
    lastName
    thirdPartyCompanyName: companyName
  }
  ... on BuilderAuthorizedContact {
    builderCompanyName: companyName
  }
}
    ` as unknown as DocumentNode<PortalAuthorizedContactFragment, unknown>;
export const PortalBankFragmentDoc = gql`
    fragment PortalBank on DwollaBank {
  links {
    self
  }
  name
  isAutopayAuthorized
}
    ` as unknown as DocumentNode<PortalBankFragment, unknown>;
export const PortalWireSettingsFragmentDoc = gql`
    fragment PortalWireSettings on CompanyWireSettings {
  bankName
  bankRoutingNumber
  accountName
  accountNumber
  bankAddress {
    ...PortalAddress
  }
  instructions
}
    ` as unknown as DocumentNode<PortalWireSettingsFragment, unknown>;
export const PortalPropertyFragmentDoc = gql`
    fragment PortalProperty on Property {
  id
  address {
    ...PortalAddress
  }
  isReleased
}
    ` as unknown as DocumentNode<PortalPropertyFragment, unknown>;
export const PortalRepayAccountFragmentDoc = gql`
    fragment PortalRepayAccount on RepayAccount {
  id
  payAccountId
  accountName
  lastFour
  disabled
  addedByCompany
}
    ` as unknown as DocumentNode<PortalRepayAccountFragment, unknown>;
export const PortalStopSettingsFragmentDoc = gql`
    fragment PortalStopSettings on StopSettings {
  portalPayments
  emailsPaused
  documentAccessPaused
  drawsPaused
}
    ` as unknown as DocumentNode<PortalStopSettingsFragment, unknown>;
export const PortalTransferDataFragmentDoc = gql`
    fragment PortalTransferData on TransferData {
  servicerName
  servicerLoanNumber
  transferEffectiveDate
  legalTransferEffectiveDate
  phone
  paymentAddress {
    ...PortalAddress
  }
  correspondenceAddress {
    ...PortalAddress
  }
  servicerWebsite
  servicerHours1
  servicerHours2
  servicerHours3
  loanOfficerName
  loanOfficerEmail
  nextServicerCollectsLatePayments
}
    ` as unknown as DocumentNode<PortalTransferDataFragment, unknown>;
export const PortalWorkoutPlanPaymentDueFragmentDoc = gql`
    fragment PortalWorkoutPlanPaymentDue on WorkoutPlanPaymentDue {
  total
  paymentDate
  dStatus {
    amountRemaining
    fulfilledAt
    isLate
    paymentMadeIds
  }
}
    ` as unknown as DocumentNode<PortalWorkoutPlanPaymentDueFragment, unknown>;
export const PortalWorkoutPlanFragmentDoc = gql`
    fragment PortalWorkoutPlan on WorkoutPlan {
  __typename
  id
  status
  type
  endDate
  ... on DefermentWorkoutPlan {
    principalAmount
    interestAmount
    feeAmount
    escrowAmount
    totalAmount
    hasPrincipalAndInterest
    hasFees
    hasEscrow
    paymentDueIds
    chargeIds
    reason
  }
  ... on ForbearanceWorkoutPlan {
    forbearanceType
    terminationDate
    forbearanceCancellationReason: cancellationReason
    planPaymentsDue {
      ...PortalWorkoutPlanPaymentDue
    }
  }
  ... on FlexModificationWorkoutPlan {
    planPaymentsDue {
      ...PortalWorkoutPlanPaymentDue
    }
  }
  ... on RepaymentWorkoutPlan {
    terminationDate
    repaymentCancellationReason: cancellationReason
    planPaymentsDue {
      ...PortalWorkoutPlanPaymentDue
    }
  }
}
    ` as unknown as DocumentNode<PortalWorkoutPlanFragment, unknown>;
export const AcceptTermsDocument = gql`
    mutation acceptTerms($emailConsent: Boolean, $tosVersion: Int!) {
  acceptTerms(emailConsent: $emailConsent, tosVersion: $tosVersion) {
    id
    acceptedTerms
    linkToken
  }
}
    ` as unknown as DocumentNode<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const CancelPaymentDocument = gql`
    mutation cancelPayment($companyId: CompanyId!, $loanId: LoanId!, $paymentId: PaymentId!) {
  cancelPayment(companyId: $companyId, loanId: $loanId, paymentId: $paymentId) {
    id
    currentSnapshot {
      loanId
      payments {
        ...PortalPayment
      }
    }
  }
}
    ${PortalPaymentFragmentDoc}
${PortalPayerFragmentDoc}` as unknown as DocumentNode<CancelPaymentMutation, CancelPaymentMutationVariables>;
export const ConfirmMessageViewDocument = gql`
    mutation confirmMessageView($companyId: CompanyId!, $loanId: LoanId!, $messageKey: BorrowerMessageKey!) {
  confirmMessageView(
    companyId: $companyId
    loanId: $loanId
    messageKey: $messageKey
  ) {
    id
  }
}
    ` as unknown as DocumentNode<ConfirmMessageViewMutation, ConfirmMessageViewMutationVariables>;
export const CreatePortalBorrowerAchAccountDocument = gql`
    mutation createPortalBorrowerAchAccount($companyId: CompanyId!, $loanId: LoanId!, $input: CreatePortalBorrowerAchAccountInput!) {
  createPortalBorrowerAchAccount(
    companyId: $companyId
    loanId: $loanId
    input: $input
  ) {
    id
    achAccounts {
      ...PortalBorrowerAchAccount
    }
  }
}
    ${PortalBorrowerAchAccountFragmentDoc}` as unknown as DocumentNode<CreatePortalBorrowerAchAccountMutation, CreatePortalBorrowerAchAccountMutationVariables>;
export const CreateRepayAccountDocument = gql`
    mutation createRepayAccount($companyId: CompanyId!, $loanId: LoanId!, $input: CreateRepayAccountInput!) {
  createRepayAccount(companyId: $companyId, loanId: $loanId, input: $input) {
    id
    repayAccounts {
      ...PortalRepayAccount
    }
  }
}
    ${PortalRepayAccountFragmentDoc}` as unknown as DocumentNode<CreateRepayAccountMutation, CreateRepayAccountMutationVariables>;
export const DeletePortalBorrowerAchAccountDocument = gql`
    mutation deletePortalBorrowerAchAccount($companyId: CompanyId!, $loanId: LoanId!, $accountId: BorrowerAchAccountId!) {
  deletePortalBorrowerAchAccount(
    companyId: $companyId
    loanId: $loanId
    accountId: $accountId
  ) {
    id
    achAccounts {
      ...PortalBorrowerAchAccount
    }
  }
}
    ${PortalBorrowerAchAccountFragmentDoc}` as unknown as DocumentNode<DeletePortalBorrowerAchAccountMutation, DeletePortalBorrowerAchAccountMutationVariables>;
export const DeleteRepayAccountDocument = gql`
    mutation deleteRepayAccount($companyId: CompanyId!, $loanId: LoanId!, $accountId: RepayAccountId!) {
  deleteRepayAccount(
    companyId: $companyId
    loanId: $loanId
    accountId: $accountId
  ) {
    id
    repayAccounts {
      ...PortalRepayAccount
    }
  }
}
    ${PortalRepayAccountFragmentDoc}` as unknown as DocumentNode<DeleteRepayAccountMutation, DeleteRepayAccountMutationVariables>;
export const DrawRequestDocument = gql`
    mutation drawRequest($companyId: CompanyId!, $loanId: LoanId!, $amount: Float!, $date: GqlDate!, $message: String!) {
  drawRequest(
    companyId: $companyId
    loanId: $loanId
    amount: $amount
    date: $date
    message: $message
  ) {
    id
    currentSnapshot {
      loanId
      hasOpenDrawRequest
    }
  }
}
    ` as unknown as DocumentNode<DrawRequestMutation, DrawRequestMutationVariables>;
export const EditBorrowerDetailsDocument = gql`
    mutation editBorrowerDetails($companyId: CompanyId!, $loanId: LoanId!, $input: BorrowerEditInput!) {
  editBorrowerDetails(companyId: $companyId, loanId: $loanId, input: $input) {
    id
    companyId
    phoneNumbers {
      home
      work
      cell
    }
    preferredContactTimes {
      ...PortalDayAndTimeRange
    }
    mailingAddress {
      line1
      line2
      line3
      line4
      locality
      region
      postcode
      country
    }
  }
}
    ${PortalDayAndTimeRangeFragmentDoc}` as unknown as DocumentNode<EditBorrowerDetailsMutation, EditBorrowerDetailsMutationVariables>;
export const EscrowWaiverRequestDocument = gql`
    mutation escrowWaiverRequest($companyId: CompanyId!, $loanId: LoanId!, $waivedItems: [EscrowWaiverRequestType!]!, $message: String) {
  escrowWaiverRequest(
    companyId: $companyId
    loanId: $loanId
    waivedItems: $waivedItems
    message: $message
  ) {
    success
  }
}
    ` as unknown as DocumentNode<EscrowWaiverRequestMutation, EscrowWaiverRequestMutationVariables>;
export const GeneralInquiryDocument = gql`
    mutation generalInquiry($companyId: CompanyId!, $loanId: LoanId!, $message: String!) {
  generalInquiry(companyId: $companyId, loanId: $loanId, message: $message) {
    success
  }
}
    ` as unknown as DocumentNode<GeneralInquiryMutation, GeneralInquiryMutationVariables>;
export const GetChatMessageDocument = gql`
    query getChatMessage($loanId: LoanId!, $messageId: LoanChatMessageId!) {
  getChatMessage(loanId: $loanId, messageId: $messageId) {
    message
    sentAt
    sender
  }
}
    ` as unknown as DocumentNode<GetChatMessageQuery, GetChatMessageQueryVariables>;
export const GetChatMessagesDocument = gql`
    query getChatMessages($loanId: LoanId!) {
  getChatMessages(loanId: $loanId) {
    records {
      message
      id
      sentAt
      sender
    }
  }
}
    ` as unknown as DocumentNode<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const GetDocumentUrlDocument = gql`
    mutation getDocumentUrl($loanId: LoanId!, $documentId: DocumentId!) {
  getDocumentUrl(loanId: $loanId, documentId: $documentId) {
    url
  }
}
    ` as unknown as DocumentNode<GetDocumentUrlMutation, GetDocumentUrlMutationVariables>;
export const GetPdfStatementUrlDocument = gql`
    mutation getPdfStatementUrl($loanId: LoanId!, $paymentDueId: PaymentDueId!, $version: Int!) {
  getPdfStatementUrl(
    loanId: $loanId
    paymentDueId: $paymentDueId
    version: $version
  ) {
    url
  }
}
    ` as unknown as DocumentNode<GetPdfStatementUrlMutation, GetPdfStatementUrlMutationVariables>;
export const InitiateNachaPaymentDocument = gql`
    mutation initiateNachaPayment($companyId: CompanyId!, $loanId: LoanId!, $borrowerAchAccountId: BorrowerAchAccountId!, $amount: Float!, $additionalPrincipal: Float, $additionalEscrow: Float, $additionalSuspense: Float, $escrowShortageAnalysisId: EscrowPaymentHistoryItemId) {
  initiateNachaPayment(
    companyId: $companyId
    loanId: $loanId
    borrowerAchAccountId: $borrowerAchAccountId
    amount: $amount
    additionalPrincipal: $additionalPrincipal
    additionalEscrow: $additionalEscrow
    additionalSuspense: $additionalSuspense
    escrowShortageAnalysisId: $escrowShortageAnalysisId
  ) {
    id
    currentSnapshot {
      loanId
      paymentsDue {
        ...PortalPaymentDue
      }
      payments {
        ...PortalPayment
      }
      paymentToPaymentDue {
        ...PortalPaymentBreakdown
      }
    }
  }
}
    ${PortalPaymentDueFragmentDoc}
${PortalPaymentFragmentDoc}
${PortalPayerFragmentDoc}
${PortalPaymentBreakdownFragmentDoc}` as unknown as DocumentNode<InitiateNachaPaymentMutation, InitiateNachaPaymentMutationVariables>;
export const InitiatePaymentDocument = gql`
    mutation initiatePayment($borrowerBankUrl: String!, $companyId: CompanyId!, $loanId: LoanId!, $amount: Float!, $additionalPrincipal: Float, $additionalEscrow: Float, $additionalSuspense: Float, $escrowShortageAnalysisId: EscrowPaymentHistoryItemId) {
  initiatePayment(
    fromBankUrl: $borrowerBankUrl
    companyId: $companyId
    loanId: $loanId
    amount: $amount
    additionalPrincipal: $additionalPrincipal
    additionalEscrow: $additionalEscrow
    additionalSuspense: $additionalSuspense
    escrowShortageAnalysisId: $escrowShortageAnalysisId
  ) {
    transferUrl
  }
}
    ` as unknown as DocumentNode<InitiatePaymentMutation, InitiatePaymentMutationVariables>;
export const InitiateRepayPaymentDocument = gql`
    mutation initiateRepayPayment($repayAccountId: RepayAccountId!, $companyId: CompanyId!, $loanId: LoanId!, $amount: Float!, $additionalPrincipal: Float, $additionalEscrow: Float, $additionalSuspense: Float, $escrowShortageAnalysisId: EscrowPaymentHistoryItemId) {
  initiateRepayPayment(
    repayAccountId: $repayAccountId
    companyId: $companyId
    loanId: $loanId
    amount: $amount
    additionalPrincipal: $additionalPrincipal
    additionalEscrow: $additionalEscrow
    additionalSuspense: $additionalSuspense
    escrowShortageAnalysisId: $escrowShortageAnalysisId
  ) {
    id
    currentSnapshot {
      loanId
      paymentsDue {
        ...PortalPaymentDue
      }
      payments {
        ...PortalPayment
      }
      paymentToPaymentDue {
        ...PortalPaymentBreakdown
      }
    }
  }
}
    ${PortalPaymentDueFragmentDoc}
${PortalPaymentFragmentDoc}
${PortalPayerFragmentDoc}
${PortalPaymentBreakdownFragmentDoc}` as unknown as DocumentNode<InitiateRepayPaymentMutation, InitiateRepayPaymentMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    success
  }
}
    ` as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const PmiCancellationRequestDocument = gql`
    mutation pmiCancellationRequest($companyId: CompanyId!, $loanId: LoanId!, $propertyValueType: PMICancellationRequestPropertyValueType!) {
  pmiCancellationRequest(
    companyId: $companyId
    loanId: $loanId
    propertyValueType: $propertyValueType
  ) {
    success
  }
}
    ` as unknown as DocumentNode<PmiCancellationRequestMutation, PmiCancellationRequestMutationVariables>;
export const PaymentAssistanceInquiryDocument = gql`
    mutation paymentAssistanceInquiry($companyId: CompanyId!, $loanId: LoanId!, $message: String!, $quotedPastDueTotal: Float!) {
  paymentAssistanceInquiry(
    companyId: $companyId
    loanId: $loanId
    message: $message
    quotedPastDueTotal: $quotedPastDueTotal
  ) {
    success
  }
}
    ` as unknown as DocumentNode<PaymentAssistanceInquiryMutation, PaymentAssistanceInquiryMutationVariables>;
export const PostPlaidBankToDwollaDocument = gql`
    mutation postPlaidBankToDwolla($publicToken: String!, $accountId: String!, $accountNickname: String!) {
  postPlaidBankToDwolla(
    publicToken: $publicToken
    accountId: $accountId
    accountNickname: $accountNickname
  ) {
    id
    banks {
      ...PortalBank
    }
  }
}
    ${PortalBankFragmentDoc}` as unknown as DocumentNode<PostPlaidBankToDwollaMutation, PostPlaidBankToDwollaMutationVariables>;
export const QueryChatBotDocument = gql`
    mutation queryChatBot($loanId: LoanId!, $message: String!) {
  queryChatBot(loanId: $loanId, message: $message) {
    message
  }
}
    ` as unknown as DocumentNode<QueryChatBotMutation, QueryChatBotMutationVariables>;
export const RemoveBankDocument = gql`
    mutation removeBank($bankUrl: String!) {
  removeBank(bankUrl: $bankUrl) {
    errorMessage
    portalUser {
      id
      banks {
        ...PortalBank
      }
      loans {
        id
        currentSnapshot {
          loanId
          autopaySettings {
            ...PortalAutopaySettings
          }
        }
      }
    }
  }
}
    ${PortalBankFragmentDoc}
${PortalAutopaySettingsFragmentDoc}
${PortalActorFragmentDoc}` as unknown as DocumentNode<RemoveBankMutation, RemoveBankMutationVariables>;
export const RemovePlaidTokenDocument = gql`
    mutation removePlaidToken {
  removePlaidToken {
    success
  }
}
    ` as unknown as DocumentNode<RemovePlaidTokenMutation, RemovePlaidTokenMutationVariables>;
export const RequestPayoffStatementDocument = gql`
    mutation requestPayoffStatement($loanId: LoanId!, $payoffDate: GqlDate!, $additionalBorrowers: [BorrowerId!]!, $propertyIds: [PropertyId!]!, $message: String) {
  requestPayoffStatement(
    loanId: $loanId
    payoffDate: $payoffDate
    additionalBorrowers: $additionalBorrowers
    propertyIds: $propertyIds
    message: $message
  ) {
    id
    currentSnapshot {
      loanId
      openPayoffStatus
    }
  }
}
    ` as unknown as DocumentNode<RequestPayoffStatementMutation, RequestPayoffStatementMutationVariables>;
export const SaveMicroDepositTokenDocument = gql`
    mutation saveMicroDepositToken($publicToken: String!, $accountId: String!) {
  saveMicroDepositToken(publicToken: $publicToken, accountId: $accountId) {
    accessToken
  }
}
    ` as unknown as DocumentNode<SaveMicroDepositTokenMutation, SaveMicroDepositTokenMutationVariables>;
export const SendChatMessageDocument = gql`
    mutation sendChatMessage($loanId: LoanId!, $message: String!) {
  sendChatMessage(loanId: $loanId, message: $message) {
    message
    sender
    id
    sentAt
  }
}
    ` as unknown as DocumentNode<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const UpdateAutopaySettingsForLoanDocument = gql`
    mutation updateAutopaySettingsForLoan($loanId: LoanId!, $autopaySettings: AutopaySettingsInput) {
  updateAutopaySettingsForLoan(loanId: $loanId, autopaySettings: $autopaySettings) {
    id
    currentSnapshot {
      loanId
      autopaySettings {
        ...PortalAutopaySettings
      }
    }
  }
}
    ${PortalAutopaySettingsFragmentDoc}
${PortalActorFragmentDoc}` as unknown as DocumentNode<UpdateAutopaySettingsForLoanMutation, UpdateAutopaySettingsForLoanMutationVariables>;
export const UpdateNachaAutopaySettingsForLoanDocument = gql`
    mutation updateNachaAutopaySettingsForLoan($loanId: LoanId!, $autopaySettings: NachaAutopaySettingsInput) {
  updateNachaAutopaySettingsForLoan(
    loanId: $loanId
    autopaySettings: $autopaySettings
  ) {
    id
    currentSnapshot {
      loanId
      autopaySettings {
        ...PortalAutopaySettings
      }
    }
  }
}
    ${PortalAutopaySettingsFragmentDoc}
${PortalActorFragmentDoc}` as unknown as DocumentNode<UpdateNachaAutopaySettingsForLoanMutation, UpdateNachaAutopaySettingsForLoanMutationVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation updateNotificationSettings($loanId: LoanId!, $input: BorrowerNotificationSettingsInput!) {
  updateNotificationSettings(loanId: $loanId, input: $input) {
    success
  }
}
    ` as unknown as DocumentNode<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const UpdateNotificationSettingsForAllCompaniesDocument = gql`
    mutation updateNotificationSettingsForAllCompanies($input: BorrowerNotificationSettingsForAllCompaniesInput!) {
  updateNotificationSettingsForAllCompanies(input: $input) {
    success
  }
}
    ` as unknown as DocumentNode<UpdateNotificationSettingsForAllCompaniesMutation, UpdateNotificationSettingsForAllCompaniesMutationVariables>;
export const UpdateRepayAutopaySettingsForLoanDocument = gql`
    mutation updateRepayAutopaySettingsForLoan($loanId: LoanId!, $autopaySettings: RepayAutopaySettingsInput) {
  updateRepayAutopaySettingsForLoan(
    loanId: $loanId
    autopaySettings: $autopaySettings
  ) {
    id
    currentSnapshot {
      loanId
      autopaySettings {
        ...PortalAutopaySettings
      }
    }
  }
}
    ${PortalAutopaySettingsFragmentDoc}
${PortalActorFragmentDoc}` as unknown as DocumentNode<UpdateRepayAutopaySettingsForLoanMutation, UpdateRepayAutopaySettingsForLoanMutationVariables>;
export const VerificationOfMortgageRequestDocument = gql`
    mutation verificationOfMortgageRequest($companyId: CompanyId!, $loanId: LoanId!, $input: VerificationOfMortgageRequestInput!) {
  verificationOfMortgageRequest(
    companyId: $companyId
    loanId: $loanId
    input: $input
  ) {
    id
    currentSnapshot {
      loanId
      documents {
        ...PortalDocument
      }
    }
  }
}
    ${PortalDocumentFragmentDoc}` as unknown as DocumentNode<VerificationOfMortgageRequestMutation, VerificationOfMortgageRequestMutationVariables>;
export const GetS3PresignedUrlDocumentUploadDocument = gql`
    mutation getS3PresignedUrlDocumentUpload($companyId: CompanyId!, $loanId: LoanId!, $fileName: String!, $fileType: String!, $fileExtension: String!, $fileSizeInBytes: Int!) {
  getS3PresignedUrlDocumentUpload(
    companyId: $companyId
    loanId: $loanId
    fileName: $fileName
    fileType: $fileType
    fileExtension: $fileExtension
    fileSizeInBytes: $fileSizeInBytes
  ) {
    presignedUploadUrl
    destination
  }
}
    ` as unknown as DocumentNode<GetS3PresignedUrlDocumentUploadMutation, GetS3PresignedUrlDocumentUploadMutationVariables>;
export const SaveBorrowerDocumentUploadDocument = gql`
    mutation saveBorrowerDocumentUpload($loanId: LoanId!, $title: String!, $url: String!) {
  saveBorrowerDocumentUpload(loanId: $loanId, title: $title, url: $url) {
    id
    currentSnapshot {
      loanId
      documents {
        ...PortalDocument
      }
    }
  }
}
    ${PortalDocumentFragmentDoc}` as unknown as DocumentNode<SaveBorrowerDocumentUploadMutation, SaveBorrowerDocumentUploadMutationVariables>;
export const GetBanksDocument = gql`
    query getBanks {
  portalSelf {
    id
    banks {
      ...PortalBank
    }
  }
}
    ${PortalBankFragmentDoc}` as unknown as DocumentNode<GetBanksQuery, GetBanksQueryVariables>;
export const GetDocumentsForLoanDocument = gql`
    query getDocumentsForLoan($userId: BorrowerId, $loanId: LoanId!) {
  portalSelf(userId: $userId) {
    id
    loan(loanId: $loanId) {
      id
      currentSnapshot {
        loanId
        documents {
          ...PortalDocument
        }
      }
    }
  }
}
    ${PortalDocumentFragmentDoc}` as unknown as DocumentNode<GetDocumentsForLoanQuery, GetDocumentsForLoanQueryVariables>;
export const GetDwollaUserDocument = gql`
    query getDwollaUser {
  portalSelf {
    id
    banks {
      ...PortalBank
    }
    linkToken
    microDepositVerification
  }
}
    ${PortalBankFragmentDoc}` as unknown as DocumentNode<GetDwollaUserQuery, GetDwollaUserQueryVariables>;
export const PortalSelfDocument = gql`
    query portalSelf($userId: BorrowerId) {
  portalSelf(userId: $userId) {
    id
    borrowerId
    email
    phoneNumbers {
      home
      work
      cell
    }
    firstName
    lastName
    suffix
    acceptedTerms
    requiredTosVersion
    isAdmin
    bannerMessages {
      ...PortalBannerMessage
    }
    loans {
      id
      losId
      originalAmount
      company {
        ...Company
      }
      wireSettings {
        ...PortalWireSettings
      }
      ...BorrowersOnLoan
      authorizedContacts {
        ...PortalAuthorizedContact
      }
      address {
        ...PortalAddress
      }
      originalAmount
      configuration {
        amortizationType
        loanTerm
        paymentFrequency
        interestRate
        escrowed
        firstDueDate
        hasInterestReserve
        annualInterestRate
        buydownType
      }
      currentSnapshot {
        loanId
        totalAmountRemainingFromBorrower
        totalUpcomingAmountRemainingFromBorrower
        totalFutureAmountRemainingFromBorrower
        totalWorkoutPlanAmountRemainingFromBorrower
        totalPastDueAmountRemainingFromBorrower
        totalStatementAmountDue
        totalAmountRemainingFromCredit
        shortageAmount
        spreadMonths
        escrowShortageAnalysisId
        chargeAmountDue
        paymentDueStatus
        openPayoffStatus
        expectedPayoffTotal
        paymentDueSubStatus {
          isPastDue
          paymentFail
        }
        nextStatementDate
        nextPaymentDueDate
        loanStatus
        amortizationMonth
        currentBillSettingsType
        paymentsDue {
          ...PortalPaymentDue
        }
        payments {
          ...PortalPayment
        }
        paymentToPaymentDue {
          ...PortalPaymentBreakdown
        }
        disbursements {
          id
          loanId
          total
          type
          isReversal
          date
          status
          comment
          amounts {
            escrow
            suspense
            principalPrepayment
          }
          recipient
        }
        creditRemaining
        drawsEnabled
        isDrawable
        maxLineOfCredit
        hasOpenDrawRequest
        charges {
          ...PortalCharge
        }
        transferData {
          ...PortalTransferData
        }
        transactionActivities {
          date
          amount
          subAmount
          type
          subType
          status
          isFailed
        }
        snapshot {
          outstandingBalance
          totalPaid {
            sum
            principal
            interest
            escrow
          }
          balances {
            escrowBalance
            reserveBalance
            holdbackBalance
            lossDraftBalance
          }
        }
        autopaySettings {
          ...PortalAutopaySettings
        }
        payoffs {
          ...PortalPayoff
        }
        isEligibleForAutomatedPayoff
        stopSettings {
          ...PortalStopSettings
        }
        properties {
          ...PortalProperty
        }
        currentPaymentConfig {
          monthlyInterestRate
        }
        delinquentInterestSettings {
          ...PortalDelinquentInterestSetting
        }
        interestRateChangeHistory {
          effectiveDate
          monthlyInterestRate
        }
        maturityConfig {
          isMaturing
          maturityDate
        }
        drawsEnabled
        isDrawable
        maxLineOfCredit
        activeWorkoutPlan {
          ...PortalWorkoutPlan
        }
        offeredWorkoutPlans {
          ...PortalWorkoutPlan
        }
        hasMortgageInsurance
        isFullInterestOnlyLoan
        originationData {
          loanOfficerName
          loanOfficerEmail
        }
      }
      entity {
        name
      }
      repayAccounts {
        ...PortalRepayAccount
      }
      achAccounts {
        ...PortalBorrowerAchAccount
      }
      messageViews {
        ...BorrowerMessageViews
      }
    }
  }
}
    ${PortalBannerMessageFragmentDoc}
${CompanyFragmentDoc}
${PortalAddressFragmentDoc}
${PortalCustomFaqSectionFragmentDoc}
${PortalCustomFaqItemFragmentDoc}
${PortalWireSettingsFragmentDoc}
${BorrowersOnLoanFragmentDoc}
${BorrowerNameFragmentDoc}
${BorrowerNotificationSettingsFragmentDoc}
${PortalDayAndTimeRangeFragmentDoc}
${PortalAuthorizedContactFragmentDoc}
${PortalPaymentDueFragmentDoc}
${PortalPaymentFragmentDoc}
${PortalPayerFragmentDoc}
${PortalPaymentBreakdownFragmentDoc}
${PortalChargeFragmentDoc}
${PortalTransferDataFragmentDoc}
${PortalAutopaySettingsFragmentDoc}
${PortalActorFragmentDoc}
${PortalPayoffFragmentDoc}
${PortalStopSettingsFragmentDoc}
${PortalPropertyFragmentDoc}
${PortalDelinquentInterestSettingFragmentDoc}
${PortalWorkoutPlanFragmentDoc}
${PortalWorkoutPlanPaymentDueFragmentDoc}
${PortalRepayAccountFragmentDoc}
${PortalBorrowerAchAccountFragmentDoc}
${BorrowerMessageViewsFragmentDoc}` as unknown as DocumentNode<PortalSelfQuery, PortalSelfQueryVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  AdvanceConfig: ( EscrowAdvanceConfig ) | ( StandardAdvanceConfig );
  AutopaySettings: ( DwollaAutopaySettings ) | ( NachaAutopaySettings ) | ( RepayAutopaySettings ) | ( UsioAutopaySettings );
  Charge: ( Omit<Advance, 'advanceConfig'> & { advanceConfig?: Maybe<_RefType['AdvanceConfig']> } ) | ( Fee );
  Payee: ( DirectoryPayee ) | ( LegacyEscrowPayeeSnapshot );
  Payer: ( AuthorizedContactPayer ) | ( BorrowerPayer ) | ( EntityPayer ) | ( ThirdPartyPayer );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Attribution: ( DelinquentInterestAttribution ) | ( DrawInterestAttribution ) | ( PartialPayoffInterestAttribution ) | ( StandardInterestAttribution );
  AuthorizedContact: ( BuilderAuthorizedContact ) | ( ThirdPartyAuthorizedContact );
  Document: ( DefermentWorkoutPlanDocument ) | ( DelinquentInterestAppliedDocument ) | ( EscrowAnalysisDocument ) | ( Form1098Document ) | ( GeneralDocument ) | ( PayoffDocument ) | ( PrincipalModificationAppliedDocument ) | ( PrincipalModificationCancelledDocument ) | ( UploadDocument ) | ( VerificationOfMortgageDocument );
  EscrowDue: ( InsuranceEscrowDue ) | ( MortgageInsuranceEscrowDue ) | ( TaxEscrowDue );
  EscrowSetting: ( Omit<InsuranceEscrowSetting, 'payee'> & { payee: _RefType['Payee'] } ) | ( Omit<MortgageInsuranceEscrowSetting, 'payee'> & { payee: _RefType['Payee'] } ) | ( Omit<TaxEscrowSetting, 'payee'> & { payee: _RefType['Payee'] } );
  LoanLateFee: ( LoanLateFeeFixed ) | ( LoanLateFeePercent );
  LoanPrincipalLateFee: ( LoanPrincipalLateFeeDisabled ) | ( LoanPrincipalLateFeeFixed ) | ( LoanPrincipalLateFeePercent );
  LoanTerminationFee: ( LoanTerminationFeeDisabled ) | ( LoanTerminationFeeFixed ) | ( LoanTerminationFeePercent );
  Modification: ( FlexModification ) | ( PrincipalModification );
  PaidOffRecord: ( TrackedPaidOffRecord ) | ( UntrackedPaidOffRecord );
  PaymentToPaymentDue: ( AdvanceBreakdown ) | ( BalanceReallocationBreakdown ) | ( FeeBreakdown ) | ( PayoffBreakdown ) | ( PrincipalPrepaymentBreakdown ) | ( StatementBreakdown ) | ( SuspenseBreakdown ) | ( ThirdPartyBreakdown );
  WorkoutPlan: ( BankruptcyCh13WorkoutPlan ) | ( DefermentWorkoutPlan ) | ( FlexModificationWorkoutPlan ) | ( ForbearanceWorkoutPlan ) | ( PaymentDeferralWorkoutPlan ) | ( RepaymentWorkoutPlan );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AccessTokenResponse: ResolverTypeWrapper<AccessTokenResponse>;
  AchBatchId: ResolverTypeWrapper<Scalars['AchBatchId']['output']>;
  AchBatchScheduleId: ResolverTypeWrapper<Scalars['AchBatchScheduleId']['output']>;
  AchBatchTransactionId: ResolverTypeWrapper<Scalars['AchBatchTransactionId']['output']>;
  Actor: ResolverTypeWrapper<Actor>;
  ActorType: ActorType;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  Advance: ResolverTypeWrapper<Omit<Advance, 'advanceConfig'> & { advanceConfig?: Maybe<ResolversTypes['AdvanceConfig']> }>;
  AdvanceBreakdown: ResolverTypeWrapper<AdvanceBreakdown>;
  AdvanceCategory: AdvanceCategory;
  AdvanceConfig: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AdvanceConfig']>;
  AdvanceType: AdvanceType;
  AmortizationType: AmortizationType;
  ApiKeyId: ResolverTypeWrapper<Scalars['ApiKeyId']['output']>;
  Appraisal: ResolverTypeWrapper<Appraisal>;
  AppraisalId: ResolverTypeWrapper<Scalars['AppraisalId']['output']>;
  AppraisalMethod: AppraisalMethod;
  AppraisalType: AppraisalType;
  ArmConfiguration: ResolverTypeWrapper<ArmConfiguration>;
  ArmRoundingType: ArmRoundingType;
  Attribution: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Attribution']>;
  AttributionType: AttributionType;
  AuditLogId: ResolverTypeWrapper<Scalars['AuditLogId']['output']>;
  AuthorizedContact: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AuthorizedContact']>;
  AuthorizedContactId: ResolverTypeWrapper<Scalars['AuthorizedContactId']['output']>;
  AuthorizedContactPayer: ResolverTypeWrapper<AuthorizedContactPayer>;
  AuthorizedContactType: AuthorizedContactType;
  AutopaySettings: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AutopaySettings']>;
  AutopaySettingsInput: AutopaySettingsInput;
  AutopaySettingsType: AutopaySettingsType;
  BalanceReallocationBreakdown: ResolverTypeWrapper<BalanceReallocationBreakdown>;
  Balances: ResolverTypeWrapper<Balances>;
  BalloonConfiguration: ResolverTypeWrapper<BalloonConfiguration>;
  BankruptcyCh13PaymentConfigChangeReason: BankruptcyCh13PaymentConfigChangeReason;
  BankruptcyCh13PrePetition: ResolverTypeWrapper<BankruptcyCh13PrePetition>;
  BankruptcyCh13PrePetitionArrearages: ResolverTypeWrapper<BankruptcyCh13PrePetitionArrearages>;
  BankruptcyCh13PrePetitionPaymentConfig: ResolverTypeWrapper<BankruptcyCh13PrePetitionPaymentConfig>;
  BankruptcyCh13WorkoutPlan: ResolverTypeWrapper<BankruptcyCh13WorkoutPlan>;
  BankruptcyId: ResolverTypeWrapper<Scalars['BankruptcyId']['output']>;
  BankruptcyPaymentPayer: BankruptcyPaymentPayer;
  BankruptcyProofOfClaimId: ResolverTypeWrapper<Scalars['BankruptcyProofOfClaimId']['output']>;
  BannerMessage: ResolverTypeWrapper<BannerMessage>;
  BannerMessageId: ResolverTypeWrapper<Scalars['BannerMessageId']['output']>;
  BillingStatus: BillingStatus;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Borrower: ResolverTypeWrapper<Omit<Borrower, 'preferredContactTimes'> & { preferredContactTimes: Array<ResolversTypes['DayAndTimeRange']> }>;
  BorrowerAchAccount: ResolverTypeWrapper<BorrowerAchAccount>;
  BorrowerAchAccountId: ResolverTypeWrapper<Scalars['BorrowerAchAccountId']['output']>;
  BorrowerEditInput: BorrowerEditInput;
  BorrowerId: ResolverTypeWrapper<Scalars['BorrowerId']['output']>;
  BorrowerMessageKey: BorrowerMessageKey;
  BorrowerMessageViews: ResolverTypeWrapper<BorrowerMessageViews>;
  BorrowerNotificationSettingsForAllCompaniesInput: BorrowerNotificationSettingsForAllCompaniesInput;
  BorrowerNotificationSettingsInput: BorrowerNotificationSettingsInput;
  BorrowerPayer: ResolverTypeWrapper<BorrowerPayer>;
  BorrowerPaymentSettings: ResolverTypeWrapper<BorrowerPaymentSettings>;
  BorrowerRequestSettings: ResolverTypeWrapper<BorrowerRequestSettings>;
  BuilderAuthorizedContact: ResolverTypeWrapper<BuilderAuthorizedContact>;
  CancelPaymentDeferralWorkoutPlanInput: CancelPaymentDeferralWorkoutPlanInput;
  CancelRepaymentWorkoutPlanInput: CancelRepaymentWorkoutPlanInput;
  Charge: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Charge']>;
  ChargeType: ChargeType;
  ChargeWorkoutPlan: ResolverTypeWrapper<ChargeWorkoutPlan>;
  ChatBotResponse: ResolverTypeWrapper<ChatBotResponse>;
  CitizenshipStatus: CitizenshipStatus;
  ColumnEnumMappingId: ResolverTypeWrapper<Scalars['ColumnEnumMappingId']['output']>;
  ColumnMappingId: ResolverTypeWrapper<Scalars['ColumnMappingId']['output']>;
  CompanyAchAccountId: ResolverTypeWrapper<Scalars['CompanyAchAccountId']['output']>;
  CompanyApplyDefaultInterestOnPastDueType: CompanyApplyDefaultInterestOnPastDueType;
  CompanyId: ResolverTypeWrapper<Scalars['CompanyId']['output']>;
  CompanyInterestOnEscrowSettingId: ResolverTypeWrapper<Scalars['CompanyInterestOnEscrowSettingId']['output']>;
  CompanyLogos: ResolverTypeWrapper<CompanyLogos>;
  CompanyWireSettings: ResolverTypeWrapper<CompanyWireSettings>;
  CompanyWireSettingsId: ResolverTypeWrapper<Scalars['CompanyWireSettingsId']['output']>;
  Configuration: ResolverTypeWrapper<Omit<Configuration, 'fees'> & { fees?: Maybe<ResolversTypes['LoanFees']> }>;
  ConstructionConfig: ResolverTypeWrapper<ConstructionConfig>;
  ConstructionLoanType: ConstructionLoanType;
  ConstructionToPermanentStatus: ConstructionToPermanentStatus;
  CreateBankruptcyCh13WorkoutPlanInput: CreateBankruptcyCh13WorkoutPlanInput;
  CreateBorrowerAchAccountInput: CreateBorrowerAchAccountInput;
  CreateFlexModificationWorkoutPlanInput: CreateFlexModificationWorkoutPlanInput;
  CreateForbearanceWorkoutPlanInput: CreateForbearanceWorkoutPlanInput;
  CreatePaymentDeferralWorkoutPlanInput: CreatePaymentDeferralWorkoutPlanInput;
  CreatePortalBorrowerAchAccountInput: CreatePortalBorrowerAchAccountInput;
  CreatePrincipalModificationInput: CreatePrincipalModificationInput;
  CreateRepayAccountInput: CreateRepayAccountInput;
  CreateRepaymentWorkoutPlanInput: CreateRepaymentWorkoutPlanInput;
  CurrentPaymentConfig: ResolverTypeWrapper<CurrentPaymentConfig>;
  CustodialAccountBalanceId: ResolverTypeWrapper<Scalars['CustodialAccountBalanceId']['output']>;
  CustodialAccountId: ResolverTypeWrapper<Scalars['CustodialAccountId']['output']>;
  CustomCompanyFieldId: ResolverTypeWrapper<Scalars['CustomCompanyFieldId']['output']>;
  CustomFAQItem: ResolverTypeWrapper<CustomFaqItem>;
  CustomFAQItemId: ResolverTypeWrapper<Scalars['CustomFAQItemId']['output']>;
  CustomFAQSection: ResolverTypeWrapper<CustomFaqSection>;
  CustomFAQSectionId: ResolverTypeWrapper<Scalars['CustomFAQSectionId']['output']>;
  CustomTemplateId: ResolverTypeWrapper<Scalars['CustomTemplateId']['output']>;
  DayAndTimeRange: ResolverTypeWrapper<Omit<DayAndTimeRange, 'endDay' | 'startDay' | 'timezone'> & { endDay: ResolversTypes['Weekday'], startDay: ResolversTypes['Weekday'], timezone: ResolversTypes['Timezone'] }>;
  DayAndTimeRangeInput: DayAndTimeRangeInput;
  DefermentWorkoutPlan: ResolverTypeWrapper<DefermentWorkoutPlan>;
  DefermentWorkoutPlanDocument: ResolverTypeWrapper<DefermentWorkoutPlanDocument>;
  DelinquentInterestAppliedDocument: ResolverTypeWrapper<DelinquentInterestAppliedDocument>;
  DelinquentInterestAttribution: ResolverTypeWrapper<DelinquentInterestAttribution>;
  DelinquentInterestSetting: ResolverTypeWrapper<DelinquentInterestSetting>;
  DelinquentInterestSettingId: ResolverTypeWrapper<Scalars['DelinquentInterestSettingId']['output']>;
  DirectoryPayee: ResolverTypeWrapper<DirectoryPayee>;
  Disbursement: ResolverTypeWrapper<Disbursement>;
  DisbursementAmounts: ResolverTypeWrapper<DisbursementAmounts>;
  DisbursementId: ResolverTypeWrapper<Scalars['DisbursementId']['output']>;
  DisbursementStatus: DisbursementStatus;
  DisbursementType: DisbursementType;
  Document: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Document']>;
  DocumentId: ResolverTypeWrapper<Scalars['DocumentId']['output']>;
  DocumentType: DocumentType;
  DownloadUrlResponse: ResolverTypeWrapper<DownloadUrlResponse>;
  DrawId: ResolverTypeWrapper<Scalars['DrawId']['output']>;
  DrawInterestAttribution: ResolverTypeWrapper<DrawInterestAttribution>;
  DwollaAutopaySettings: ResolverTypeWrapper<DwollaAutopaySettings>;
  DwollaBank: ResolverTypeWrapper<DwollaBank>;
  DwollaPaymentResponse: ResolverTypeWrapper<DwollaPaymentResponse>;
  DwollaUrls: ResolverTypeWrapper<DwollaUrls>;
  Entity: ResolverTypeWrapper<Entity>;
  EntityId: ResolverTypeWrapper<Scalars['EntityId']['output']>;
  EntityPayer: ResolverTypeWrapper<EntityPayer>;
  EscrowAdvanceConfig: ResolverTypeWrapper<EscrowAdvanceConfig>;
  EscrowAnalysisDocument: ResolverTypeWrapper<EscrowAnalysisDocument>;
  EscrowCompanyId: ResolverTypeWrapper<Scalars['EscrowCompanyId']['output']>;
  EscrowDue: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EscrowDue']>;
  EscrowDueId: ResolverTypeWrapper<Scalars['EscrowDueId']['output']>;
  EscrowDueInput: EscrowDueInput;
  EscrowInsuranceType: EscrowInsuranceType;
  EscrowPaymentHistoryItem: ResolverTypeWrapper<EscrowPaymentHistoryItem>;
  EscrowPaymentHistoryItemId: ResolverTypeWrapper<Scalars['EscrowPaymentHistoryItemId']['output']>;
  EscrowPaymentHistoryItemType: EscrowPaymentHistoryItemType;
  EscrowSetting: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EscrowSetting']>;
  EscrowSettingId: ResolverTypeWrapper<Scalars['EscrowSettingId']['output']>;
  EscrowSettingInput: EscrowSettingInput;
  EscrowSettingStatus: EscrowSettingStatus;
  EscrowSettingType: EscrowSettingType;
  EscrowType: EscrowType;
  EscrowWaiverRequestType: EscrowWaiverRequestType;
  Ethnicity: Ethnicity;
  ExpectedPayment: ResolverTypeWrapper<ExpectedPayment>;
  ExtendForbearanceWorkoutPlanInput: ExtendForbearanceWorkoutPlanInput;
  ExternalEntityId: ResolverTypeWrapper<Scalars['ExternalEntityId']['output']>;
  FHAProgramType: FhaProgramType;
  Fee: ResolverTypeWrapper<Fee>;
  FeeBreakdown: ResolverTypeWrapper<FeeBreakdown>;
  FeeId: ResolverTypeWrapper<Scalars['FeeId']['output']>;
  FeeLineItem: ResolverTypeWrapper<FeeLineItem>;
  FeeLineItemId: ResolverTypeWrapper<Scalars['FeeLineItemId']['output']>;
  FeeStatus: FeeStatus;
  FeeType: FeeType;
  FileImportId: ResolverTypeWrapper<Scalars['FileImportId']['output']>;
  FlagStopSettingsInput: FlagStopSettingsInput;
  FlexModification: ResolverTypeWrapper<FlexModification>;
  FlexModificationModification: ResolverTypeWrapper<FlexModificationModification>;
  FlexModificationWorkoutPlan: ResolverTypeWrapper<FlexModificationWorkoutPlan>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ForbearanceCancellationReason: ForbearanceCancellationReason;
  ForbearanceSubType: ForbearanceSubType;
  ForbearanceType: ForbearanceType;
  ForbearanceWorkoutPlan: ResolverTypeWrapper<ForbearanceWorkoutPlan>;
  ForbearanceWorkoutPlanExtension: ResolverTypeWrapper<ForbearanceWorkoutPlanExtension>;
  ForeclosureId: ResolverTypeWrapper<Scalars['ForeclosureId']['output']>;
  Form1098Document: ResolverTypeWrapper<Form1098Document>;
  Gender: Gender;
  GeneralDocument: ResolverTypeWrapper<GeneralDocument>;
  GetS3PresignedUploadUrlResponse: ResolverTypeWrapper<GetS3PresignedUploadUrlResponse>;
  GqlDate: ResolverTypeWrapper<Scalars['GqlDate']['output']>;
  GqlIsoDate: ResolverTypeWrapper<Scalars['GqlIsoDate']['output']>;
  GqlIsoDateTime: ResolverTypeWrapper<Scalars['GqlIsoDateTime']['output']>;
  GqlTemporalInstant: ResolverTypeWrapper<Scalars['GqlTemporalInstant']['output']>;
  GqlTemporalPlainTime: ResolverTypeWrapper<Scalars['GqlTemporalPlainTime']['output']>;
  GqlTimestamp: ResolverTypeWrapper<Scalars['GqlTimestamp']['output']>;
  HistoricalTransactionId: ResolverTypeWrapper<Scalars['HistoricalTransactionId']['output']>;
  IndexRateType: IndexRateType;
  InspectionGeneralCondition: InspectionGeneralCondition;
  InspectionId: ResolverTypeWrapper<Scalars['InspectionId']['output']>;
  InspectionInsurableDamages: InspectionInsurableDamages;
  InspectionOccupancyStatus: InspectionOccupancyStatus;
  InspectionOccupancyType: InspectionOccupancyType;
  InspectionOrderedReason: InspectionOrderedReason;
  InspectionType: InspectionType;
  InsuranceEscrowDue: ResolverTypeWrapper<InsuranceEscrowDue>;
  InsuranceEscrowSetting: ResolverTypeWrapper<Omit<InsuranceEscrowSetting, 'payee'> & { payee: ResolversTypes['Payee'] }>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InterestOnlyConfiguration: ResolverTypeWrapper<InterestOnlyConfiguration>;
  InterestOnlyType: InterestOnlyType;
  InterestRateChange: ResolverTypeWrapper<InterestRateChange>;
  InvestorId: ResolverTypeWrapper<Scalars['InvestorId']['output']>;
  InvestorRemittanceSplit: ResolverTypeWrapper<InvestorRemittanceSplit>;
  InvestorReportingId: ResolverTypeWrapper<Scalars['InvestorReportingId']['output']>;
  InvestorSplitOption: InvestorSplitOption;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  Language: Language;
  LegacyEscrowPayeeInput: LegacyEscrowPayeeInput;
  LegacyEscrowPayeeSnapshot: ResolverTypeWrapper<LegacyEscrowPayeeSnapshot>;
  LiquidationId: ResolverTypeWrapper<Scalars['LiquidationId']['output']>;
  LoanBillSettings: ResolverTypeWrapper<LoanBillSettings>;
  LoanBillSettingsType: LoanBillSettingsType;
  LoanChatMessage: ResolverTypeWrapper<TLoanChatMessage>;
  LoanChatMessageId: ResolverTypeWrapper<Scalars['LoanChatMessageId']['output']>;
  LoanChatMessages: ResolverTypeWrapper<Omit<LoanChatMessages, 'records'> & { records: Array<ResolversTypes['LoanChatMessage']> }>;
  LoanChatSender: ResolverTypeWrapper<TLoanChatSender>;
  LoanDetailsSettings: ResolverTypeWrapper<LoanDetailsSettings>;
  LoanFees: ResolverTypeWrapper<Omit<LoanFees, 'lateFee' | 'principalLateFee' | 'terminationFee'> & { lateFee?: Maybe<ResolversTypes['LoanLateFee']>, principalLateFee?: Maybe<ResolversTypes['LoanPrincipalLateFee']>, terminationFee?: Maybe<ResolversTypes['LoanTerminationFee']> }>;
  LoanId: ResolverTypeWrapper<Scalars['LoanId']['output']>;
  LoanInvestor: ResolverTypeWrapper<LoanInvestor>;
  LoanInvestorRemittanceSplit: ResolverTypeWrapper<LoanInvestorRemittanceSplit>;
  LoanInvestorRemittanceSplitInput: LoanInvestorRemittanceSplitInput;
  LoanLateFee: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LoanLateFee']>;
  LoanLateFeeFixed: ResolverTypeWrapper<LoanLateFeeFixed>;
  LoanLateFeePercent: ResolverTypeWrapper<LoanLateFeePercent>;
  LoanLateFeeType: LoanLateFeeType;
  LoanNoteContactRole: LoanNoteContactRole;
  LoanNoteContactType: LoanNoteContactType;
  LoanNoteId: ResolverTypeWrapper<Scalars['LoanNoteId']['output']>;
  LoanNoteReason: LoanNoteReason;
  LoanNoteTopicType: LoanNoteTopicType;
  LoanOwnerId: ResolverTypeWrapper<Scalars['LoanOwnerId']['output']>;
  LoanPrepaymentPenaltyFee: ResolverTypeWrapper<LoanPrepaymentPenaltyFee>;
  LoanPrepaymentPenaltyFeePlanType: LoanPrepaymentPenaltyFeePlanType;
  LoanPrincipalLateFee: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LoanPrincipalLateFee']>;
  LoanPrincipalLateFeeDisabled: ResolverTypeWrapper<LoanPrincipalLateFeeDisabled>;
  LoanPrincipalLateFeeFixed: ResolverTypeWrapper<LoanPrincipalLateFeeFixed>;
  LoanPrincipalLateFeePercent: ResolverTypeWrapper<LoanPrincipalLateFeePercent>;
  LoanPrincipalLateFeeType: LoanPrincipalLateFeeType;
  LoanPurpose: LoanPurpose;
  LoanStatus: LoanStatus;
  LoanStatusStopSettingsInput: LoanStatusStopSettingsInput;
  LoanTerminationFee: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LoanTerminationFee']>;
  LoanTerminationFeeDisabled: ResolverTypeWrapper<LoanTerminationFeeDisabled>;
  LoanTerminationFeeFixed: ResolverTypeWrapper<LoanTerminationFeeFixed>;
  LoanTerminationFeePercent: ResolverTypeWrapper<LoanTerminationFeePercent>;
  LoanTerminationFeeType: LoanTerminationFeeType;
  LosId: ResolverTypeWrapper<Scalars['LosId']['output']>;
  MERS: ResolverTypeWrapper<Mers>;
  MERSMIN: ResolverTypeWrapper<Scalars['MERSMIN']['output']>;
  MERSMINStatus: MersminStatus;
  MERSOrgId: ResolverTypeWrapper<Scalars['MERSOrgId']['output']>;
  MaturityConfig: ResolverTypeWrapper<MaturityConfig>;
  MaturityHistoryItem: ResolverTypeWrapper<MaturityHistoryItem>;
  Modification: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Modification']>;
  ModificationStatus: ModificationStatus;
  ModificationType: ModificationType;
  MortgageInsuranceCancellationEligibilityReason: MortgageInsuranceCancellationEligibilityReason;
  MortgageInsuranceCancellationInput: MortgageInsuranceCancellationInput;
  MortgageInsuranceDiscontinuanceCode: MortgageInsuranceDiscontinuanceCode;
  MortgageInsuranceEscrowDue: ResolverTypeWrapper<MortgageInsuranceEscrowDue>;
  MortgageInsuranceEscrowSetting: ResolverTypeWrapper<Omit<MortgageInsuranceEscrowSetting, 'payee'> & { payee: ResolversTypes['Payee'] }>;
  MortgageInsuranceRenewalType: MortgageInsuranceRenewalType;
  MortgageInsuranceType: MortgageInsuranceType;
  Mutation: ResolverTypeWrapper<{}>;
  NachaAutopaySettings: ResolverTypeWrapper<NachaAutopaySettings>;
  NachaAutopaySettingsInput: NachaAutopaySettingsInput;
  NonPerformanceCodeForReportingCycleId: ResolverTypeWrapper<Scalars['NonPerformanceCodeForReportingCycleId']['output']>;
  Noteholder: Noteholder;
  OccupancyType: OccupancyType;
  OpenPayoffStatus: OpenPayoffStatus;
  OriginationData: ResolverTypeWrapper<TOriginationData>;
  PMICancellationRequestPropertyValueType: PmiCancellationRequestPropertyValueType;
  PageSizeInt: ResolverTypeWrapper<Scalars['PageSizeInt']['output']>;
  PaidOffRecord: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PaidOffRecord']>;
  PaidOffType: PaidOffType;
  PartialPayoffInterestAttribution: ResolverTypeWrapper<PartialPayoffInterestAttribution>;
  Payee: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Payee']>;
  PayeeId: ResolverTypeWrapper<Scalars['PayeeId']['output']>;
  PayeePaymentMethod: PayeePaymentMethod;
  PayeeTaxType: PayeeTaxType;
  PayeeType: PayeeType;
  Payer: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Payer']>;
  PayerInput: PayerInput;
  Payment: ResolverTypeWrapper<Omit<Payment, 'payer'> & { payer: ResolversTypes['Payer'] }>;
  PaymentBreakdownEvent: PaymentBreakdownEvent;
  PaymentBreakdownId: ResolverTypeWrapper<Scalars['PaymentBreakdownId']['output']>;
  PaymentCadence: PaymentCadence;
  PaymentConfigId: ResolverTypeWrapper<Scalars['PaymentConfigId']['output']>;
  PaymentDeferralAcceptanceMethod: PaymentDeferralAcceptanceMethod;
  PaymentDeferralCancellationReason: PaymentDeferralCancellationReason;
  PaymentDeferralQuotedDeferredBalances: ResolverTypeWrapper<PaymentDeferralQuotedDeferredBalances>;
  PaymentDeferralQuotedDeferredBalancesInput: PaymentDeferralQuotedDeferredBalancesInput;
  PaymentDeferralReason: PaymentDeferralReason;
  PaymentDeferralWorkoutPlan: ResolverTypeWrapper<PaymentDeferralWorkoutPlan>;
  PaymentDue: ResolverTypeWrapper<Omit<PaymentDue, 'attribution'> & { attribution: Array<ResolversTypes['Attribution']> }>;
  PaymentDueId: ResolverTypeWrapper<Scalars['PaymentDueId']['output']>;
  PaymentDueSnapshot: ResolverTypeWrapper<PaymentDueSnapshot>;
  PaymentDueStatus: PaymentDueStatus;
  PaymentDueSubStatus: ResolverTypeWrapper<PaymentDueSubStatus>;
  PaymentId: ResolverTypeWrapper<Scalars['PaymentId']['output']>;
  PaymentMethod: PaymentMethod;
  PaymentSnapshot: ResolverTypeWrapper<PaymentSnapshot>;
  PaymentStatus: PaymentStatus;
  PaymentToPaymentDue: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PaymentToPaymentDue']>;
  PaymentToPaymentDueType: PaymentToPaymentDueType;
  Payoff: ResolverTypeWrapper<Payoff>;
  PayoffBreakdown: ResolverTypeWrapper<PayoffBreakdown>;
  PayoffDocument: ResolverTypeWrapper<PayoffDocument>;
  PayoffId: ResolverTypeWrapper<Scalars['PayoffId']['output']>;
  PayoffRecord: ResolverTypeWrapper<PayoffRecord>;
  PayoffStatus: PayoffStatus;
  PayoffWaiver: ResolverTypeWrapper<PayoffWaiver>;
  PermittedAction: PermittedAction;
  Phone: ResolverTypeWrapper<Phone>;
  PoolId: ResolverTypeWrapper<Scalars['PoolId']['output']>;
  PortalCompany: ResolverTypeWrapper<PortalCompany>;
  PortalCompanyAdminSettings: ResolverTypeWrapper<PortalCompanyAdminSettings>;
  PortalCompanyAdminSettingsApplications: ResolverTypeWrapper<PortalCompanyAdminSettingsApplications>;
  PortalLoan: ResolverTypeWrapper<Omit<PortalLoan, 'additionalBorrowers' | 'authorizedContacts' | 'configuration' | 'currentSnapshot' | 'primaryBorrower'> & { additionalBorrowers: Array<ResolversTypes['Borrower']>, authorizedContacts: Array<ResolversTypes['AuthorizedContact']>, configuration: ResolversTypes['Configuration'], currentSnapshot: ResolversTypes['PortalLoanSnapshot'], primaryBorrower: ResolversTypes['Borrower'] }>;
  PortalLoanSnapshot: ResolverTypeWrapper<Omit<PortalLoanSnapshot, 'activeWorkoutPlan' | 'autopaySettings' | 'charges' | 'documents' | 'offeredWorkoutPlans' | 'originationData' | 'paymentToPaymentDue' | 'payments' | 'paymentsDue'> & { activeWorkoutPlan?: Maybe<ResolversTypes['WorkoutPlan']>, autopaySettings?: Maybe<ResolversTypes['AutopaySettings']>, charges: Array<ResolversTypes['Charge']>, documents: Array<ResolversTypes['Document']>, offeredWorkoutPlans: Array<ResolversTypes['WorkoutPlan']>, originationData?: Maybe<ResolversTypes['OriginationData']>, paymentToPaymentDue: Array<ResolversTypes['PaymentToPaymentDue']>, payments: Array<ResolversTypes['Payment']>, paymentsDue: Array<ResolversTypes['PaymentDue']> }>;
  PortalPaymentStopSettingType: PortalPaymentStopSettingType;
  PortalSettings: ResolverTypeWrapper<PortalSettings>;
  PortalSettingsStatementPdf: ResolverTypeWrapper<PortalSettingsStatementPdf>;
  PortalUser: ResolverTypeWrapper<Omit<PortalUser, 'loan' | 'loans'> & { loan: ResolversTypes['PortalLoan'], loans: Array<ResolversTypes['PortalLoan']> }>;
  PortalUserActionResponse: ResolverTypeWrapper<Omit<PortalUserActionResponse, 'portalUser'> & { portalUser: ResolversTypes['PortalUser'] }>;
  PortalUserId: ResolverTypeWrapper<Scalars['PortalUserId']['output']>;
  PreviousServicer: ResolverTypeWrapper<PreviousServicer>;
  PrincipalModification: ResolverTypeWrapper<PrincipalModification>;
  PrincipalModificationAppliedDocument: ResolverTypeWrapper<PrincipalModificationAppliedDocument>;
  PrincipalModificationCancelledDocument: ResolverTypeWrapper<PrincipalModificationCancelledDocument>;
  PrincipalModificationCollectionType: PrincipalModificationCollectionType;
  PrincipalModificationId: ResolverTypeWrapper<Scalars['PrincipalModificationId']['output']>;
  PrincipalPrepaymentBreakdown: ResolverTypeWrapper<PrincipalPrepaymentBreakdown>;
  ProductType: ProductType;
  Property: ResolverTypeWrapper<Property>;
  PropertyId: ResolverTypeWrapper<Scalars['PropertyId']['output']>;
  QcDocumentId: ResolverTypeWrapper<Scalars['QcDocumentId']['output']>;
  QrpcId: ResolverTypeWrapper<Scalars['QrpcId']['output']>;
  QrpcOccupancyStatus: QrpcOccupancyStatus;
  QrpcReason: QrpcReason;
  Query: ResolverTypeWrapper<{}>;
  RecordWriteoffInput: RecordWriteoffInput;
  RepayAccount: ResolverTypeWrapper<RepayAccount>;
  RepayAccountId: ResolverTypeWrapper<Scalars['RepayAccountId']['output']>;
  RepayAutopaySettings: ResolverTypeWrapper<RepayAutopaySettings>;
  RepayAutopaySettingsInput: RepayAutopaySettingsInput;
  RepaymentArrearagesBreakdown: ResolverTypeWrapper<RepaymentArrearagesBreakdown>;
  RepaymentPlanCancellationReason: RepaymentPlanCancellationReason;
  RepaymentWorkoutPlan: ResolverTypeWrapper<RepaymentWorkoutPlan>;
  ReportableEventId: ResolverTypeWrapper<Scalars['ReportableEventId']['output']>;
  SftpKeyId: ResolverTypeWrapper<Scalars['SftpKeyId']['output']>;
  SftpSiteId: ResolverTypeWrapper<Scalars['SftpSiteId']['output']>;
  SortBy: SortBy;
  StandardAdvanceConfig: ResolverTypeWrapper<StandardAdvanceConfig>;
  StandardInterestAttribution: ResolverTypeWrapper<StandardInterestAttribution>;
  Statement: ResolverTypeWrapper<Statement>;
  StatementBreakdown: ResolverTypeWrapper<StatementBreakdown>;
  StopSettings: ResolverTypeWrapper<StopSettings>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SuccessResponse: ResolverTypeWrapper<SuccessResponse>;
  SuccessResponseWithFailureReason: ResolverTypeWrapper<SuccessResponseWithFailureReason>;
  SupportHours: ResolverTypeWrapper<SupportHours>;
  SuspenseBreakdown: ResolverTypeWrapper<SuspenseBreakdown>;
  TaskAuditLogId: ResolverTypeWrapper<Scalars['TaskAuditLogId']['output']>;
  TaxDetails: ResolverTypeWrapper<TaxDetails>;
  TaxEscrowDue: ResolverTypeWrapper<TaxEscrowDue>;
  TaxEscrowSetting: ResolverTypeWrapper<Omit<TaxEscrowSetting, 'payee'> & { payee: ResolversTypes['Payee'] }>;
  TaxEscrowType: TaxEscrowType;
  ThirdPartyAuthorizedContact: ResolverTypeWrapper<ThirdPartyAuthorizedContact>;
  ThirdPartyBreakdown: ResolverTypeWrapper<ThirdPartyBreakdown>;
  ThirdPartyPayer: ResolverTypeWrapper<ThirdPartyPayer>;
  Timezone: ResolverTypeWrapper<TTimezone>;
  TotalPaid: ResolverTypeWrapper<TotalPaid>;
  TrackedPaidOffRecord: ResolverTypeWrapper<TrackedPaidOffRecord>;
  TransactionActivity: ResolverTypeWrapper<TransactionActivity>;
  TransferData: ResolverTypeWrapper<TransferData>;
  UntrackedPaidOffRecord: ResolverTypeWrapper<UntrackedPaidOffRecord>;
  UploadDocument: ResolverTypeWrapper<UploadDocument>;
  UserId: ResolverTypeWrapper<Scalars['UserId']['output']>;
  UsioAccount: ResolverTypeWrapper<UsioAccount>;
  UsioAccountId: ResolverTypeWrapper<Scalars['UsioAccountId']['output']>;
  UsioAutopaySettings: ResolverTypeWrapper<UsioAutopaySettings>;
  VerificationOfMortgageDocument: ResolverTypeWrapper<VerificationOfMortgageDocument>;
  VerificationOfMortgagePurpose: VerificationOfMortgagePurpose;
  VerificationOfMortgageRequestInput: VerificationOfMortgageRequestInput;
  Weekday: ResolverTypeWrapper<TWeekday>;
  WorkoutPlan: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['WorkoutPlan']>;
  WorkoutPlanId: ResolverTypeWrapper<Scalars['WorkoutPlanId']['output']>;
  WorkoutPlanIneligibleModificationInput: WorkoutPlanIneligibleModificationInput;
  WorkoutPlanIneligibleModifications: ResolverTypeWrapper<WorkoutPlanIneligibleModifications>;
  WorkoutPlanPaymentDue: ResolverTypeWrapper<WorkoutPlanPaymentDue>;
  WorkoutPlanPaymentDueStatus: ResolverTypeWrapper<WorkoutPlanPaymentDueStatus>;
  WorkoutPlanReason: WorkoutPlanReason;
  WorkoutPlanStatus: WorkoutPlanStatus;
  WorkoutPlanType: WorkoutPlanType;
  WorkoutPlanWorkflowInformation: ResolverTypeWrapper<WorkoutPlanWorkflowInformation>;
  Writeoff: ResolverTypeWrapper<Writeoff>;
  WriteoffAmounts: ResolverTypeWrapper<WriteoffAmounts>;
  WriteoffId: ResolverTypeWrapper<Scalars['WriteoffId']['output']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AccessTokenResponse: AccessTokenResponse;
  AchBatchId: Scalars['AchBatchId']['output'];
  AchBatchScheduleId: Scalars['AchBatchScheduleId']['output'];
  AchBatchTransactionId: Scalars['AchBatchTransactionId']['output'];
  Actor: Actor;
  Address: Address;
  AddressInput: AddressInput;
  Advance: Omit<Advance, 'advanceConfig'> & { advanceConfig?: Maybe<ResolversParentTypes['AdvanceConfig']> };
  AdvanceBreakdown: AdvanceBreakdown;
  AdvanceConfig: ResolversUnionTypes<ResolversParentTypes>['AdvanceConfig'];
  ApiKeyId: Scalars['ApiKeyId']['output'];
  Appraisal: Appraisal;
  AppraisalId: Scalars['AppraisalId']['output'];
  ArmConfiguration: ArmConfiguration;
  Attribution: ResolversInterfaceTypes<ResolversParentTypes>['Attribution'];
  AuditLogId: Scalars['AuditLogId']['output'];
  AuthorizedContact: ResolversInterfaceTypes<ResolversParentTypes>['AuthorizedContact'];
  AuthorizedContactId: Scalars['AuthorizedContactId']['output'];
  AuthorizedContactPayer: AuthorizedContactPayer;
  AutopaySettings: ResolversUnionTypes<ResolversParentTypes>['AutopaySettings'];
  AutopaySettingsInput: AutopaySettingsInput;
  BalanceReallocationBreakdown: BalanceReallocationBreakdown;
  Balances: Balances;
  BalloonConfiguration: BalloonConfiguration;
  BankruptcyCh13PrePetition: BankruptcyCh13PrePetition;
  BankruptcyCh13PrePetitionArrearages: BankruptcyCh13PrePetitionArrearages;
  BankruptcyCh13PrePetitionPaymentConfig: BankruptcyCh13PrePetitionPaymentConfig;
  BankruptcyCh13WorkoutPlan: BankruptcyCh13WorkoutPlan;
  BankruptcyId: Scalars['BankruptcyId']['output'];
  BankruptcyProofOfClaimId: Scalars['BankruptcyProofOfClaimId']['output'];
  BannerMessage: BannerMessage;
  BannerMessageId: Scalars['BannerMessageId']['output'];
  Boolean: Scalars['Boolean']['output'];
  Borrower: Omit<Borrower, 'preferredContactTimes'> & { preferredContactTimes: Array<ResolversParentTypes['DayAndTimeRange']> };
  BorrowerAchAccount: BorrowerAchAccount;
  BorrowerAchAccountId: Scalars['BorrowerAchAccountId']['output'];
  BorrowerEditInput: BorrowerEditInput;
  BorrowerId: Scalars['BorrowerId']['output'];
  BorrowerMessageViews: BorrowerMessageViews;
  BorrowerNotificationSettingsForAllCompaniesInput: BorrowerNotificationSettingsForAllCompaniesInput;
  BorrowerNotificationSettingsInput: BorrowerNotificationSettingsInput;
  BorrowerPayer: BorrowerPayer;
  BorrowerPaymentSettings: BorrowerPaymentSettings;
  BorrowerRequestSettings: BorrowerRequestSettings;
  BuilderAuthorizedContact: BuilderAuthorizedContact;
  CancelPaymentDeferralWorkoutPlanInput: CancelPaymentDeferralWorkoutPlanInput;
  CancelRepaymentWorkoutPlanInput: CancelRepaymentWorkoutPlanInput;
  Charge: ResolversUnionTypes<ResolversParentTypes>['Charge'];
  ChargeWorkoutPlan: ChargeWorkoutPlan;
  ChatBotResponse: ChatBotResponse;
  ColumnEnumMappingId: Scalars['ColumnEnumMappingId']['output'];
  ColumnMappingId: Scalars['ColumnMappingId']['output'];
  CompanyAchAccountId: Scalars['CompanyAchAccountId']['output'];
  CompanyId: Scalars['CompanyId']['output'];
  CompanyInterestOnEscrowSettingId: Scalars['CompanyInterestOnEscrowSettingId']['output'];
  CompanyLogos: CompanyLogos;
  CompanyWireSettings: CompanyWireSettings;
  CompanyWireSettingsId: Scalars['CompanyWireSettingsId']['output'];
  Configuration: Omit<Configuration, 'fees'> & { fees?: Maybe<ResolversParentTypes['LoanFees']> };
  ConstructionConfig: ConstructionConfig;
  CreateBankruptcyCh13WorkoutPlanInput: CreateBankruptcyCh13WorkoutPlanInput;
  CreateBorrowerAchAccountInput: CreateBorrowerAchAccountInput;
  CreateFlexModificationWorkoutPlanInput: CreateFlexModificationWorkoutPlanInput;
  CreateForbearanceWorkoutPlanInput: CreateForbearanceWorkoutPlanInput;
  CreatePaymentDeferralWorkoutPlanInput: CreatePaymentDeferralWorkoutPlanInput;
  CreatePortalBorrowerAchAccountInput: CreatePortalBorrowerAchAccountInput;
  CreatePrincipalModificationInput: CreatePrincipalModificationInput;
  CreateRepayAccountInput: CreateRepayAccountInput;
  CreateRepaymentWorkoutPlanInput: CreateRepaymentWorkoutPlanInput;
  CurrentPaymentConfig: CurrentPaymentConfig;
  CustodialAccountBalanceId: Scalars['CustodialAccountBalanceId']['output'];
  CustodialAccountId: Scalars['CustodialAccountId']['output'];
  CustomCompanyFieldId: Scalars['CustomCompanyFieldId']['output'];
  CustomFAQItem: CustomFaqItem;
  CustomFAQItemId: Scalars['CustomFAQItemId']['output'];
  CustomFAQSection: CustomFaqSection;
  CustomFAQSectionId: Scalars['CustomFAQSectionId']['output'];
  CustomTemplateId: Scalars['CustomTemplateId']['output'];
  DayAndTimeRange: DayAndTimeRange;
  DayAndTimeRangeInput: DayAndTimeRangeInput;
  DefermentWorkoutPlan: DefermentWorkoutPlan;
  DefermentWorkoutPlanDocument: DefermentWorkoutPlanDocument;
  DelinquentInterestAppliedDocument: DelinquentInterestAppliedDocument;
  DelinquentInterestAttribution: DelinquentInterestAttribution;
  DelinquentInterestSetting: DelinquentInterestSetting;
  DelinquentInterestSettingId: Scalars['DelinquentInterestSettingId']['output'];
  DirectoryPayee: DirectoryPayee;
  Disbursement: Disbursement;
  DisbursementAmounts: DisbursementAmounts;
  DisbursementId: Scalars['DisbursementId']['output'];
  Document: ResolversInterfaceTypes<ResolversParentTypes>['Document'];
  DocumentId: Scalars['DocumentId']['output'];
  DownloadUrlResponse: DownloadUrlResponse;
  DrawId: Scalars['DrawId']['output'];
  DrawInterestAttribution: DrawInterestAttribution;
  DwollaAutopaySettings: DwollaAutopaySettings;
  DwollaBank: DwollaBank;
  DwollaPaymentResponse: DwollaPaymentResponse;
  DwollaUrls: DwollaUrls;
  Entity: Entity;
  EntityId: Scalars['EntityId']['output'];
  EntityPayer: EntityPayer;
  EscrowAdvanceConfig: EscrowAdvanceConfig;
  EscrowAnalysisDocument: EscrowAnalysisDocument;
  EscrowCompanyId: Scalars['EscrowCompanyId']['output'];
  EscrowDue: ResolversInterfaceTypes<ResolversParentTypes>['EscrowDue'];
  EscrowDueId: Scalars['EscrowDueId']['output'];
  EscrowDueInput: EscrowDueInput;
  EscrowPaymentHistoryItem: EscrowPaymentHistoryItem;
  EscrowPaymentHistoryItemId: Scalars['EscrowPaymentHistoryItemId']['output'];
  EscrowSetting: ResolversInterfaceTypes<ResolversParentTypes>['EscrowSetting'];
  EscrowSettingId: Scalars['EscrowSettingId']['output'];
  EscrowSettingInput: EscrowSettingInput;
  ExpectedPayment: ExpectedPayment;
  ExtendForbearanceWorkoutPlanInput: ExtendForbearanceWorkoutPlanInput;
  ExternalEntityId: Scalars['ExternalEntityId']['output'];
  Fee: Fee;
  FeeBreakdown: FeeBreakdown;
  FeeId: Scalars['FeeId']['output'];
  FeeLineItem: FeeLineItem;
  FeeLineItemId: Scalars['FeeLineItemId']['output'];
  FileImportId: Scalars['FileImportId']['output'];
  FlagStopSettingsInput: FlagStopSettingsInput;
  FlexModification: FlexModification;
  FlexModificationModification: FlexModificationModification;
  FlexModificationWorkoutPlan: FlexModificationWorkoutPlan;
  Float: Scalars['Float']['output'];
  ForbearanceWorkoutPlan: ForbearanceWorkoutPlan;
  ForbearanceWorkoutPlanExtension: ForbearanceWorkoutPlanExtension;
  ForeclosureId: Scalars['ForeclosureId']['output'];
  Form1098Document: Form1098Document;
  GeneralDocument: GeneralDocument;
  GetS3PresignedUploadUrlResponse: GetS3PresignedUploadUrlResponse;
  GqlDate: Scalars['GqlDate']['output'];
  GqlIsoDate: Scalars['GqlIsoDate']['output'];
  GqlIsoDateTime: Scalars['GqlIsoDateTime']['output'];
  GqlTemporalInstant: Scalars['GqlTemporalInstant']['output'];
  GqlTemporalPlainTime: Scalars['GqlTemporalPlainTime']['output'];
  GqlTimestamp: Scalars['GqlTimestamp']['output'];
  HistoricalTransactionId: Scalars['HistoricalTransactionId']['output'];
  InspectionId: Scalars['InspectionId']['output'];
  InsuranceEscrowDue: InsuranceEscrowDue;
  InsuranceEscrowSetting: Omit<InsuranceEscrowSetting, 'payee'> & { payee: ResolversParentTypes['Payee'] };
  Int: Scalars['Int']['output'];
  InterestOnlyConfiguration: InterestOnlyConfiguration;
  InterestRateChange: InterestRateChange;
  InvestorId: Scalars['InvestorId']['output'];
  InvestorRemittanceSplit: InvestorRemittanceSplit;
  InvestorReportingId: Scalars['InvestorReportingId']['output'];
  JSON: Scalars['JSON']['output'];
  LegacyEscrowPayeeInput: LegacyEscrowPayeeInput;
  LegacyEscrowPayeeSnapshot: LegacyEscrowPayeeSnapshot;
  LiquidationId: Scalars['LiquidationId']['output'];
  LoanBillSettings: LoanBillSettings;
  LoanChatMessage: TLoanChatMessage;
  LoanChatMessageId: Scalars['LoanChatMessageId']['output'];
  LoanChatMessages: Omit<LoanChatMessages, 'records'> & { records: Array<ResolversParentTypes['LoanChatMessage']> };
  LoanDetailsSettings: LoanDetailsSettings;
  LoanFees: Omit<LoanFees, 'lateFee' | 'principalLateFee' | 'terminationFee'> & { lateFee?: Maybe<ResolversParentTypes['LoanLateFee']>, principalLateFee?: Maybe<ResolversParentTypes['LoanPrincipalLateFee']>, terminationFee?: Maybe<ResolversParentTypes['LoanTerminationFee']> };
  LoanId: Scalars['LoanId']['output'];
  LoanInvestor: LoanInvestor;
  LoanInvestorRemittanceSplit: LoanInvestorRemittanceSplit;
  LoanInvestorRemittanceSplitInput: LoanInvestorRemittanceSplitInput;
  LoanLateFee: ResolversInterfaceTypes<ResolversParentTypes>['LoanLateFee'];
  LoanLateFeeFixed: LoanLateFeeFixed;
  LoanLateFeePercent: LoanLateFeePercent;
  LoanNoteId: Scalars['LoanNoteId']['output'];
  LoanOwnerId: Scalars['LoanOwnerId']['output'];
  LoanPrepaymentPenaltyFee: LoanPrepaymentPenaltyFee;
  LoanPrincipalLateFee: ResolversInterfaceTypes<ResolversParentTypes>['LoanPrincipalLateFee'];
  LoanPrincipalLateFeeDisabled: LoanPrincipalLateFeeDisabled;
  LoanPrincipalLateFeeFixed: LoanPrincipalLateFeeFixed;
  LoanPrincipalLateFeePercent: LoanPrincipalLateFeePercent;
  LoanStatusStopSettingsInput: LoanStatusStopSettingsInput;
  LoanTerminationFee: ResolversInterfaceTypes<ResolversParentTypes>['LoanTerminationFee'];
  LoanTerminationFeeDisabled: LoanTerminationFeeDisabled;
  LoanTerminationFeeFixed: LoanTerminationFeeFixed;
  LoanTerminationFeePercent: LoanTerminationFeePercent;
  LosId: Scalars['LosId']['output'];
  MERS: Mers;
  MERSMIN: Scalars['MERSMIN']['output'];
  MERSOrgId: Scalars['MERSOrgId']['output'];
  MaturityConfig: MaturityConfig;
  MaturityHistoryItem: MaturityHistoryItem;
  Modification: ResolversInterfaceTypes<ResolversParentTypes>['Modification'];
  MortgageInsuranceCancellationInput: MortgageInsuranceCancellationInput;
  MortgageInsuranceEscrowDue: MortgageInsuranceEscrowDue;
  MortgageInsuranceEscrowSetting: Omit<MortgageInsuranceEscrowSetting, 'payee'> & { payee: ResolversParentTypes['Payee'] };
  Mutation: {};
  NachaAutopaySettings: NachaAutopaySettings;
  NachaAutopaySettingsInput: NachaAutopaySettingsInput;
  NonPerformanceCodeForReportingCycleId: Scalars['NonPerformanceCodeForReportingCycleId']['output'];
  OriginationData: TOriginationData;
  PageSizeInt: Scalars['PageSizeInt']['output'];
  PaidOffRecord: ResolversInterfaceTypes<ResolversParentTypes>['PaidOffRecord'];
  PartialPayoffInterestAttribution: PartialPayoffInterestAttribution;
  Payee: ResolversUnionTypes<ResolversParentTypes>['Payee'];
  PayeeId: Scalars['PayeeId']['output'];
  Payer: ResolversUnionTypes<ResolversParentTypes>['Payer'];
  PayerInput: PayerInput;
  Payment: Omit<Payment, 'payer'> & { payer: ResolversParentTypes['Payer'] };
  PaymentBreakdownId: Scalars['PaymentBreakdownId']['output'];
  PaymentConfigId: Scalars['PaymentConfigId']['output'];
  PaymentDeferralQuotedDeferredBalances: PaymentDeferralQuotedDeferredBalances;
  PaymentDeferralQuotedDeferredBalancesInput: PaymentDeferralQuotedDeferredBalancesInput;
  PaymentDeferralWorkoutPlan: PaymentDeferralWorkoutPlan;
  PaymentDue: Omit<PaymentDue, 'attribution'> & { attribution: Array<ResolversParentTypes['Attribution']> };
  PaymentDueId: Scalars['PaymentDueId']['output'];
  PaymentDueSnapshot: PaymentDueSnapshot;
  PaymentDueSubStatus: PaymentDueSubStatus;
  PaymentId: Scalars['PaymentId']['output'];
  PaymentSnapshot: PaymentSnapshot;
  PaymentToPaymentDue: ResolversInterfaceTypes<ResolversParentTypes>['PaymentToPaymentDue'];
  Payoff: Payoff;
  PayoffBreakdown: PayoffBreakdown;
  PayoffDocument: PayoffDocument;
  PayoffId: Scalars['PayoffId']['output'];
  PayoffRecord: PayoffRecord;
  PayoffWaiver: PayoffWaiver;
  Phone: Phone;
  PoolId: Scalars['PoolId']['output'];
  PortalCompany: PortalCompany;
  PortalCompanyAdminSettings: PortalCompanyAdminSettings;
  PortalCompanyAdminSettingsApplications: PortalCompanyAdminSettingsApplications;
  PortalLoan: Omit<PortalLoan, 'additionalBorrowers' | 'authorizedContacts' | 'configuration' | 'currentSnapshot' | 'primaryBorrower'> & { additionalBorrowers: Array<ResolversParentTypes['Borrower']>, authorizedContacts: Array<ResolversParentTypes['AuthorizedContact']>, configuration: ResolversParentTypes['Configuration'], currentSnapshot: ResolversParentTypes['PortalLoanSnapshot'], primaryBorrower: ResolversParentTypes['Borrower'] };
  PortalLoanSnapshot: Omit<PortalLoanSnapshot, 'activeWorkoutPlan' | 'autopaySettings' | 'charges' | 'documents' | 'offeredWorkoutPlans' | 'originationData' | 'paymentToPaymentDue' | 'payments' | 'paymentsDue'> & { activeWorkoutPlan?: Maybe<ResolversParentTypes['WorkoutPlan']>, autopaySettings?: Maybe<ResolversParentTypes['AutopaySettings']>, charges: Array<ResolversParentTypes['Charge']>, documents: Array<ResolversParentTypes['Document']>, offeredWorkoutPlans: Array<ResolversParentTypes['WorkoutPlan']>, originationData?: Maybe<ResolversParentTypes['OriginationData']>, paymentToPaymentDue: Array<ResolversParentTypes['PaymentToPaymentDue']>, payments: Array<ResolversParentTypes['Payment']>, paymentsDue: Array<ResolversParentTypes['PaymentDue']> };
  PortalSettings: PortalSettings;
  PortalSettingsStatementPdf: PortalSettingsStatementPdf;
  PortalUser: Omit<PortalUser, 'loan' | 'loans'> & { loan: ResolversParentTypes['PortalLoan'], loans: Array<ResolversParentTypes['PortalLoan']> };
  PortalUserActionResponse: Omit<PortalUserActionResponse, 'portalUser'> & { portalUser: ResolversParentTypes['PortalUser'] };
  PortalUserId: Scalars['PortalUserId']['output'];
  PreviousServicer: PreviousServicer;
  PrincipalModification: PrincipalModification;
  PrincipalModificationAppliedDocument: PrincipalModificationAppliedDocument;
  PrincipalModificationCancelledDocument: PrincipalModificationCancelledDocument;
  PrincipalModificationId: Scalars['PrincipalModificationId']['output'];
  PrincipalPrepaymentBreakdown: PrincipalPrepaymentBreakdown;
  Property: Property;
  PropertyId: Scalars['PropertyId']['output'];
  QcDocumentId: Scalars['QcDocumentId']['output'];
  QrpcId: Scalars['QrpcId']['output'];
  Query: {};
  RecordWriteoffInput: RecordWriteoffInput;
  RepayAccount: RepayAccount;
  RepayAccountId: Scalars['RepayAccountId']['output'];
  RepayAutopaySettings: RepayAutopaySettings;
  RepayAutopaySettingsInput: RepayAutopaySettingsInput;
  RepaymentArrearagesBreakdown: RepaymentArrearagesBreakdown;
  RepaymentWorkoutPlan: RepaymentWorkoutPlan;
  ReportableEventId: Scalars['ReportableEventId']['output'];
  SftpKeyId: Scalars['SftpKeyId']['output'];
  SftpSiteId: Scalars['SftpSiteId']['output'];
  SortBy: SortBy;
  StandardAdvanceConfig: StandardAdvanceConfig;
  StandardInterestAttribution: StandardInterestAttribution;
  Statement: Statement;
  StatementBreakdown: StatementBreakdown;
  StopSettings: StopSettings;
  String: Scalars['String']['output'];
  SuccessResponse: SuccessResponse;
  SuccessResponseWithFailureReason: SuccessResponseWithFailureReason;
  SupportHours: SupportHours;
  SuspenseBreakdown: SuspenseBreakdown;
  TaskAuditLogId: Scalars['TaskAuditLogId']['output'];
  TaxDetails: TaxDetails;
  TaxEscrowDue: TaxEscrowDue;
  TaxEscrowSetting: Omit<TaxEscrowSetting, 'payee'> & { payee: ResolversParentTypes['Payee'] };
  ThirdPartyAuthorizedContact: ThirdPartyAuthorizedContact;
  ThirdPartyBreakdown: ThirdPartyBreakdown;
  ThirdPartyPayer: ThirdPartyPayer;
  TotalPaid: TotalPaid;
  TrackedPaidOffRecord: TrackedPaidOffRecord;
  TransactionActivity: TransactionActivity;
  TransferData: TransferData;
  UntrackedPaidOffRecord: UntrackedPaidOffRecord;
  UploadDocument: UploadDocument;
  UserId: Scalars['UserId']['output'];
  UsioAccount: UsioAccount;
  UsioAccountId: Scalars['UsioAccountId']['output'];
  UsioAutopaySettings: UsioAutopaySettings;
  VerificationOfMortgageDocument: VerificationOfMortgageDocument;
  VerificationOfMortgageRequestInput: VerificationOfMortgageRequestInput;
  WorkoutPlan: ResolversInterfaceTypes<ResolversParentTypes>['WorkoutPlan'];
  WorkoutPlanId: Scalars['WorkoutPlanId']['output'];
  WorkoutPlanIneligibleModificationInput: WorkoutPlanIneligibleModificationInput;
  WorkoutPlanIneligibleModifications: WorkoutPlanIneligibleModifications;
  WorkoutPlanPaymentDue: WorkoutPlanPaymentDue;
  WorkoutPlanPaymentDueStatus: WorkoutPlanPaymentDueStatus;
  WorkoutPlanWorkflowInformation: WorkoutPlanWorkflowInformation;
  Writeoff: Writeoff;
  WriteoffAmounts: WriteoffAmounts;
  WriteoffId: Scalars['WriteoffId']['output'];
};

export type IsAdminOrUserInLoanDirectiveArgs = { };

export type IsAdminOrUserInLoanDirectiveResolver<Result, Parent, ContextType = any, Args = IsAdminOrUserInLoanDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type IsUserInLoanDirectiveArgs = { };

export type IsUserInLoanDirectiveResolver<Result, Parent, ContextType = any, Args = IsUserInLoanDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccessTokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessTokenResponse'] = ResolversParentTypes['AccessTokenResponse']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AchBatchIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AchBatchId'], any> {
  name: 'AchBatchId';
}

export interface AchBatchScheduleIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AchBatchScheduleId'], any> {
  name: 'AchBatchScheduleId';
}

export interface AchBatchTransactionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AchBatchTransactionId'], any> {
  name: 'AchBatchTransactionId';
}

export type ActorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Actor'] = ResolversParentTypes['Actor']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ActorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locality?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advance'] = ResolversParentTypes['Advance']> = {
  advanceConfig?: Resolver<Maybe<ResolversTypes['AdvanceConfig']>, ParentType, ContextType>;
  advanceInterest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  advanceInterestUpdatedAt?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  advancePrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chargeDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['GqlIsoDateTime']>, ParentType, ContextType>;
  dWorkoutPlan?: Resolver<Maybe<ResolversTypes['ChargeWorkoutPlan']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['FeeId'], ParentType, ContextType>;
  investorRemittanceSplit?: Resolver<Maybe<ResolversTypes['InvestorRemittanceSplit']>, ParentType, ContextType>;
  isDeferred?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrePetition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originalPrincipal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payeeId?: Resolver<Maybe<ResolversTypes['PayeeId']>, ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FeeStatus'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ChargeType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvanceBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvanceBreakdown'] = ResolversParentTypes['AdvanceBreakdown']> = {
  advance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  advanceInterest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  feeId?: Resolver<ResolversTypes['FeeId'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvanceConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvanceConfig'] = ResolversParentTypes['AdvanceConfig']> = {
  __resolveType: TypeResolveFn<'EscrowAdvanceConfig' | 'StandardAdvanceConfig', ParentType, ContextType>;
};

export interface ApiKeyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ApiKeyId'], any> {
  name: 'ApiKeyId';
}

export type AppraisalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Appraisal'] = ResolversParentTypes['Appraisal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  appraisalMethod?: Resolver<ResolversTypes['AppraisalMethod'], ParentType, ContextType>;
  appraisalType?: Resolver<ResolversTypes['AppraisalType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['AppraisalId'], ParentType, ContextType>;
  isOriginal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AppraisalIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AppraisalId'], any> {
  name: 'AppraisalId';
}

export type ArmConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArmConfiguration'] = ResolversParentTypes['ArmConfiguration']> = {
  adjustmentLeadCountDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  armFirstRateChangeDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  armIndex?: Resolver<Maybe<ResolversTypes['IndexRateType']>, ParentType, ContextType>;
  margin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxIncreaseForFirstPeriod?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxIncreasePerPeriod?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minIncreaseForFirstPeriod?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minIncreasePerPeriod?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateAdjustmentFrequency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rateCeiling?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateFloor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  roundingPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  roundingType?: Resolver<Maybe<ResolversTypes['ArmRoundingType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attribution'] = ResolversParentTypes['Attribution']> = {
  __resolveType: TypeResolveFn<'DelinquentInterestAttribution' | 'DrawInterestAttribution' | 'PartialPayoffInterestAttribution' | 'StandardInterestAttribution', ParentType, ContextType>;
  dailyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  periodInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  startOfPeriodPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttributionType'], ParentType, ContextType>;
};

export interface AuditLogIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AuditLogId'], any> {
  name: 'AuditLogId';
}

export type AuthorizedContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizedContact'] = ResolversParentTypes['AuthorizedContact']> = {
  __resolveType: TypeResolveFn<'BuilderAuthorizedContact' | 'ThirdPartyAuthorizedContact', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['AuthorizedContactId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthorizedContactType'], ParentType, ContextType>;
};

export interface AuthorizedContactIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AuthorizedContactId'], any> {
  name: 'AuthorizedContactId';
}

export type AuthorizedContactPayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizedContactPayer'] = ResolversParentTypes['AuthorizedContactPayer']> = {
  authorizedContactId?: Resolver<ResolversTypes['AuthorizedContactId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutopaySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutopaySettings'] = ResolversParentTypes['AutopaySettings']> = {
  __resolveType: TypeResolveFn<'DwollaAutopaySettings' | 'NachaAutopaySettings' | 'RepayAutopaySettings' | 'UsioAutopaySettings', ParentType, ContextType>;
};

export type BalanceReallocationBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceReallocationBreakdown'] = ResolversParentTypes['BalanceReallocationBreakdown']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  futureStatementSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  holdback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  lossDraft?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Balances'] = ResolversParentTypes['Balances']> = {
  escrowBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  holdbackBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lossDraftBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  principalPrepaymentBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reserveBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  suspenseBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalloonConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalloonConfiguration'] = ResolversParentTypes['BalloonConfiguration']> = {
  amortizationTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankruptcyCh13PrePetitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankruptcyCh13PrePetition'] = ResolversParentTypes['BankruptcyCh13PrePetition']> = {
  arrearages?: Resolver<ResolversTypes['BankruptcyCh13PrePetitionArrearages'], ParentType, ContextType>;
  paymentConfigHistory?: Resolver<Array<ResolversTypes['BankruptcyCh13PrePetitionPaymentConfig']>, ParentType, ContextType>;
  planPaymentsDue?: Resolver<Array<ResolversTypes['WorkoutPlanPaymentDue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankruptcyCh13PrePetitionArrearagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankruptcyCh13PrePetitionArrearages'] = ResolversParentTypes['BankruptcyCh13PrePetitionArrearages']> = {
  chargeIds?: Resolver<Array<ResolversTypes['FeeId']>, ParentType, ContextType>;
  paymentDueIds?: Resolver<Array<ResolversTypes['PaymentDueId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankruptcyCh13PrePetitionPaymentConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankruptcyCh13PrePetitionPaymentConfig'] = ResolversParentTypes['BankruptcyCh13PrePetitionPaymentConfig']> = {
  changeReason?: Resolver<Maybe<ResolversTypes['BankruptcyCh13PaymentConfigChangeReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  monthlyPaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  numberOfMonthsRemaining?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payer?: Resolver<ResolversTypes['BankruptcyPaymentPayer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankruptcyCh13WorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankruptcyCh13WorkoutPlan'] = ResolversParentTypes['BankruptcyCh13WorkoutPlan']> = {
  bankruptcyId?: Resolver<ResolversTypes['BankruptcyId'], ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  confirmationDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  initialContractualLPIDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  postPetitionSplitEffectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  prePetition?: Resolver<Maybe<ResolversTypes['BankruptcyCh13PrePetition']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BankruptcyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BankruptcyId'], any> {
  name: 'BankruptcyId';
}

export interface BankruptcyProofOfClaimIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BankruptcyProofOfClaimId'], any> {
  name: 'BankruptcyProofOfClaimId';
}

export type BannerMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerMessage'] = ResolversParentTypes['BannerMessage']> = {
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['BannerMessageId'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BannerMessageIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BannerMessageId'], any> {
  name: 'BannerMessageId';
}

export type BorrowerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Borrower'] = ResolversParentTypes['Borrower']> = {
  achAccounts?: Resolver<Array<ResolversTypes['BorrowerAchAccount']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['CompanyId'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailNotificationsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mailingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paperNotificationsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneNumbers?: Resolver<ResolversTypes['Phone'], ParentType, ContextType>;
  preferredContactTimes?: Resolver<Array<ResolversTypes['DayAndTimeRange']>, ParentType, ContextType>;
  repayAccounts?: Resolver<Array<ResolversTypes['RepayAccount']>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usioAccounts?: Resolver<Array<ResolversTypes['UsioAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerAchAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerAchAccount'] = ResolversParentTypes['BorrowerAchAccount']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedByCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['BorrowerAchAccountId'], ParentType, ContextType>;
  lastFour?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prenoteSubmittedAt?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BorrowerAchAccountIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BorrowerAchAccountId'], any> {
  name: 'BorrowerAchAccountId';
}

export interface BorrowerIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BorrowerId'], any> {
  name: 'BorrowerId';
}

export type BorrowerMessageViewsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerMessageViews'] = ResolversParentTypes['BorrowerMessageViews']> = {
  mailingAddressConfirmedAt?: Resolver<Maybe<ResolversTypes['GqlIsoDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerPayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerPayer'] = ResolversParentTypes['BorrowerPayer']> = {
  borrowerId?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerPaymentSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerPaymentSettings'] = ResolversParentTypes['BorrowerPaymentSettings']> = {
  allowPaymentsPastMaturity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BorrowerRequestSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BorrowerRequestSettings'] = ResolversParentTypes['BorrowerRequestSettings']> = {
  drawRequestEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  escrowWaiverRequestEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  generalInquiryEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentAssistanceInquiryEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payoffRequestEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pmiCancellationRequestEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  verificationOfMortgageEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuilderAuthorizedContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuilderAuthorizedContact'] = ResolversParentTypes['BuilderAuthorizedContact']> = {
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['AuthorizedContactId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthorizedContactType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Charge'] = ResolversParentTypes['Charge']> = {
  __resolveType: TypeResolveFn<'Advance' | 'Fee', ParentType, ContextType>;
};

export type ChargeWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeWorkoutPlan'] = ResolversParentTypes['ChargeWorkoutPlan']> = {
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatBotResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatBotResponse'] = ResolversParentTypes['ChatBotResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ColumnEnumMappingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ColumnEnumMappingId'], any> {
  name: 'ColumnEnumMappingId';
}

export interface ColumnMappingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ColumnMappingId'], any> {
  name: 'ColumnMappingId';
}

export interface CompanyAchAccountIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CompanyAchAccountId'], any> {
  name: 'CompanyAchAccountId';
}

export interface CompanyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CompanyId'], any> {
  name: 'CompanyId';
}

export interface CompanyInterestOnEscrowSettingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CompanyInterestOnEscrowSettingId'], any> {
  name: 'CompanyInterestOnEscrowSettingId';
}

export type CompanyLogosResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyLogos'] = ResolversParentTypes['CompanyLogos']> = {
  emailLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portalLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyWireSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyWireSettings'] = ResolversParentTypes['CompanyWireSettings']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankRoutingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['CompanyWireSettingsId'], ParentType, ContextType>;
  instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ownerIds?: Resolver<Array<ResolversTypes['LoanOwnerId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CompanyWireSettingsIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CompanyWireSettingsId'], any> {
  name: 'CompanyWireSettingsId';
}

export type ConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Configuration'] = ResolversParentTypes['Configuration']> = {
  acquisitionDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  amortizationType?: Resolver<ResolversTypes['AmortizationType'], ParentType, ContextType>;
  annualInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  armConfiguration?: Resolver<Maybe<ResolversTypes['ArmConfiguration']>, ParentType, ContextType>;
  balloonConfiguration?: Resolver<Maybe<ResolversTypes['BalloonConfiguration']>, ParentType, ContextType>;
  brokerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buydownType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completionCertFlag?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  completionCertNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  constructionLoanType?: Resolver<Maybe<ResolversTypes['ConstructionLoanType']>, ParentType, ContextType>;
  delinquentInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  delinquentInterestRemittanceSplit?: Resolver<Maybe<ResolversTypes['InvestorRemittanceSplit']>, ParentType, ContextType>;
  drawsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['LoanFees']>, ParentType, ContextType>;
  firstCollectedPaymentDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  firstDueDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  fundingChannel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundingDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  gracePeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasInterestReserve?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  incomingTransferEffectiveDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  initialDiscountPointsAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  initialMaturityDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  interestOnlyConfiguration?: Resolver<Maybe<ResolversTypes['InterestOnlyConfiguration']>, ParentType, ContextType>;
  interestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  investor?: Resolver<Maybe<ResolversTypes['LoanInvestor']>, ParentType, ContextType>;
  investorOrgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAssumable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isBalloon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDrawableLoanType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDutch?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInterestOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legalDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lienPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  loanClosingDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  loanTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxLineOfCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  noteDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  numberOfProperties?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  occupancyType?: Resolver<Maybe<ResolversTypes['OccupancyType']>, ParentType, ContextType>;
  originalAmortizationType?: Resolver<ResolversTypes['AmortizationType'], ParentType, ContextType>;
  originalNoteHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentFrequency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ppc1OrgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previousLoanOwner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previousServicer?: Resolver<Maybe<ResolversTypes['PreviousServicer']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['ProductType']>, ParentType, ContextType>;
  purpose?: Resolver<Maybe<ResolversTypes['LoanPurpose']>, ParentType, ContextType>;
  qualifiedMortgage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  servicerOrgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subServicerOrgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxDetails?: Resolver<Maybe<ResolversTypes['TaxDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConstructionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConstructionConfig'] = ResolversParentTypes['ConstructionConfig']> = {
  constructionModificationEffectiveDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  constructionToPermanentStatus?: Resolver<ResolversTypes['ConstructionToPermanentStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentPaymentConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentPaymentConfig'] = ResolversParentTypes['CurrentPaymentConfig']> = {
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  monthlyEscrowPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  monthlyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  monthlyPrincipalAndInterestTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CustodialAccountBalanceIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustodialAccountBalanceId'], any> {
  name: 'CustodialAccountBalanceId';
}

export interface CustodialAccountIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustodialAccountId'], any> {
  name: 'CustodialAccountId';
}

export interface CustomCompanyFieldIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustomCompanyFieldId'], any> {
  name: 'CustomCompanyFieldId';
}

export type CustomFaqItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomFAQItem'] = ResolversParentTypes['CustomFAQItem']> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['CustomFAQItemId'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CustomFaqItemIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustomFAQItemId'], any> {
  name: 'CustomFAQItemId';
}

export type CustomFaqSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomFAQSection'] = ResolversParentTypes['CustomFAQSection']> = {
  id?: Resolver<ResolversTypes['CustomFAQSectionId'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CustomFAQItem']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CustomFaqSectionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustomFAQSectionId'], any> {
  name: 'CustomFAQSectionId';
}

export interface CustomTemplateIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CustomTemplateId'], any> {
  name: 'CustomTemplateId';
}

export type DayAndTimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DayAndTimeRange'] = ResolversParentTypes['DayAndTimeRange']> = {
  endDay?: Resolver<ResolversTypes['Weekday'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startDay?: Resolver<ResolversTypes['Weekday'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['Timezone'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefermentWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefermentWorkoutPlan'] = ResolversParentTypes['DefermentWorkoutPlan']> = {
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  chargeIds?: Resolver<Array<ResolversTypes['FeeId']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  escrowAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  feeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hasEscrow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasFees?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPrincipalAndInterest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  interestAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDueIds?: Resolver<Array<ResolversTypes['PaymentDueId']>, ParentType, ContextType>;
  principalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['WorkoutPlanReason']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefermentWorkoutPlanDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefermentWorkoutPlanDocument'] = ResolversParentTypes['DefermentWorkoutPlanDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  workoutPlanId?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DelinquentInterestAppliedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DelinquentInterestAppliedDocument'] = ResolversParentTypes['DelinquentInterestAppliedDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  delinquentInterestSettingId?: Resolver<Maybe<ResolversTypes['DelinquentInterestSettingId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentConfigId?: Resolver<Maybe<ResolversTypes['PaymentConfigId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DelinquentInterestAttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DelinquentInterestAttribution'] = ResolversParentTypes['DelinquentInterestAttribution']> = {
  dailyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  delinquentInterestSettingId?: Resolver<Maybe<ResolversTypes['DelinquentInterestSettingId']>, ParentType, ContextType>;
  endOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  periodInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  startOfPeriodPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttributionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DelinquentInterestSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DelinquentInterestSetting'] = ResolversParentTypes['DelinquentInterestSetting']> = {
  createdAt?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DelinquentInterestSettingId'], ParentType, ContextType>;
  interestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  investorRemittanceSplit?: Resolver<Maybe<ResolversTypes['InvestorRemittanceSplit']>, ParentType, ContextType>;
  isDeferred?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWaived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DelinquentInterestSettingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DelinquentInterestSettingId'], any> {
  name: 'DelinquentInterestSettingId';
}

export type DirectoryPayeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectoryPayee'] = ResolversParentTypes['DirectoryPayee']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['CompanyId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  dueDates?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  externalPayeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PayeeId'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loanUsageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  miCompanyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payeeType?: Resolver<ResolversTypes['PayeeType'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['PayeePaymentMethod'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxOption?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taxType?: Resolver<Maybe<ResolversTypes['PayeeTaxType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisbursementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Disbursement'] = ResolversParentTypes['Disbursement']> = {
  amounts?: Resolver<ResolversTypes['DisbursementAmounts'], ParentType, ContextType>;
  borrowerId?: Resolver<Maybe<ResolversTypes['BorrowerId']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  escrowDueId?: Resolver<Maybe<ResolversTypes['EscrowDueId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DisbursementId'], ParentType, ContextType>;
  isReversal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loanId?: Resolver<ResolversTypes['LoanId'], ParentType, ContextType>;
  payeeId?: Resolver<Maybe<ResolversTypes['PayeeId']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['PayeePaymentMethod']>, ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DisbursementStatus'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DisbursementType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisbursementAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisbursementAmounts'] = ResolversParentTypes['DisbursementAmounts']> = {
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  futureStatementSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  holdback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lossDraft?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principalPrepayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reserve?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DisbursementIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DisbursementId'], any> {
  name: 'DisbursementId';
}

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  __resolveType: TypeResolveFn<'DefermentWorkoutPlanDocument' | 'DelinquentInterestAppliedDocument' | 'EscrowAnalysisDocument' | 'Form1098Document' | 'GeneralDocument' | 'PayoffDocument' | 'PrincipalModificationAppliedDocument' | 'PrincipalModificationCancelledDocument' | 'UploadDocument' | 'VerificationOfMortgageDocument', ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export interface DocumentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DocumentId'], any> {
  name: 'DocumentId';
}

export type DownloadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadUrlResponse'] = ResolversParentTypes['DownloadUrlResponse']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DrawIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DrawId'], any> {
  name: 'DrawId';
}

export type DrawInterestAttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DrawInterestAttribution'] = ResolversParentTypes['DrawInterestAttribution']> = {
  dailyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  drawId?: Resolver<ResolversTypes['DrawId'], ParentType, ContextType>;
  endOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  periodInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  startOfPeriodPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttributionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DwollaAutopaySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DwollaAutopaySettings'] = ResolversParentTypes['DwollaAutopaySettings']> = {
  actor?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  bankUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portalUserId?: Resolver<ResolversTypes['PortalUserId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AutopaySettingsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DwollaBankResolvers<ContextType = any, ParentType extends ResolversParentTypes['DwollaBank'] = ResolversParentTypes['DwollaBank']> = {
  isAutopayAuthorized?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  links?: Resolver<ResolversTypes['DwollaUrls'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DwollaPaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DwollaPaymentResponse'] = ResolversParentTypes['DwollaPaymentResponse']> = {
  transferUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DwollaUrlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DwollaUrls'] = ResolversParentTypes['DwollaUrls']> = {
  self?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Entity'] = ResolversParentTypes['Entity']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  ein?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalEntityId?: Resolver<ResolversTypes['ExternalEntityId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EntityId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EntityIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EntityId'], any> {
  name: 'EntityId';
}

export type EntityPayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityPayer'] = ResolversParentTypes['EntityPayer']> = {
  entityId?: Resolver<ResolversTypes['EntityId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EscrowAdvanceConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscrowAdvanceConfig'] = ResolversParentTypes['EscrowAdvanceConfig']> = {
  advanceType?: Resolver<ResolversTypes['AdvanceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EscrowAnalysisDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscrowAnalysisDocument'] = ResolversParentTypes['EscrowAnalysisDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCorrected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EscrowCompanyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EscrowCompanyId'], any> {
  name: 'EscrowCompanyId';
}

export type EscrowDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscrowDue'] = ResolversParentTypes['EscrowDue']> = {
  __resolveType: TypeResolveFn<'InsuranceEscrowDue' | 'MortgageInsuranceEscrowDue' | 'TaxEscrowDue', ParentType, ContextType>;
  amountPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  escrowSettingId?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowDueId'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowType'], ParentType, ContextType>;
};

export interface EscrowDueIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EscrowDueId'], any> {
  name: 'EscrowDueId';
}

export type EscrowPaymentHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscrowPaymentHistoryItem'] = ResolversParentTypes['EscrowPaymentHistoryItem']> = {
  actorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowPaymentHistoryItemId'], ParentType, ContextType>;
  isCancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  newMonthlyAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  newMonthlyAmountIfShortagePaidUpfront?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shortageAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowPaymentHistoryItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EscrowPaymentHistoryItemIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EscrowPaymentHistoryItemId'], any> {
  name: 'EscrowPaymentHistoryItemId';
}

export type EscrowSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['EscrowSetting'] = ResolversParentTypes['EscrowSetting']> = {
  __resolveType: TypeResolveFn<'InsuranceEscrowSetting' | 'MortgageInsuranceEscrowSetting' | 'TaxEscrowSetting', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  payee?: Resolver<ResolversTypes['Payee'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowSettingType'], ParentType, ContextType>;
};

export interface EscrowSettingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EscrowSettingId'], any> {
  name: 'EscrowSettingId';
}

export type ExpectedPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpectedPayment'] = ResolversParentTypes['ExpectedPayment']> = {
  nextPaymentDueDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  totalAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalAmountRemainingFromCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalFutureAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalUpcomingAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ExternalEntityIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ExternalEntityId'], any> {
  name: 'ExternalEntityId';
}

export type FeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fee'] = ResolversParentTypes['Fee']> = {
  amountRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chargeDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['FeeId'], ParentType, ContextType>;
  investorRemittanceSplit?: Resolver<Maybe<ResolversTypes['InvestorRemittanceSplit']>, ParentType, ContextType>;
  isDeferred?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrePetition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['FeeLineItem']>, ParentType, ContextType>;
  paymentDueId?: Resolver<Maybe<ResolversTypes['PaymentDueId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FeeStatus'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ChargeType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeBreakdown'] = ResolversParentTypes['FeeBreakdown']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  feeId?: Resolver<ResolversTypes['FeeId'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface FeeIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FeeId'], any> {
  name: 'FeeId';
}

export type FeeLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeLineItem'] = ResolversParentTypes['FeeLineItem']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['FeeLineItemId'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['PaymentId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface FeeLineItemIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FeeLineItemId'], any> {
  name: 'FeeLineItemId';
}

export interface FileImportIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FileImportId'], any> {
  name: 'FileImportId';
}

export type FlexModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexModification'] = ResolversParentTypes['FlexModification']> = {
  deferredPrincipalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PrincipalModificationId'], ParentType, ContextType>;
  interestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  loanTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ModificationStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ModificationType'], ParentType, ContextType>;
  unpaidPrincipalBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  workoutPlanId?: Resolver<Maybe<ResolversTypes['WorkoutPlanId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexModificationModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexModificationModification'] = ResolversParentTypes['FlexModificationModification']> = {
  deferredPrincipalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  loanTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unpaidPrincipalBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlexModificationWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexModificationWorkoutPlan'] = ResolversParentTypes['FlexModificationWorkoutPlan']> = {
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  evaluationNoticeSentDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  modification?: Resolver<ResolversTypes['FlexModificationModification'], ParentType, ContextType>;
  planPaymentsDue?: Resolver<Array<ResolversTypes['WorkoutPlanPaymentDue']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['WorkoutPlanReason']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  trialTermMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  workflowInformation?: Resolver<Maybe<ResolversTypes['WorkoutPlanWorkflowInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForbearanceWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForbearanceWorkoutPlan'] = ResolversParentTypes['ForbearanceWorkoutPlan']> = {
  cancellationReason?: Resolver<Maybe<ResolversTypes['ForbearanceCancellationReason']>, ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  extensions?: Resolver<Array<ResolversTypes['ForbearanceWorkoutPlanExtension']>, ParentType, ContextType>;
  forbearanceType?: Resolver<ResolversTypes['ForbearanceType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  originalTermMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  partialPaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  planPaymentsDue?: Resolver<Array<ResolversTypes['WorkoutPlanPaymentDue']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  subType?: Resolver<ResolversTypes['ForbearanceSubType'], ParentType, ContextType>;
  terminationDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  workflowInformation?: Resolver<Maybe<ResolversTypes['WorkoutPlanWorkflowInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForbearanceWorkoutPlanExtensionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForbearanceWorkoutPlanExtension'] = ResolversParentTypes['ForbearanceWorkoutPlanExtension']> = {
  extensionDate?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  extensionTermMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ForeclosureIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ForeclosureId'], any> {
  name: 'ForeclosureId';
}

export type Form1098DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Form1098Document'] = ResolversParentTypes['Form1098Document']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCorrected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneralDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralDocument'] = ResolversParentTypes['GeneralDocument']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetS3PresignedUploadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetS3PresignedUploadUrlResponse'] = ResolversParentTypes['GetS3PresignedUploadUrlResponse']> = {
  destination?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  presignedUploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GqlDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlDate'], any> {
  name: 'GqlDate';
}

export interface GqlIsoDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlIsoDate'], any> {
  name: 'GqlIsoDate';
}

export interface GqlIsoDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlIsoDateTime'], any> {
  name: 'GqlIsoDateTime';
}

export interface GqlTemporalInstantScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlTemporalInstant'], any> {
  name: 'GqlTemporalInstant';
}

export interface GqlTemporalPlainTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlTemporalPlainTime'], any> {
  name: 'GqlTemporalPlainTime';
}

export interface GqlTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GqlTimestamp'], any> {
  name: 'GqlTimestamp';
}

export interface HistoricalTransactionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HistoricalTransactionId'], any> {
  name: 'HistoricalTransactionId';
}

export interface InspectionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['InspectionId'], any> {
  name: 'InspectionId';
}

export type InsuranceEscrowDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['InsuranceEscrowDue'] = ResolversParentTypes['InsuranceEscrowDue']> = {
  amountPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  escrowSettingId?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowDueId'], ParentType, ContextType>;
  insuranceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insuranceType?: Resolver<Maybe<ResolversTypes['EscrowInsuranceType']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InsuranceEscrowSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['InsuranceEscrowSetting'] = ResolversParentTypes['InsuranceEscrowSetting']> = {
  agentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  coverageAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  forcedPlacedFlag?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  insuranceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  insuranceType?: Resolver<Maybe<ResolversTypes['EscrowInsuranceType']>, ParentType, ContextType>;
  payee?: Resolver<ResolversTypes['Payee'], ParentType, ContextType>;
  policyEndDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  policyNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  policyStartDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowSettingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestOnlyConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestOnlyConfiguration'] = ResolversParentTypes['InterestOnlyConfiguration']> = {
  loanTerm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['InterestOnlyType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestRateChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestRateChange'] = ResolversParentTypes['InterestRateChange']> = {
  effectiveDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  monthlyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface InvestorIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['InvestorId'], any> {
  name: 'InvestorId';
}

export type InvestorRemittanceSplitResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorRemittanceSplit'] = ResolversParentTypes['InvestorRemittanceSplit']> = {
  investor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  servicer?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  splitEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface InvestorReportingIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['InvestorReportingId'], any> {
  name: 'InvestorReportingId';
}

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LegacyEscrowPayeeSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyEscrowPayeeSnapshot'] = ResolversParentTypes['LegacyEscrowPayeeSnapshot']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LiquidationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LiquidationId'], any> {
  name: 'LiquidationId';
}

export type LoanBillSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanBillSettings'] = ResolversParentTypes['LoanBillSettings']> = {
  startDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanBillSettingsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanChatMessage'] = ResolversParentTypes['LoanChatMessage']> = {
  id?: Resolver<ResolversTypes['LoanChatMessageId'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['LoanChatSender'], ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LoanChatMessageIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LoanChatMessageId'], any> {
  name: 'LoanChatMessageId';
}

export type LoanChatMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanChatMessages'] = ResolversParentTypes['LoanChatMessages']> = {
  records?: Resolver<Array<ResolversTypes['LoanChatMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanChatSenderResolvers = EnumResolverSignature<{ BORROWER?: any, BOT?: any, LENDER?: any }, ResolversTypes['LoanChatSender']>;

export type LoanDetailsSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanDetailsSettings'] = ResolversParentTypes['LoanDetailsSettings']> = {
  loanOfficer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  manageMailingAddress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanFees'] = ResolversParentTypes['LoanFees']> = {
  lateFee?: Resolver<Maybe<ResolversTypes['LoanLateFee']>, ParentType, ContextType>;
  prepaymentPenalty?: Resolver<Maybe<ResolversTypes['LoanPrepaymentPenaltyFee']>, ParentType, ContextType>;
  principalLateFee?: Resolver<Maybe<ResolversTypes['LoanPrincipalLateFee']>, ParentType, ContextType>;
  terminationFee?: Resolver<Maybe<ResolversTypes['LoanTerminationFee']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LoanIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LoanId'], any> {
  name: 'LoanId';
}

export type LoanInvestorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanInvestor'] = ResolversParentTypes['LoanInvestor']> = {
  documentCustodian?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fhaAdpCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fhaCaseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  investorLoanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  investorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mers?: Resolver<Maybe<ResolversTypes['MERS']>, ParentType, ContextType>;
  noteholder?: Resolver<Maybe<ResolversTypes['Noteholder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanInvestorRemittanceSplitResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanInvestorRemittanceSplit'] = ResolversParentTypes['LoanInvestorRemittanceSplit']> = {
  guaranteeFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  investor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  investor2?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  investor2Ownership?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  investorOwnership?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  servicer?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  soldDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  splitEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanLateFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanLateFee'] = ResolversParentTypes['LoanLateFee']> = {
  __resolveType: TypeResolveFn<'LoanLateFeeFixed' | 'LoanLateFeePercent', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanLateFeeType'], ParentType, ContextType>;
};

export type LoanLateFeeFixedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanLateFeeFixed'] = ResolversParentTypes['LoanLateFeeFixed']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanLateFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanLateFeePercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanLateFeePercent'] = ResolversParentTypes['LoanLateFeePercent']> = {
  decimalCharge?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanLateFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LoanNoteIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LoanNoteId'], any> {
  name: 'LoanNoteId';
}

export interface LoanOwnerIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LoanOwnerId'], any> {
  name: 'LoanOwnerId';
}

export type LoanPrepaymentPenaltyFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanPrepaymentPenaltyFee'] = ResolversParentTypes['LoanPrepaymentPenaltyFee']> = {
  expirationMonths?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  planDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<Maybe<ResolversTypes['LoanPrepaymentPenaltyFeePlanType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanPrincipalLateFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanPrincipalLateFee'] = ResolversParentTypes['LoanPrincipalLateFee']> = {
  __resolveType: TypeResolveFn<'LoanPrincipalLateFeeDisabled' | 'LoanPrincipalLateFeeFixed' | 'LoanPrincipalLateFeePercent', ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanPrincipalLateFeeType'], ParentType, ContextType>;
};

export type LoanPrincipalLateFeeDisabledResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanPrincipalLateFeeDisabled'] = ResolversParentTypes['LoanPrincipalLateFeeDisabled']> = {
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanPrincipalLateFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanPrincipalLateFeeFixedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanPrincipalLateFeeFixed'] = ResolversParentTypes['LoanPrincipalLateFeeFixed']> = {
  fixedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fixedDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  perProperty?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanPrincipalLateFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanPrincipalLateFeePercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanPrincipalLateFeePercent'] = ResolversParentTypes['LoanPrincipalLateFeePercent']> = {
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  percentDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  percentPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanPrincipalLateFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanTerminationFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanTerminationFee'] = ResolversParentTypes['LoanTerminationFee']> = {
  __resolveType: TypeResolveFn<'LoanTerminationFeeDisabled' | 'LoanTerminationFeeFixed' | 'LoanTerminationFeePercent', ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanTerminationFeeType'], ParentType, ContextType>;
};

export type LoanTerminationFeeDisabledResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanTerminationFeeDisabled'] = ResolversParentTypes['LoanTerminationFeeDisabled']> = {
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanTerminationFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanTerminationFeeFixedResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanTerminationFeeFixed'] = ResolversParentTypes['LoanTerminationFeeFixed']> = {
  fixedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fixedMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  perProperty?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanTerminationFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoanTerminationFeePercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanTerminationFeePercent'] = ResolversParentTypes['LoanTerminationFeePercent']> = {
  flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  percentMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  percentPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LoanTerminationFeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LosIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LosId'], any> {
  name: 'LosId';
}

export type MersResolvers<ContextType = any, ParentType extends ResolversParentTypes['MERS'] = ResolversParentTypes['MERS']> = {
  MIN?: Resolver<Maybe<ResolversTypes['MERSMIN']>, ParentType, ContextType>;
  MINStatus?: Resolver<Maybe<ResolversTypes['MERSMINStatus']>, ParentType, ContextType>;
  momFlag?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['MERSOrgId']>, ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MersminScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MERSMIN'], any> {
  name: 'MERSMIN';
}

export interface MersOrgIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MERSOrgId'], any> {
  name: 'MERSOrgId';
}

export type MaturityConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['MaturityConfig'] = ResolversParentTypes['MaturityConfig']> = {
  history?: Resolver<Array<ResolversTypes['MaturityHistoryItem']>, ParentType, ContextType>;
  isMaturing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maturityDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MaturityHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MaturityHistoryItem'] = ResolversParentTypes['MaturityHistoryItem']> = {
  createdAt?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  maturityDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Modification'] = ResolversParentTypes['Modification']> = {
  __resolveType: TypeResolveFn<'FlexModification' | 'PrincipalModification', ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PrincipalModificationId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ModificationStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ModificationType'], ParentType, ContextType>;
};

export type MortgageInsuranceEscrowDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['MortgageInsuranceEscrowDue'] = ResolversParentTypes['MortgageInsuranceEscrowDue']> = {
  amountPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  escrowSettingId?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowDueId'], ParentType, ContextType>;
  isCancellable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MortgageInsuranceEscrowSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MortgageInsuranceEscrowSetting'] = ResolversParentTypes['MortgageInsuranceEscrowSetting']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  associatedDisbursementCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cancellationDiscontinuanceCode?: Resolver<Maybe<ResolversTypes['MortgageInsuranceDiscontinuanceCode']>, ParentType, ContextType>;
  cancellationEffectiveDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  cancellationEligibilityReasons?: Resolver<Array<ResolversTypes['MortgageInsuranceCancellationEligibilityReason']>, ParentType, ContextType>;
  certificateId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coveragePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fhaProgramType?: Resolver<Maybe<ResolversTypes['FHAProgramType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  isEligibleForCancellation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFinanced?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRefundable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  midpointDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  mortgageInsuranceType?: Resolver<ResolversTypes['MortgageInsuranceType'], ParentType, ContextType>;
  payee?: Resolver<ResolversTypes['Payee'], ParentType, ContextType>;
  paymentCadence?: Resolver<ResolversTypes['PaymentCadence'], ParentType, ContextType>;
  poolCertificateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  renewalType?: Resolver<ResolversTypes['MortgageInsuranceRenewalType'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowSettingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptTerms?: Resolver<ResolversTypes['PortalUser'], ParentType, ContextType, RequireFields<MutationAcceptTermsArgs, 'tosVersion'>>;
  cancelPayment?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationCancelPaymentArgs, 'companyId' | 'loanId' | 'paymentId'>>;
  confirmMessageView?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationConfirmMessageViewArgs, 'companyId' | 'loanId' | 'messageKey'>>;
  createPortalBorrowerAchAccount?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationCreatePortalBorrowerAchAccountArgs, 'companyId' | 'input' | 'loanId'>>;
  createRepayAccount?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationCreateRepayAccountArgs, 'companyId' | 'input' | 'loanId'>>;
  deletePortalBorrowerAchAccount?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationDeletePortalBorrowerAchAccountArgs, 'accountId' | 'companyId' | 'loanId'>>;
  deleteRepayAccount?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationDeleteRepayAccountArgs, 'accountId' | 'companyId' | 'loanId'>>;
  drawRequest?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationDrawRequestArgs, 'amount' | 'companyId' | 'date' | 'loanId' | 'message'>>;
  editBorrowerDetails?: Resolver<ResolversTypes['Borrower'], ParentType, ContextType, RequireFields<MutationEditBorrowerDetailsArgs, 'companyId' | 'input' | 'loanId'>>;
  escrowWaiverRequest?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationEscrowWaiverRequestArgs, 'companyId' | 'loanId' | 'waivedItems'>>;
  generalInquiry?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationGeneralInquiryArgs, 'companyId' | 'loanId' | 'message'>>;
  getDocumentUrl?: Resolver<ResolversTypes['DownloadUrlResponse'], ParentType, ContextType, RequireFields<MutationGetDocumentUrlArgs, 'documentId' | 'loanId'>>;
  getPdfStatementUrl?: Resolver<ResolversTypes['DownloadUrlResponse'], ParentType, ContextType, RequireFields<MutationGetPdfStatementUrlArgs, 'loanId' | 'paymentDueId' | 'version'>>;
  getS3PresignedUrlDocumentUpload?: Resolver<ResolversTypes['GetS3PresignedUploadUrlResponse'], ParentType, ContextType, RequireFields<MutationGetS3PresignedUrlDocumentUploadArgs, 'companyId' | 'fileExtension' | 'fileName' | 'fileSizeInBytes' | 'fileType' | 'loanId'>>;
  initiateNachaPayment?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationInitiateNachaPaymentArgs, 'amount' | 'borrowerAchAccountId' | 'companyId' | 'loanId'>>;
  initiatePayment?: Resolver<ResolversTypes['DwollaPaymentResponse'], ParentType, ContextType, RequireFields<MutationInitiatePaymentArgs, 'amount' | 'companyId' | 'fromBankUrl' | 'loanId'>>;
  initiateRepayPayment?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationInitiateRepayPaymentArgs, 'amount' | 'companyId' | 'loanId' | 'repayAccountId'>>;
  logout?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType>;
  paymentAssistanceInquiry?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationPaymentAssistanceInquiryArgs, 'companyId' | 'loanId' | 'message' | 'quotedPastDueTotal'>>;
  pmiCancellationRequest?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationPmiCancellationRequestArgs, 'companyId' | 'loanId' | 'propertyValueType'>>;
  postPlaidBankToDwolla?: Resolver<ResolversTypes['PortalUser'], ParentType, ContextType, RequireFields<MutationPostPlaidBankToDwollaArgs, 'accountId' | 'accountNickname' | 'publicToken'>>;
  queryChatBot?: Resolver<Maybe<ResolversTypes['ChatBotResponse']>, ParentType, ContextType, RequireFields<MutationQueryChatBotArgs, 'loanId' | 'message'>>;
  removeBank?: Resolver<ResolversTypes['PortalUserActionResponse'], ParentType, ContextType, RequireFields<MutationRemoveBankArgs, 'bankUrl'>>;
  removePlaidToken?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType>;
  requestPayoffStatement?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationRequestPayoffStatementArgs, 'additionalBorrowers' | 'loanId' | 'payoffDate' | 'propertyIds'>>;
  saveBorrowerDocumentUpload?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationSaveBorrowerDocumentUploadArgs, 'loanId' | 'title' | 'url'>>;
  saveMicroDepositToken?: Resolver<ResolversTypes['AccessTokenResponse'], ParentType, ContextType, RequireFields<MutationSaveMicroDepositTokenArgs, 'accountId' | 'publicToken'>>;
  sendChatMessage?: Resolver<ResolversTypes['LoanChatMessage'], ParentType, ContextType, RequireFields<MutationSendChatMessageArgs, 'loanId' | 'message'>>;
  updateAutopaySettingsForLoan?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationUpdateAutopaySettingsForLoanArgs, 'loanId'>>;
  updateNachaAutopaySettingsForLoan?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationUpdateNachaAutopaySettingsForLoanArgs, 'loanId'>>;
  updateNotificationSettings?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationUpdateNotificationSettingsArgs, 'input' | 'loanId'>>;
  updateNotificationSettingsForAllCompanies?: Resolver<ResolversTypes['SuccessResponse'], ParentType, ContextType, RequireFields<MutationUpdateNotificationSettingsForAllCompaniesArgs, 'input'>>;
  updateRepayAutopaySettingsForLoan?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationUpdateRepayAutopaySettingsForLoanArgs, 'loanId'>>;
  verificationOfMortgageRequest?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<MutationVerificationOfMortgageRequestArgs, 'companyId' | 'input' | 'loanId'>>;
};

export type NachaAutopaySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NachaAutopaySettings'] = ResolversParentTypes['NachaAutopaySettings']> = {
  accountId?: Resolver<ResolversTypes['BorrowerAchAccountId'], ParentType, ContextType>;
  actor?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  borrowerId?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  dayOfTheMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AutopaySettingsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface NonPerformanceCodeForReportingCycleIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['NonPerformanceCodeForReportingCycleId'], any> {
  name: 'NonPerformanceCodeForReportingCycleId';
}

export type OriginationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OriginationData'] = ResolversParentTypes['OriginationData']> = {
  fundedAtClosing?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  loanOfficerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loanOfficerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loanProcessorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loanProcessorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PageSizeIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PageSizeInt'], any> {
  name: 'PageSizeInt';
}

export type PaidOffRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaidOffRecord'] = ResolversParentTypes['PaidOffRecord']> = {
  __resolveType: TypeResolveFn<'TrackedPaidOffRecord' | 'UntrackedPaidOffRecord', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  payoffDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  payoffType?: Resolver<ResolversTypes['PaidOffType'], ParentType, ContextType>;
};

export type PartialPayoffInterestAttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PartialPayoffInterestAttribution'] = ResolversParentTypes['PartialPayoffInterestAttribution']> = {
  dailyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  payoffId?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  periodInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  startOfPeriodPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttributionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payee'] = ResolversParentTypes['Payee']> = {
  __resolveType: TypeResolveFn<'DirectoryPayee' | 'LegacyEscrowPayeeSnapshot', ParentType, ContextType>;
};

export interface PayeeIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PayeeId'], any> {
  name: 'PayeeId';
}

export type PayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payer'] = ResolversParentTypes['Payer']> = {
  __resolveType: TypeResolveFn<'AuthorizedContactPayer' | 'BorrowerPayer' | 'EntityPayer' | 'ThirdPartyPayer', ParentType, ContextType>;
};

export type PaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']> = {
  additionalEscrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  additionalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  additionalSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  canCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canInitiateClawBack?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  clawBackStatus?: Resolver<Maybe<ResolversTypes['PaymentStatus']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  failureDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSweep?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  holdback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  isAutopayment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isInterestOnEscrowDeposit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lossDraft?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  originatingAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payer?: Resolver<ResolversTypes['Payer'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  payoffId?: Resolver<Maybe<ResolversTypes['PayoffId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentStatus'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PaymentBreakdownIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PaymentBreakdownId'], any> {
  name: 'PaymentBreakdownId';
}

export interface PaymentConfigIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PaymentConfigId'], any> {
  name: 'PaymentConfigId';
}

export type PaymentDeferralQuotedDeferredBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDeferralQuotedDeferredBalances'] = ResolversParentTypes['PaymentDeferralQuotedDeferredBalances']> = {
  charges?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  escrowAdvances?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDeferralWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDeferralWorkoutPlan'] = ResolversParentTypes['PaymentDeferralWorkoutPlan']> = {
  acceptanceMethod?: Resolver<ResolversTypes['PaymentDeferralAcceptanceMethod'], ParentType, ContextType>;
  acceptanceMethodOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  acceptedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDateTime']>, ParentType, ContextType>;
  archivedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  cancellationReason?: Resolver<Maybe<ResolversTypes['PaymentDeferralCancellationReason']>, ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  chargeIds?: Resolver<Array<ResolversTypes['FeeId']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  endStatementDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  escrowAnalysisId?: Resolver<Maybe<ResolversTypes['QcDocumentId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  offeredDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  paymentDeferralReason?: Resolver<ResolversTypes['PaymentDeferralReason'], ParentType, ContextType>;
  quotedDeferredBalances?: Resolver<ResolversTypes['PaymentDeferralQuotedDeferredBalances'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  startStatementDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  totalDeferredBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDue'] = ResolversParentTypes['PaymentDue']> = {
  attribution?: Resolver<Array<ResolversTypes['Attribution']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  escrowShortage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PaymentDueId'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reserveCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  statementDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  statements?: Resolver<Array<ResolversTypes['Statement']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentDueSnapshot'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PaymentDueIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PaymentDueId'], any> {
  name: 'PaymentDueId';
}

export type PaymentDueSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDueSnapshot'] = ResolversParentTypes['PaymentDueSnapshot']> = {
  amountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amountRemainingFromCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  billingStatus?: Resolver<ResolversTypes['BillingStatus'], ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrePetition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalAmountRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  wasCapitalized?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  workoutPlanType?: Resolver<Maybe<ResolversTypes['WorkoutPlanType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDueSubStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentDueSubStatus'] = ResolversParentTypes['PaymentDueSubStatus']> = {
  isPastDue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentFail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PaymentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PaymentId'], any> {
  name: 'PaymentId';
}

export type PaymentSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentSnapshot'] = ResolversParentTypes['PaymentSnapshot']> = {
  balances?: Resolver<ResolversTypes['Balances'], ParentType, ContextType>;
  outstandingBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPaid?: Resolver<ResolversTypes['TotalPaid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentToPaymentDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentToPaymentDue'] = ResolversParentTypes['PaymentToPaymentDue']> = {
  __resolveType: TypeResolveFn<'AdvanceBreakdown' | 'BalanceReallocationBreakdown' | 'FeeBreakdown' | 'PayoffBreakdown' | 'PrincipalPrepaymentBreakdown' | 'StatementBreakdown' | 'SuspenseBreakdown' | 'ThirdPartyBreakdown', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
};

export type PayoffResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payoff'] = ResolversParentTypes['Payoff']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  expirationDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Fee']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  isPartial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  processedRecord?: Resolver<Maybe<ResolversTypes['PayoffRecord']>, ParentType, ContextType>;
  propertyIds?: Resolver<Array<ResolversTypes['PropertyId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PayoffStatus'], ParentType, ContextType>;
  totalDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoffBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoffBreakdown'] = ResolversParentTypes['PayoffBreakdown']> = {
  additionalEscrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  additionalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  futureStatementSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  payoffId?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reserve?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoffDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoffDocument'] = ResolversParentTypes['PayoffDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExpired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPartial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  payoffAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PayoffIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PayoffId'], any> {
  name: 'PayoffId';
}

export type PayoffRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoffRecord'] = ResolversParentTypes['PayoffRecord']> = {
  amountPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['GqlIsoDateTime']>, ParentType, ContextType>;
  escrowBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Fee']>, ParentType, ContextType>;
  processedDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  totalDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  waivedAmounts?: Resolver<ResolversTypes['PayoffWaiver'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoffWaiverResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoffWaiver'] = ResolversParentTypes['PayoffWaiver']> = {
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Phone'] = ResolversParentTypes['Phone']> = {
  cell?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  other?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PoolIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PoolId'], any> {
  name: 'PoolId';
}

export type PortalCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalCompany'] = ResolversParentTypes['PortalCompany']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  adminSettings?: Resolver<ResolversTypes['PortalCompanyAdminSettings'], ParentType, ContextType>;
  customFAQ?: Resolver<Array<ResolversTypes['CustomFAQSection']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['CompanyId'], ParentType, ContextType>;
  logos?: Resolver<ResolversTypes['CompanyLogos'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentsPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  portalSettings?: Resolver<ResolversTypes['PortalSettings'], ParentType, ContextType>;
  supportEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supportHours?: Resolver<Maybe<ResolversTypes['SupportHours']>, ParentType, ContextType>;
  supportPhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalCompanyAdminSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalCompanyAdminSettings'] = ResolversParentTypes['PortalCompanyAdminSettings']> = {
  applicationsEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  applicationsEnabledSettings?: Resolver<Maybe<ResolversTypes['PortalCompanyAdminSettingsApplications']>, ParentType, ContextType>;
  autopayEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  econsentEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exactPaymentsOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  manualNachaFileGeneration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  portalBalanceForward?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  repayEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  whedaEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalCompanyAdminSettingsApplicationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalCompanyAdminSettingsApplications'] = ResolversParentTypes['PortalCompanyAdminSettingsApplications']> = {
  ladderLife?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalLoanResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalLoan'] = ResolversParentTypes['PortalLoan']> = {
  achAccounts?: Resolver<Array<ResolversTypes['BorrowerAchAccount']>, ParentType, ContextType>;
  additionalBorrowers?: Resolver<Array<ResolversTypes['Borrower']>, ParentType, ContextType>;
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  authorizedContacts?: Resolver<Array<ResolversTypes['AuthorizedContact']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['PortalCompany'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['Configuration'], ParentType, ContextType>;
  currentSnapshot?: Resolver<ResolversTypes['PortalLoanSnapshot'], ParentType, ContextType>;
  entity?: Resolver<Maybe<ResolversTypes['Entity']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['LoanId'], ParentType, ContextType>;
  losId?: Resolver<ResolversTypes['LosId'], ParentType, ContextType>;
  messageViews?: Resolver<Maybe<ResolversTypes['BorrowerMessageViews']>, ParentType, ContextType>;
  originalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  primaryBorrower?: Resolver<ResolversTypes['Borrower'], ParentType, ContextType>;
  repayAccounts?: Resolver<Array<ResolversTypes['RepayAccount']>, ParentType, ContextType>;
  wireSettings?: Resolver<Maybe<ResolversTypes['CompanyWireSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalLoanSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalLoanSnapshot'] = ResolversParentTypes['PortalLoanSnapshot']> = {
  activeWorkoutPlan?: Resolver<Maybe<ResolversTypes['WorkoutPlan']>, ParentType, ContextType>;
  amortizationMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  autopaySettings?: Resolver<Maybe<ResolversTypes['AutopaySettings']>, ParentType, ContextType>;
  chargeAmountDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  charges?: Resolver<Array<ResolversTypes['Charge']>, ParentType, ContextType>;
  creditRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currentBillSettingsType?: Resolver<ResolversTypes['LoanBillSettingsType'], ParentType, ContextType>;
  currentPaymentConfig?: Resolver<ResolversTypes['CurrentPaymentConfig'], ParentType, ContextType>;
  delinquentInterestSettings?: Resolver<Array<ResolversTypes['DelinquentInterestSetting']>, ParentType, ContextType>;
  disbursements?: Resolver<Array<ResolversTypes['Disbursement']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType>;
  drawsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  escrowShortageAnalysisId?: Resolver<Maybe<ResolversTypes['EscrowPaymentHistoryItemId']>, ParentType, ContextType>;
  expectedPayoffTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hasMortgageInsurance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasOpenDrawRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  interestRateChangeHistory?: Resolver<Array<ResolversTypes['InterestRateChange']>, ParentType, ContextType>;
  isDrawable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForAutomatedPayoff?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFullInterestOnlyLoan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loanId?: Resolver<ResolversTypes['LoanId'], ParentType, ContextType>;
  loanStatus?: Resolver<ResolversTypes['LoanStatus'], ParentType, ContextType>;
  maturityConfig?: Resolver<ResolversTypes['MaturityConfig'], ParentType, ContextType>;
  maxLineOfCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nextPaymentDueDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  nextStatementDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  offeredWorkoutPlans?: Resolver<Array<ResolversTypes['WorkoutPlan']>, ParentType, ContextType>;
  openPayoffStatus?: Resolver<Maybe<ResolversTypes['OpenPayoffStatus']>, ParentType, ContextType>;
  originationData?: Resolver<Maybe<ResolversTypes['OriginationData']>, ParentType, ContextType>;
  paymentDueStatus?: Resolver<ResolversTypes['PaymentDueStatus'], ParentType, ContextType>;
  paymentDueSubStatus?: Resolver<ResolversTypes['PaymentDueSubStatus'], ParentType, ContextType>;
  paymentToPaymentDue?: Resolver<Array<ResolversTypes['PaymentToPaymentDue']>, ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['Payment']>, ParentType, ContextType>;
  paymentsDue?: Resolver<Array<ResolversTypes['PaymentDue']>, ParentType, ContextType>;
  payoffs?: Resolver<Array<ResolversTypes['Payoff']>, ParentType, ContextType>;
  properties?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType>;
  shortageAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  snapshot?: Resolver<ResolversTypes['PaymentSnapshot'], ParentType, ContextType>;
  spreadMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stopSettings?: Resolver<ResolversTypes['StopSettings'], ParentType, ContextType>;
  totalAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalAmountRemainingFromCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalFutureAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPastDueAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalStatementAmountDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalUpcomingAmountRemainingFromBorrower?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalWorkoutPlanAmountRemainingFromBorrower?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactionActivities?: Resolver<Array<ResolversTypes['TransactionActivity']>, ParentType, ContextType>;
  transferData?: Resolver<Maybe<ResolversTypes['TransferData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalSettings'] = ResolversParentTypes['PortalSettings']> = {
  borrowerPayments?: Resolver<ResolversTypes['BorrowerPaymentSettings'], ParentType, ContextType>;
  borrowerRequests?: Resolver<ResolversTypes['BorrowerRequestSettings'], ParentType, ContextType>;
  emailGreeting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loanDetails?: Resolver<ResolversTypes['LoanDetailsSettings'], ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalSettingsStatementPdfResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalSettingsStatementPdf'] = ResolversParentTypes['PortalSettingsStatementPdf']> = {
  footer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalUser'] = ResolversParentTypes['PortalUser']> = {
  acceptedTerms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  banks?: Resolver<Array<ResolversTypes['DwollaBank']>, ParentType, ContextType>;
  bannerMessages?: Resolver<Array<ResolversTypes['BannerMessage']>, ParentType, ContextType>;
  borrowerId?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  dwollaBorrowerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PortalUserId'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loan?: Resolver<ResolversTypes['PortalLoan'], ParentType, ContextType, RequireFields<PortalUserLoanArgs, 'loanId'>>;
  loans?: Resolver<Array<ResolversTypes['PortalLoan']>, ParentType, ContextType>;
  microDepositVerification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumbers?: Resolver<ResolversTypes['Phone'], ParentType, ContextType>;
  requiredTosVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalUserActionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalUserActionResponse'] = ResolversParentTypes['PortalUserActionResponse']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portalUser?: Resolver<ResolversTypes['PortalUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PortalUserIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PortalUserId'], any> {
  name: 'PortalUserId';
}

export type PreviousServicerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviousServicer'] = ResolversParentTypes['PreviousServicer']> = {
  lenderEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lenderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lenderPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  purchasedEscrowBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  purchasedReserveBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrincipalModificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrincipalModification'] = ResolversParentTypes['PrincipalModification']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  collectionType?: Resolver<ResolversTypes['PrincipalModificationCollectionType'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PrincipalModificationId'], ParentType, ContextType>;
  isFederalGovernmentPlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecast?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ModificationStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ModificationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrincipalModificationAppliedDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrincipalModificationAppliedDocument'] = ResolversParentTypes['PrincipalModificationAppliedDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  principalModificationId?: Resolver<ResolversTypes['PrincipalModificationId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrincipalModificationCancelledDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrincipalModificationCancelledDocument'] = ResolversParentTypes['PrincipalModificationCancelledDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  principalModificationId?: Resolver<ResolversTypes['PrincipalModificationId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PrincipalModificationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PrincipalModificationId'], any> {
  name: 'PrincipalModificationId';
}

export type PrincipalPrepaymentBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrincipalPrepaymentBreakdown'] = ResolversParentTypes['PrincipalPrepaymentBreakdown']> = {
  additionalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  reserve?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Property'] = ResolversParentTypes['Property']> = {
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  isReleased?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PropertyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PropertyId'], any> {
  name: 'PropertyId';
}

export interface QcDocumentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['QcDocumentId'], any> {
  name: 'QcDocumentId';
}

export interface QrpcIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['QrpcId'], any> {
  name: 'QrpcId';
}

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getChatMessage?: Resolver<ResolversTypes['LoanChatMessage'], ParentType, ContextType, RequireFields<QueryGetChatMessageArgs, 'loanId' | 'messageId'>>;
  getChatMessages?: Resolver<ResolversTypes['LoanChatMessages'], ParentType, ContextType, RequireFields<QueryGetChatMessagesArgs, 'loanId'>>;
  portalSelf?: Resolver<ResolversTypes['PortalUser'], ParentType, ContextType, Partial<QueryPortalSelfArgs>>;
};

export type RepayAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepayAccount'] = ResolversParentTypes['RepayAccount']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedByCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['RepayAccountId'], ParentType, ContextType>;
  lastFour?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface RepayAccountIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['RepayAccountId'], any> {
  name: 'RepayAccountId';
}

export type RepayAutopaySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepayAutopaySettings'] = ResolversParentTypes['RepayAutopaySettings']> = {
  accountId?: Resolver<ResolversTypes['RepayAccountId'], ParentType, ContextType>;
  actor?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  borrowerId?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  dayOfTheMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AutopaySettingsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RepaymentArrearagesBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepaymentArrearagesBreakdown'] = ResolversParentTypes['RepaymentArrearagesBreakdown']> = {
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  feesAndAdvances?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  monthlyPaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  statementSuspenseCredit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RepaymentWorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepaymentWorkoutPlan'] = ResolversParentTypes['RepaymentWorkoutPlan']> = {
  arrearageBreakdown?: Resolver<ResolversTypes['RepaymentArrearagesBreakdown'], ParentType, ContextType>;
  cancellationReason?: Resolver<Maybe<ResolversTypes['RepaymentPlanCancellationReason']>, ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  chargeIds?: Resolver<Array<ResolversTypes['FeeId']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  contractualMonthlyPaymentAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  dAmountPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  endStatementDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  hasFees?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  planIncreaseDecimal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  planPaymentsDue?: Resolver<Array<ResolversTypes['WorkoutPlanPaymentDue']>, ParentType, ContextType>;
  repaymentMonthlyAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  startStatementDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  termMonths?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  terminationDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  workflowInformation?: Resolver<Maybe<ResolversTypes['WorkoutPlanWorkflowInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ReportableEventIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ReportableEventId'], any> {
  name: 'ReportableEventId';
}

export interface SftpKeyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SftpKeyId'], any> {
  name: 'SftpKeyId';
}

export interface SftpSiteIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SftpSiteId'], any> {
  name: 'SftpSiteId';
}

export type StandardAdvanceConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandardAdvanceConfig'] = ResolversParentTypes['StandardAdvanceConfig']> = {
  advanceCategory?: Resolver<Maybe<ResolversTypes['AdvanceCategory']>, ParentType, ContextType>;
  advanceCategoryDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advanceType?: Resolver<ResolversTypes['AdvanceType'], ParentType, ContextType>;
  interestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandardInterestAttributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandardInterestAttribution'] = ResolversParentTypes['StandardInterestAttribution']> = {
  dailyInterestRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeferred?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  periodInterestRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startOfPeriod?: Resolver<Maybe<ResolversTypes['GqlTimestamp']>, ParentType, ContextType>;
  startOfPeriodPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttributionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Statement'] = ResolversParentTypes['Statement']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatementBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatementBreakdown'] = ResolversParentTypes['StatementBreakdown']> = {
  additionalEscrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  additionalPrincipal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  futureStatementSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentDueId?: Resolver<ResolversTypes['PaymentDueId'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reserve?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StopSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StopSettings'] = ResolversParentTypes['StopSettings']> = {
  advancesPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  advancesPausedUntilDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  documentAccessPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  drawsPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emailsPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  miCancellationReviewReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  miCancellationReviewRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  miDisbursementsPaused?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  omitFromDelinquentInterestAutomation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  omitFromInterestOnEscrow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  omitFromLateFeeAutomation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  omitFromPayoffAutomation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  portalPayments?: Resolver<ResolversTypes['PortalPaymentStopSettingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuccessResponse'] = ResolversParentTypes['SuccessResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuccessResponseWithFailureReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuccessResponseWithFailureReason'] = ResolversParentTypes['SuccessResponseWithFailureReason']> = {
  failureReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportHoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportHours'] = ResolversParentTypes['SupportHours']> = {
  line1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuspenseBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuspenseBreakdown'] = ResolversParentTypes['SuspenseBreakdown']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  futureStatementSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TaskAuditLogIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TaskAuditLogId'], any> {
  name: 'TaskAuditLogId';
}

export type TaxDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxDetails'] = ResolversParentTypes['TaxDetails']> = {
  backupWithholdingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  backupWithholdingRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  taxExempt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxEscrowDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxEscrowDue'] = ResolversParentTypes['TaxEscrowDue']> = {
  amountPaid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['GqlDate']>, ParentType, ContextType>;
  escrowSettingId?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  estimatedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowDueId'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  taxType?: Resolver<ResolversTypes['TaxEscrowType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxEscrowSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxEscrowSetting'] = ResolversParentTypes['TaxEscrowSetting']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  apn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dueDates?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  escrowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EscrowSettingId'], ParentType, ContextType>;
  payee?: Resolver<ResolversTypes['Payee'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['PropertyId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EscrowSettingStatus'], ParentType, ContextType>;
  taxType?: Resolver<ResolversTypes['TaxEscrowType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EscrowSettingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThirdPartyAuthorizedContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThirdPartyAuthorizedContact'] = ResolversParentTypes['ThirdPartyAuthorizedContact']> = {
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['AuthorizedContactId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuthorizedContactType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThirdPartyBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThirdPartyBreakdown'] = ResolversParentTypes['ThirdPartyBreakdown']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['PaymentBreakdownEvent'], ParentType, ContextType>;
  expectedPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  holdback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  lossDraft?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['PaymentId'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentToPaymentDueType'], ParentType, ContextType>;
  unappliedSuspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  voidedBreakdownId?: Resolver<Maybe<ResolversTypes['PaymentBreakdownId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThirdPartyPayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThirdPartyPayer'] = ResolversParentTypes['ThirdPartyPayer']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimezoneResolvers = EnumResolverSignature<{ America__Chicago?: any, America__Denver?: any, America__Los_Angeles?: any, America__New_York?: any }, ResolversTypes['Timezone']>;

export type TotalPaidResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalPaid'] = ResolversParentTypes['TotalPaid']> = {
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrackedPaidOffRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackedPaidOffRecord'] = ResolversParentTypes['TrackedPaidOffRecord']> = {
  id?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  payoffDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  payoffRecord?: Resolver<ResolversTypes['PayoffRecord'], ParentType, ContextType>;
  payoffType?: Resolver<ResolversTypes['PaidOffType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionActivity'] = ResolversParentTypes['TransactionActivity']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isFailed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferData'] = ResolversParentTypes['TransferData']> = {
  correspondenceAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  legalTransferEffectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  loanOfficerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loanOfficerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextServicerCollectsLatePayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  servicerHours1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  servicerHours2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  servicerHours3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  servicerLoanNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  servicerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  servicerWebsite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferEffectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UntrackedPaidOffRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['UntrackedPaidOffRecord'] = ResolversParentTypes['UntrackedPaidOffRecord']> = {
  id?: Resolver<ResolversTypes['PayoffId'], ParentType, ContextType>;
  payoffDate?: Resolver<ResolversTypes['GqlDate'], ParentType, ContextType>;
  payoffType?: Resolver<ResolversTypes['PaidOffType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadDocument'] = ResolversParentTypes['UploadDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UserIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UserId'], any> {
  name: 'UserId';
}

export type UsioAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsioAccount'] = ResolversParentTypes['UsioAccount']> = {
  confirmationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UsioAccountId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UsioAccountIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UsioAccountId'], any> {
  name: 'UsioAccountId';
}

export type UsioAutopaySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsioAutopaySettings'] = ResolversParentTypes['UsioAutopaySettings']> = {
  actor?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  borrowerId?: Resolver<ResolversTypes['BorrowerId'], ParentType, ContextType>;
  confirmationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dayOfTheMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AutopaySettingsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationOfMortgageDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationOfMortgageDocument'] = ResolversParentTypes['VerificationOfMortgageDocument']> = {
  createdAt?: Resolver<ResolversTypes['GqlTimestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DocumentType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeekdayResolvers = EnumResolverSignature<{ FRIDAY?: any, MONDAY?: any, SATURDAY?: any, SUNDAY?: any, THURSDAY?: any, TUESDAY?: any, WEDNESDAY?: any }, ResolversTypes['Weekday']>;

export type WorkoutPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkoutPlan'] = ResolversParentTypes['WorkoutPlan']> = {
  __resolveType: TypeResolveFn<'BankruptcyCh13WorkoutPlan' | 'DefermentWorkoutPlan' | 'FlexModificationWorkoutPlan' | 'ForbearanceWorkoutPlan' | 'PaymentDeferralWorkoutPlan' | 'RepaymentWorkoutPlan', ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  completedDate?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WorkoutPlanId'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['WorkoutPlanStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['GqlIsoDateTime'], ParentType, ContextType>;
};

export interface WorkoutPlanIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['WorkoutPlanId'], any> {
  name: 'WorkoutPlanId';
}

export type WorkoutPlanIneligibleModificationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkoutPlanIneligibleModifications'] = ResolversParentTypes['WorkoutPlanIneligibleModifications']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkoutPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkoutPlanPaymentDueResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkoutPlanPaymentDue'] = ResolversParentTypes['WorkoutPlanPaymentDue']> = {
  dStatus?: Resolver<ResolversTypes['WorkoutPlanPaymentDueStatus'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkoutPlanPaymentDueStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkoutPlanPaymentDueStatus'] = ResolversParentTypes['WorkoutPlanPaymentDueStatus']> = {
  amountRemaining?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fulfilledAt?: Resolver<Maybe<ResolversTypes['GqlIsoDate']>, ParentType, ContextType>;
  isLate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentMadeIds?: Resolver<Array<ResolversTypes['PaymentId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkoutPlanWorkflowInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkoutPlanWorkflowInformation'] = ResolversParentTypes['WorkoutPlanWorkflowInformation']> = {
  completedBorrowerResponsePackageReceived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ineligibleModifications?: Resolver<Array<ResolversTypes['WorkoutPlanIneligibleModifications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WriteoffResolvers<ContextType = any, ParentType extends ResolversParentTypes['Writeoff'] = ResolversParentTypes['Writeoff']> = {
  amounts?: Resolver<ResolversTypes['WriteoffAmounts'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['GqlIsoDate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['WriteoffId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WriteoffAmountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WriteoffAmounts'] = ResolversParentTypes['WriteoffAmounts']> = {
  corporateAdvances?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  escrow?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interest?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  principal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  suspense?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface WriteoffIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['WriteoffId'], any> {
  name: 'WriteoffId';
}

export type Resolvers<ContextType = any> = {
  AccessTokenResponse?: AccessTokenResponseResolvers<ContextType>;
  AchBatchId?: GraphQLScalarType;
  AchBatchScheduleId?: GraphQLScalarType;
  AchBatchTransactionId?: GraphQLScalarType;
  Actor?: ActorResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  Advance?: AdvanceResolvers<ContextType>;
  AdvanceBreakdown?: AdvanceBreakdownResolvers<ContextType>;
  AdvanceConfig?: AdvanceConfigResolvers<ContextType>;
  ApiKeyId?: GraphQLScalarType;
  Appraisal?: AppraisalResolvers<ContextType>;
  AppraisalId?: GraphQLScalarType;
  ArmConfiguration?: ArmConfigurationResolvers<ContextType>;
  Attribution?: AttributionResolvers<ContextType>;
  AuditLogId?: GraphQLScalarType;
  AuthorizedContact?: AuthorizedContactResolvers<ContextType>;
  AuthorizedContactId?: GraphQLScalarType;
  AuthorizedContactPayer?: AuthorizedContactPayerResolvers<ContextType>;
  AutopaySettings?: AutopaySettingsResolvers<ContextType>;
  BalanceReallocationBreakdown?: BalanceReallocationBreakdownResolvers<ContextType>;
  Balances?: BalancesResolvers<ContextType>;
  BalloonConfiguration?: BalloonConfigurationResolvers<ContextType>;
  BankruptcyCh13PrePetition?: BankruptcyCh13PrePetitionResolvers<ContextType>;
  BankruptcyCh13PrePetitionArrearages?: BankruptcyCh13PrePetitionArrearagesResolvers<ContextType>;
  BankruptcyCh13PrePetitionPaymentConfig?: BankruptcyCh13PrePetitionPaymentConfigResolvers<ContextType>;
  BankruptcyCh13WorkoutPlan?: BankruptcyCh13WorkoutPlanResolvers<ContextType>;
  BankruptcyId?: GraphQLScalarType;
  BankruptcyProofOfClaimId?: GraphQLScalarType;
  BannerMessage?: BannerMessageResolvers<ContextType>;
  BannerMessageId?: GraphQLScalarType;
  Borrower?: BorrowerResolvers<ContextType>;
  BorrowerAchAccount?: BorrowerAchAccountResolvers<ContextType>;
  BorrowerAchAccountId?: GraphQLScalarType;
  BorrowerId?: GraphQLScalarType;
  BorrowerMessageViews?: BorrowerMessageViewsResolvers<ContextType>;
  BorrowerPayer?: BorrowerPayerResolvers<ContextType>;
  BorrowerPaymentSettings?: BorrowerPaymentSettingsResolvers<ContextType>;
  BorrowerRequestSettings?: BorrowerRequestSettingsResolvers<ContextType>;
  BuilderAuthorizedContact?: BuilderAuthorizedContactResolvers<ContextType>;
  Charge?: ChargeResolvers<ContextType>;
  ChargeWorkoutPlan?: ChargeWorkoutPlanResolvers<ContextType>;
  ChatBotResponse?: ChatBotResponseResolvers<ContextType>;
  ColumnEnumMappingId?: GraphQLScalarType;
  ColumnMappingId?: GraphQLScalarType;
  CompanyAchAccountId?: GraphQLScalarType;
  CompanyId?: GraphQLScalarType;
  CompanyInterestOnEscrowSettingId?: GraphQLScalarType;
  CompanyLogos?: CompanyLogosResolvers<ContextType>;
  CompanyWireSettings?: CompanyWireSettingsResolvers<ContextType>;
  CompanyWireSettingsId?: GraphQLScalarType;
  Configuration?: ConfigurationResolvers<ContextType>;
  ConstructionConfig?: ConstructionConfigResolvers<ContextType>;
  CurrentPaymentConfig?: CurrentPaymentConfigResolvers<ContextType>;
  CustodialAccountBalanceId?: GraphQLScalarType;
  CustodialAccountId?: GraphQLScalarType;
  CustomCompanyFieldId?: GraphQLScalarType;
  CustomFAQItem?: CustomFaqItemResolvers<ContextType>;
  CustomFAQItemId?: GraphQLScalarType;
  CustomFAQSection?: CustomFaqSectionResolvers<ContextType>;
  CustomFAQSectionId?: GraphQLScalarType;
  CustomTemplateId?: GraphQLScalarType;
  DayAndTimeRange?: DayAndTimeRangeResolvers<ContextType>;
  DefermentWorkoutPlan?: DefermentWorkoutPlanResolvers<ContextType>;
  DefermentWorkoutPlanDocument?: DefermentWorkoutPlanDocumentResolvers<ContextType>;
  DelinquentInterestAppliedDocument?: DelinquentInterestAppliedDocumentResolvers<ContextType>;
  DelinquentInterestAttribution?: DelinquentInterestAttributionResolvers<ContextType>;
  DelinquentInterestSetting?: DelinquentInterestSettingResolvers<ContextType>;
  DelinquentInterestSettingId?: GraphQLScalarType;
  DirectoryPayee?: DirectoryPayeeResolvers<ContextType>;
  Disbursement?: DisbursementResolvers<ContextType>;
  DisbursementAmounts?: DisbursementAmountsResolvers<ContextType>;
  DisbursementId?: GraphQLScalarType;
  Document?: DocumentResolvers<ContextType>;
  DocumentId?: GraphQLScalarType;
  DownloadUrlResponse?: DownloadUrlResponseResolvers<ContextType>;
  DrawId?: GraphQLScalarType;
  DrawInterestAttribution?: DrawInterestAttributionResolvers<ContextType>;
  DwollaAutopaySettings?: DwollaAutopaySettingsResolvers<ContextType>;
  DwollaBank?: DwollaBankResolvers<ContextType>;
  DwollaPaymentResponse?: DwollaPaymentResponseResolvers<ContextType>;
  DwollaUrls?: DwollaUrlsResolvers<ContextType>;
  Entity?: EntityResolvers<ContextType>;
  EntityId?: GraphQLScalarType;
  EntityPayer?: EntityPayerResolvers<ContextType>;
  EscrowAdvanceConfig?: EscrowAdvanceConfigResolvers<ContextType>;
  EscrowAnalysisDocument?: EscrowAnalysisDocumentResolvers<ContextType>;
  EscrowCompanyId?: GraphQLScalarType;
  EscrowDue?: EscrowDueResolvers<ContextType>;
  EscrowDueId?: GraphQLScalarType;
  EscrowPaymentHistoryItem?: EscrowPaymentHistoryItemResolvers<ContextType>;
  EscrowPaymentHistoryItemId?: GraphQLScalarType;
  EscrowSetting?: EscrowSettingResolvers<ContextType>;
  EscrowSettingId?: GraphQLScalarType;
  ExpectedPayment?: ExpectedPaymentResolvers<ContextType>;
  ExternalEntityId?: GraphQLScalarType;
  Fee?: FeeResolvers<ContextType>;
  FeeBreakdown?: FeeBreakdownResolvers<ContextType>;
  FeeId?: GraphQLScalarType;
  FeeLineItem?: FeeLineItemResolvers<ContextType>;
  FeeLineItemId?: GraphQLScalarType;
  FileImportId?: GraphQLScalarType;
  FlexModification?: FlexModificationResolvers<ContextType>;
  FlexModificationModification?: FlexModificationModificationResolvers<ContextType>;
  FlexModificationWorkoutPlan?: FlexModificationWorkoutPlanResolvers<ContextType>;
  ForbearanceWorkoutPlan?: ForbearanceWorkoutPlanResolvers<ContextType>;
  ForbearanceWorkoutPlanExtension?: ForbearanceWorkoutPlanExtensionResolvers<ContextType>;
  ForeclosureId?: GraphQLScalarType;
  Form1098Document?: Form1098DocumentResolvers<ContextType>;
  GeneralDocument?: GeneralDocumentResolvers<ContextType>;
  GetS3PresignedUploadUrlResponse?: GetS3PresignedUploadUrlResponseResolvers<ContextType>;
  GqlDate?: GraphQLScalarType;
  GqlIsoDate?: GraphQLScalarType;
  GqlIsoDateTime?: GraphQLScalarType;
  GqlTemporalInstant?: GraphQLScalarType;
  GqlTemporalPlainTime?: GraphQLScalarType;
  GqlTimestamp?: GraphQLScalarType;
  HistoricalTransactionId?: GraphQLScalarType;
  InspectionId?: GraphQLScalarType;
  InsuranceEscrowDue?: InsuranceEscrowDueResolvers<ContextType>;
  InsuranceEscrowSetting?: InsuranceEscrowSettingResolvers<ContextType>;
  InterestOnlyConfiguration?: InterestOnlyConfigurationResolvers<ContextType>;
  InterestRateChange?: InterestRateChangeResolvers<ContextType>;
  InvestorId?: GraphQLScalarType;
  InvestorRemittanceSplit?: InvestorRemittanceSplitResolvers<ContextType>;
  InvestorReportingId?: GraphQLScalarType;
  JSON?: GraphQLScalarType;
  LegacyEscrowPayeeSnapshot?: LegacyEscrowPayeeSnapshotResolvers<ContextType>;
  LiquidationId?: GraphQLScalarType;
  LoanBillSettings?: LoanBillSettingsResolvers<ContextType>;
  LoanChatMessage?: LoanChatMessageResolvers<ContextType>;
  LoanChatMessageId?: GraphQLScalarType;
  LoanChatMessages?: LoanChatMessagesResolvers<ContextType>;
  LoanChatSender?: LoanChatSenderResolvers;
  LoanDetailsSettings?: LoanDetailsSettingsResolvers<ContextType>;
  LoanFees?: LoanFeesResolvers<ContextType>;
  LoanId?: GraphQLScalarType;
  LoanInvestor?: LoanInvestorResolvers<ContextType>;
  LoanInvestorRemittanceSplit?: LoanInvestorRemittanceSplitResolvers<ContextType>;
  LoanLateFee?: LoanLateFeeResolvers<ContextType>;
  LoanLateFeeFixed?: LoanLateFeeFixedResolvers<ContextType>;
  LoanLateFeePercent?: LoanLateFeePercentResolvers<ContextType>;
  LoanNoteId?: GraphQLScalarType;
  LoanOwnerId?: GraphQLScalarType;
  LoanPrepaymentPenaltyFee?: LoanPrepaymentPenaltyFeeResolvers<ContextType>;
  LoanPrincipalLateFee?: LoanPrincipalLateFeeResolvers<ContextType>;
  LoanPrincipalLateFeeDisabled?: LoanPrincipalLateFeeDisabledResolvers<ContextType>;
  LoanPrincipalLateFeeFixed?: LoanPrincipalLateFeeFixedResolvers<ContextType>;
  LoanPrincipalLateFeePercent?: LoanPrincipalLateFeePercentResolvers<ContextType>;
  LoanTerminationFee?: LoanTerminationFeeResolvers<ContextType>;
  LoanTerminationFeeDisabled?: LoanTerminationFeeDisabledResolvers<ContextType>;
  LoanTerminationFeeFixed?: LoanTerminationFeeFixedResolvers<ContextType>;
  LoanTerminationFeePercent?: LoanTerminationFeePercentResolvers<ContextType>;
  LosId?: GraphQLScalarType;
  MERS?: MersResolvers<ContextType>;
  MERSMIN?: GraphQLScalarType;
  MERSOrgId?: GraphQLScalarType;
  MaturityConfig?: MaturityConfigResolvers<ContextType>;
  MaturityHistoryItem?: MaturityHistoryItemResolvers<ContextType>;
  Modification?: ModificationResolvers<ContextType>;
  MortgageInsuranceEscrowDue?: MortgageInsuranceEscrowDueResolvers<ContextType>;
  MortgageInsuranceEscrowSetting?: MortgageInsuranceEscrowSettingResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NachaAutopaySettings?: NachaAutopaySettingsResolvers<ContextType>;
  NonPerformanceCodeForReportingCycleId?: GraphQLScalarType;
  OriginationData?: OriginationDataResolvers<ContextType>;
  PageSizeInt?: GraphQLScalarType;
  PaidOffRecord?: PaidOffRecordResolvers<ContextType>;
  PartialPayoffInterestAttribution?: PartialPayoffInterestAttributionResolvers<ContextType>;
  Payee?: PayeeResolvers<ContextType>;
  PayeeId?: GraphQLScalarType;
  Payer?: PayerResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  PaymentBreakdownId?: GraphQLScalarType;
  PaymentConfigId?: GraphQLScalarType;
  PaymentDeferralQuotedDeferredBalances?: PaymentDeferralQuotedDeferredBalancesResolvers<ContextType>;
  PaymentDeferralWorkoutPlan?: PaymentDeferralWorkoutPlanResolvers<ContextType>;
  PaymentDue?: PaymentDueResolvers<ContextType>;
  PaymentDueId?: GraphQLScalarType;
  PaymentDueSnapshot?: PaymentDueSnapshotResolvers<ContextType>;
  PaymentDueSubStatus?: PaymentDueSubStatusResolvers<ContextType>;
  PaymentId?: GraphQLScalarType;
  PaymentSnapshot?: PaymentSnapshotResolvers<ContextType>;
  PaymentToPaymentDue?: PaymentToPaymentDueResolvers<ContextType>;
  Payoff?: PayoffResolvers<ContextType>;
  PayoffBreakdown?: PayoffBreakdownResolvers<ContextType>;
  PayoffDocument?: PayoffDocumentResolvers<ContextType>;
  PayoffId?: GraphQLScalarType;
  PayoffRecord?: PayoffRecordResolvers<ContextType>;
  PayoffWaiver?: PayoffWaiverResolvers<ContextType>;
  Phone?: PhoneResolvers<ContextType>;
  PoolId?: GraphQLScalarType;
  PortalCompany?: PortalCompanyResolvers<ContextType>;
  PortalCompanyAdminSettings?: PortalCompanyAdminSettingsResolvers<ContextType>;
  PortalCompanyAdminSettingsApplications?: PortalCompanyAdminSettingsApplicationsResolvers<ContextType>;
  PortalLoan?: PortalLoanResolvers<ContextType>;
  PortalLoanSnapshot?: PortalLoanSnapshotResolvers<ContextType>;
  PortalSettings?: PortalSettingsResolvers<ContextType>;
  PortalSettingsStatementPdf?: PortalSettingsStatementPdfResolvers<ContextType>;
  PortalUser?: PortalUserResolvers<ContextType>;
  PortalUserActionResponse?: PortalUserActionResponseResolvers<ContextType>;
  PortalUserId?: GraphQLScalarType;
  PreviousServicer?: PreviousServicerResolvers<ContextType>;
  PrincipalModification?: PrincipalModificationResolvers<ContextType>;
  PrincipalModificationAppliedDocument?: PrincipalModificationAppliedDocumentResolvers<ContextType>;
  PrincipalModificationCancelledDocument?: PrincipalModificationCancelledDocumentResolvers<ContextType>;
  PrincipalModificationId?: GraphQLScalarType;
  PrincipalPrepaymentBreakdown?: PrincipalPrepaymentBreakdownResolvers<ContextType>;
  Property?: PropertyResolvers<ContextType>;
  PropertyId?: GraphQLScalarType;
  QcDocumentId?: GraphQLScalarType;
  QrpcId?: GraphQLScalarType;
  Query?: QueryResolvers<ContextType>;
  RepayAccount?: RepayAccountResolvers<ContextType>;
  RepayAccountId?: GraphQLScalarType;
  RepayAutopaySettings?: RepayAutopaySettingsResolvers<ContextType>;
  RepaymentArrearagesBreakdown?: RepaymentArrearagesBreakdownResolvers<ContextType>;
  RepaymentWorkoutPlan?: RepaymentWorkoutPlanResolvers<ContextType>;
  ReportableEventId?: GraphQLScalarType;
  SftpKeyId?: GraphQLScalarType;
  SftpSiteId?: GraphQLScalarType;
  StandardAdvanceConfig?: StandardAdvanceConfigResolvers<ContextType>;
  StandardInterestAttribution?: StandardInterestAttributionResolvers<ContextType>;
  Statement?: StatementResolvers<ContextType>;
  StatementBreakdown?: StatementBreakdownResolvers<ContextType>;
  StopSettings?: StopSettingsResolvers<ContextType>;
  SuccessResponse?: SuccessResponseResolvers<ContextType>;
  SuccessResponseWithFailureReason?: SuccessResponseWithFailureReasonResolvers<ContextType>;
  SupportHours?: SupportHoursResolvers<ContextType>;
  SuspenseBreakdown?: SuspenseBreakdownResolvers<ContextType>;
  TaskAuditLogId?: GraphQLScalarType;
  TaxDetails?: TaxDetailsResolvers<ContextType>;
  TaxEscrowDue?: TaxEscrowDueResolvers<ContextType>;
  TaxEscrowSetting?: TaxEscrowSettingResolvers<ContextType>;
  ThirdPartyAuthorizedContact?: ThirdPartyAuthorizedContactResolvers<ContextType>;
  ThirdPartyBreakdown?: ThirdPartyBreakdownResolvers<ContextType>;
  ThirdPartyPayer?: ThirdPartyPayerResolvers<ContextType>;
  Timezone?: TimezoneResolvers;
  TotalPaid?: TotalPaidResolvers<ContextType>;
  TrackedPaidOffRecord?: TrackedPaidOffRecordResolvers<ContextType>;
  TransactionActivity?: TransactionActivityResolvers<ContextType>;
  TransferData?: TransferDataResolvers<ContextType>;
  UntrackedPaidOffRecord?: UntrackedPaidOffRecordResolvers<ContextType>;
  UploadDocument?: UploadDocumentResolvers<ContextType>;
  UserId?: GraphQLScalarType;
  UsioAccount?: UsioAccountResolvers<ContextType>;
  UsioAccountId?: GraphQLScalarType;
  UsioAutopaySettings?: UsioAutopaySettingsResolvers<ContextType>;
  VerificationOfMortgageDocument?: VerificationOfMortgageDocumentResolvers<ContextType>;
  Weekday?: WeekdayResolvers;
  WorkoutPlan?: WorkoutPlanResolvers<ContextType>;
  WorkoutPlanId?: GraphQLScalarType;
  WorkoutPlanIneligibleModifications?: WorkoutPlanIneligibleModificationsResolvers<ContextType>;
  WorkoutPlanPaymentDue?: WorkoutPlanPaymentDueResolvers<ContextType>;
  WorkoutPlanPaymentDueStatus?: WorkoutPlanPaymentDueStatusResolvers<ContextType>;
  WorkoutPlanWorkflowInformation?: WorkoutPlanWorkflowInformationResolvers<ContextType>;
  Writeoff?: WriteoffResolvers<ContextType>;
  WriteoffAmounts?: WriteoffAmountsResolvers<ContextType>;
  WriteoffId?: GraphQLScalarType;
};

export type DirectiveResolvers<ContextType = any> = {
  isAdminOrUserInLoan?: IsAdminOrUserInLoanDirectiveResolver<any, any, ContextType>;
  isUserInLoan?: IsUserInLoanDirectiveResolver<any, any, ContextType>;
};
